(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[562],{

/***/ 81245:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[userSlug]/[[...tab]]",
      function () {
        return __webpack_require__(77447);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 59837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18316);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94614);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var _govlaunch_palette__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(95576);
/* harmony import */ var _components_icons_BookmarkIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2409);







var BookmarkButton = function(_param) {
    var onClick = _param.onClick, bookmarked = _param.bookmarked, bookmarkedColor = _param.bookmarkedColor, bookmarkedStrokeColor = _param.bookmarkedStrokeColor, disabled = _param.disabled, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "onClick",
        "bookmarked",
        "bookmarkedColor",
        "bookmarkedStrokeColor",
        "disabled"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("button", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        type: "button",
        css: {
            border: 0,
            background: "none",
            padding: 4,
            display: "inline-flex",
            cursor: disabled ? "normal" : "pointer",
            outline: "none",
            color: "#fff",
            alignSelf: "center"
        },
        onClick: onClick
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_components_icons_BookmarkIcon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            fill: bookmarked ? bookmarkedColor || _govlaunch_palette__WEBPACK_IMPORTED_MODULE_6__/* .sealBlue */ .N9 : undefined,
            stroke: bookmarked ? bookmarkedStrokeColor : undefined
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (BookmarkButton);


/***/ }),

/***/ 2425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ GatedContent; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.9.0_g2nyo56cszy7jhpiictt6fwifm/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(82789);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+core@0.21.2_iyni55cf3gelv6eahxhjaprhn4/node_modules/@govlaunch/core/index.js + 20 modules
var core = __webpack_require__(98973);
// EXTERNAL MODULE: ./src/components/auth/SignInModal.tsx + 3 modules
var SignInModal = __webpack_require__(43316);
// EXTERNAL MODULE: ./components/auth/Auth.tsx + 1 modules
var Auth = __webpack_require__(27068);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(93712);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+palette@0.4.0/node_modules/@govlaunch/palette/index.js
var palette = __webpack_require__(95576);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.5_cejl76k2qxbp2ab75jaaojpzhe/node_modules/next/link.js
var next_link = __webpack_require__(54892);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_s7dhm7uhgnhsqh75wuilf3r4wi/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(90489);
// EXTERNAL MODULE: ./components/icons/ModalCloseIcon.tsx
var ModalCloseIcon = __webpack_require__(86140);
// EXTERNAL MODULE: ./components/spacings.tsx
var spacings = __webpack_require__(52126);
;// CONCATENATED MODULE: ./components/UserNotVerified.tsx










function UserNotVerified(param) {
    var isOpen = param.isOpen, onRequestClose = param.onRequestClose, overlayStyle = param.overlayStyle, style = param.style;
    var user = (0,Auth/* useSelfie */.yD)();
    var isCitizen = user && user.role === "CITIZEN";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(core/* Modal */.u_, {
        isOpen: isOpen,
        onRequestClose: onRequestClose,
        ariaHideApp: false,
        overlayStyle: overlayStyle,
        style: (0,_object_spread/* default */.Z)({
            background: "#fff",
            zIndex: 0,
            boxShadow: "0 30px 40px 0 rgba(34, 35, 40, 0.2)"
        }, style),
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Box */.xu, {
                width: [
                    360,
                    710
                ],
                children: onRequestClose && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                    role: "button",
                    "aria-label": "Close",
                    onClick: onRequestClose,
                    css: {
                        position: "absolute",
                        zIndex: 9999,
                        top: 0,
                        right: 0,
                        cursor: "pointer",
                        width: 45,
                        height: 45,
                        paddingTop: 20,
                        paddingRight: 20,
                        display: "flex",
                        justifyContent: "flex-end"
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ModalCloseIcon/* default */.Z, {})
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Box */.xu, {
                width: [
                    360,
                    710
                ],
                css: {
                    background: "#fff",
                    zIndex: 0,
                    boxShadow: "0 30px 40px 0 rgba(34, 35, 40, 0.2)",
                    borderRadius: 4
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: {
                        display: "flex",
                        flexDirection: "column",
                        padding: "64px 32px 120px 34px",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "contain",
                        backgroundPosition: "bottom right",
                        backgroundImage: 'url("/static/gating/verified-members-only.png")',
                        backgroundPositionX: 45
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                            mb: 24,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h1", {
                                css: {
                                    fontSize: 26,
                                    margin: 0
                                },
                                children: isCitizen ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "You don't have access to this content",
                                    id: "WANdbg"
                                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Oops! This content is only available to our verified community members.",
                                    id: "x3XSwA"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                            mb: 48,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                css: {
                                    margin: 0,
                                    maxWidth: 400
                                },
                                children: isCitizen ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "If you think this a mistake, please contact us at",
                                            id: "FrjQba"
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                            href: "mailto:hello@govlaunch.com",
                                            css: {
                                                color: palette/* innovatorBlue */.LD
                                            },
                                            children: "hello@govlaunch.com"
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Thank you for your interest in Govlaunch.",
                                    id: "tIv2yE"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                            mb: 12,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                href: "/",
                                passHref: true,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                    css: {
                                        fontSize: 18,
                                        color: palette/* innovatorBlue */.LD
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "Go to the homepage",
                                        id: "eyGrVk"
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                            href: "https://help.govlaunch.com/en/collections/2190109-what-is-govlaunch",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            css: {
                                margin: 0,
                                color: palette/* innovatorBlue */.LD,
                                fontSize: 14
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "Click here to learn more about us",
                                id: "6jw/cR"
                            })
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/GatedContent.tsx






function GatedContent(param) {
    var image = param.image, _isOpen = param.isOpen, isOpen = _isOpen === void 0 ? true : _isOpen, hardRefreshAfterSignin = param.hardRefreshAfterSignin, onSignIn = param.onSignIn, _onRequestClose = param.onRequestClose, onRequestClose = _onRequestClose === void 0 ? defaultOnRequestClose : _onRequestClose;
    var user = (0,Auth/* useSelfie */.yD)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* BlockBodyOverflow */.Bm, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                style: {
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    height: "calc(100vh - 30%)",
                    textAlign: "center",
                    marginTop: 85,
                    filter: "blur(6px)"
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                    alt: "gating image",
                    src: image,
                    css: {
                        maxWidth: "100%",
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                        objectPosition: "top"
                    }
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: {
                    width: "100%",
                    marginTop: 85,
                    display: "flex",
                    justifyContent: "center",
                    position: "relative"
                },
                children: [
                    user && !user.verified && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UserNotVerified, {
                        isOpen: isOpen,
                        onRequestClose: onRequestClose
                    }),
                    !user && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SignInModal/* SigninModal */.I, {
                        isOpen: isOpen,
                        hardRefreshAfterSignin: hardRefreshAfterSignin,
                        onSignIn: onSignIn,
                        onRequestClose: onRequestClose
                    })
                ]
            })
        ]
    });
};
function defaultOnRequestClose() {
    if (true) {
        return window.history.back();
    }
}


/***/ }),

/***/ 29142:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports Phone, Tablet, Mobile, Desktop */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18316);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82789);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59496);
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(30467);
/* harmony import */ var react_responsive__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_responsive__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _components_MobileDetectContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48582);






function getResponsiveSsrProps(param) {
    var isPhone = param.isPhone, isTablet = param.isTablet;
    if (isPhone) {
        return {
            values: {
                width: 375,
                deviceWidth: 375
            }
        };
    }
    if (isTablet) {
        return {
            values: {
                width: 720,
                deviceWidth: 720
            }
        };
    }
    return {
        values: {
            width: 1024,
            deviceWidth: 1024
        }
    };
}
var Phone = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_components_MobileDetectContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"].Consumer */ .Z.Consumer, {
        children: function(flags) {
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)((react_responsive__WEBPACK_IMPORTED_MODULE_3___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props, getResponsiveSsrProps(flags)), {
                maxWidth: 720
            }));
        }
    });
};
var Tablet = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_components_MobileDetectContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"].Consumer */ .Z.Consumer, {
        children: function(flags) {
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)((react_responsive__WEBPACK_IMPORTED_MODULE_3___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props, getResponsiveSsrProps(flags)), {
                minWidth: 720,
                maxWidth: 960
            }));
        }
    });
};
var Mobile = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_components_MobileDetectContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"].Consumer */ .Z.Consumer, {
        children: function(flags) {
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)((react_responsive__WEBPACK_IMPORTED_MODULE_3___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props, getResponsiveSsrProps(flags)), {
                maxWidth: 960
            }));
        }
    });
};
var Desktop = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_components_MobileDetectContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"].Consumer */ .Z.Consumer, {
        children: function(flags) {
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)((react_responsive__WEBPACK_IMPORTED_MODULE_3___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, props, getResponsiveSsrProps(flags)), {
                minWidth: 960
            }));
        }
    });
};
var Screen = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(Desktop, {
        children: function(isDesktop) {
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(Mobile, {
                children: function(isMobile) {
                    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(Tablet, {
                        children: function(isTablet) {
                            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(Phone, {
                                children: function(isPhone) {
                                    return children({
                                        isDesktop: isDesktop,
                                        isMobile: isMobile,
                                        isTablet: isTablet,
                                        isPhone: isPhone
                                    });
                                }
                            });
                        }
                    });
                }
            });
        }
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (Screen);
// eslint-disable-next-line



/***/ }),

/***/ 58707:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var governmentStates = {
    AL: "Alabama",
    AK: "Alaska",
    AZ: "Arizona",
    AR: "Arkansas",
    CA: "California",
    CO: "Colorado",
    CT: "Connecticut",
    DE: "Delaware",
    FL: "Florida",
    GA: "Georgia",
    HI: "Hawaii",
    ID: "Idaho",
    IL: "Illinois",
    IN: "Indiana",
    IA: "Iowa",
    KS: "Kansas",
    KY: "Kentucky",
    LA: "Louisiana",
    ME: "Maine",
    MD: "Maryland",
    MA: "Massachusetts",
    MI: "Michigan",
    MN: "Minnesota",
    MS: "Mississippi",
    MO: "Missouri",
    MT: "Montana",
    NE: "Nebraska",
    NV: "Nevada",
    NH: "New Hampshire",
    NJ: "New Jersey",
    NM: "New Mexico",
    NY: "New York",
    NC: "North Carolina",
    ND: "North Dakota",
    OH: "Ohio",
    OK: "Oklahoma",
    OR: "Oregon",
    PA: "Pennsylvania",
    RI: "Rhode Island",
    SC: "South Carolina",
    SD: "South Dakota",
    TN: "Tennessee",
    TX: "Texas",
    UT: "Utah",
    VT: "Vermont",
    VA: "Virginia",
    WA: "Washington",
    WV: "West Virginia",
    WI: "Wisconsin",
    WY: "Wyoming"
};
/* harmony default export */ __webpack_exports__["Z"] = (governmentStates);


/***/ }),

/***/ 77447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _tab_; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_type_of.mjs
var _type_of = __webpack_require__(75538);
// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+react@11.9.0_g2nyo56cszy7jhpiictt6fwifm/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(82789);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.9_mnlteiidv5se4zpyvopwg4rohq/node_modules/@apollo/client/react/components/Query.js
var Query = __webpack_require__(38085);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.5_cejl76k2qxbp2ab75jaaojpzhe/node_modules/next/router.js
var next_router = __webpack_require__(22051);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@17.0.2/node_modules/react/index.js
var react = __webpack_require__(59496);
// EXTERNAL MODULE: ./components/auth/Auth.tsx + 1 modules
var Auth = __webpack_require__(27068);
// EXTERNAL MODULE: ./components/GatedContent.tsx + 1 modules
var GatedContent = __webpack_require__(2425);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.5_cejl76k2qxbp2ab75jaaojpzhe/node_modules/next/head.js
var head = __webpack_require__(84217);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./components/seo/SeoHead.tsx
var SeoHead = __webpack_require__(35692);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_s7dhm7uhgnhsqh75wuilf3r4wi/node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(69057);
;// CONCATENATED MODULE: ./components/seo/UserPageSeo.tsx





function UserPageSeo(param) {
    var user = param.user, tab = param.tab;
    if (!user) {
        return null;
    }
    var formatTab = tab;
    if (tab === "connect") {
        formatTab = "profile";
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SeoHead/* default */.Z, {
                title: getUserFormattedTitle(formatTab, user),
                description: user.jobTitle || getUserFormattedTitle(formatTab, user)
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                        name: "twitter:site",
                        content: "@Govlaunch"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                        name: "twitter:image",
                        content: user.avatar || ""
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                        property: "og:image",
                        content: user.avatar || ""
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                        property: "og:title",
                        content: user.fullName || ""
                    })
                ]
            })
        ]
    });
};
function getUserFormattedTitle(tab, user) {
    var intl = (0,useIntl/* default */.Z)();
    if (!user) {
        return intl.formatMessage({
            defaultMessage: "Search the wiki for local government innovation.",
            id: "Pa6P7h"
        });
    }
    switch(tab){
        case "projects":
            return intl.formatMessage({
                defaultMessage: "{userName} – Govlaunch Projects",
                id: "HZpuLW"
            }, {
                userName: user.fullName || user.firstName
            });
        case "saved":
            return intl.formatMessage({
                defaultMessage: "{userName} – Govlaunch Saved",
                id: "Orhat7"
            }, {
                userName: user.fullName || user.firstName
            });
        case "settings":
            return intl.formatMessage({
                defaultMessage: "{userName} – Govlaunch Settings",
                id: "OJjoU2"
            }, {
                userName: user.fullName || user.firstName
            });
        case "sharing":
            return intl.formatMessage({
                defaultMessage: "{userName} – Govlaunch Sharing",
                id: "/q/nP9"
            }, {
                userName: user.fullName || user.firstName
            });
        default:
            return intl.formatMessage({
                defaultMessage: "{userName} – Govlaunch Profile",
                id: "teZTOp"
            }, {
                userName: user.fullName || user.firstName
            });
    }
}

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(49980);
// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.9_mnlteiidv5se4zpyvopwg4rohq/node_modules/@apollo/client/react/components/Mutation.js
var Mutation = __webpack_require__(82280);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+core@0.21.2_iyni55cf3gelv6eahxhjaprhn4/node_modules/@govlaunch/core/index.js + 20 modules
var core = __webpack_require__(98973);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+palette@0.4.0/node_modules/@govlaunch/palette/index.js
var palette = __webpack_require__(95576);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+profile-picture@1.4.1/node_modules/@govlaunch/profile-picture/index.js + 1 modules
var profile_picture = __webpack_require__(77876);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+web@2.32.25_cmry25ein5ld6qeazx5fxbvqjy/node_modules/@govlaunch/web/index.ts + 112 modules
var web = __webpack_require__(19026);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.5_cejl76k2qxbp2ab75jaaojpzhe/node_modules/next/link.js
var next_link = __webpack_require__(54892);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-intl@5.25.1_s7dhm7uhgnhsqh75wuilf3r4wi/node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(90489);
// EXTERNAL MODULE: ./lib/hooks/useIsMobile.ts
var useIsMobile = __webpack_require__(67459);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(17440);
// EXTERNAL MODULE: ./node_modules/.pnpm/graphql-tag@2.12.6_graphql@16.5.0/node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(18125);
;// CONCATENATED MODULE: ./lib/mutations/SetProfilePicture.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation SetProfilePicture($userId: ObjectId!, $picture: String!) {\n    setProfilePicture(userId: $userId, picture: $picture) {\n      ... on GovernmentUser {\n        _id\n        avatar\n      }\n      ... on VendorUser {\n        _id\n        avatar\n      }\n      ... on PendingUser {\n        _id\n        avatar\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var SetProfilePicture = ((0,lib/* gql */.Ps)(_templateObject()));

;// CONCATENATED MODULE: ./lib/mutations/SetUserResources.ts

function SetUserResources_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation SetUserResources($resources: [ResourceInput!]!) {\n    setUserResources(resources: $resources) {\n      ... on GovernmentUser {\n        _id\n        resources {\n          ... on LinkResource {\n            type\n            title\n            url\n            addedAt\n          }\n          ... on DownloadResource {\n            type\n            filename\n            title\n            url\n            addedAt\n          }\n          ... on TextResource {\n            type\n            title\n            body\n            addedAt\n          }\n        }\n      }\n    }\n  }\n"
    ]);
    SetUserResources_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var SetUserResources = ((0,lib/* gql */.Ps)(SetUserResources_templateObject()));

;// CONCATENATED MODULE: ./lib/queries/RecentlyJoinedGovernments.ts

function RecentlyJoinedGovernments_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query RecentlyJoinedGovernments {\n    recentlyJoinedGovernments {\n      _id\n      name\n      logo\n      slug\n      city {\n        _id\n        name\n        country\n        countryName\n      }\n    }\n  }\n"
    ]);
    RecentlyJoinedGovernments_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var RecentlyJoinedGovernments = ((0,lib/* gql */.Ps)(RecentlyJoinedGovernments_templateObject()));

// EXTERNAL MODULE: ./components/feed/WriteContentBox.tsx + 6 modules
var WriteContentBox = __webpack_require__(54436);
// EXTERNAL MODULE: ./components/HorizontalLine.tsx
var HorizontalLine = __webpack_require__(68231);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(93712);
// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(18316);
;// CONCATENATED MODULE: ./components/icons/InnovatiorsIcon.tsx




function InnovatorsIcon(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 15 15",
        width: 15,
        height: 15
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            d: "M5.772 3.96c.193-.45.552-.808 1.002-1.001.227-.097.468-.147.726-.147.258 0 .5.05.727.147.45.194.808.553 1.002 1.002.097.227.146.468.146.727 0 .257-.049.498-.146.725a1.88 1.88 0 0 1-.405.597c-.172.171-.374.31-.597.406-.23.098-.477.148-.727.147-.258 0-.499-.05-.726-.147a1.919 1.919 0 0 1-1.002-1.003 1.805 1.805 0 0 1-.147-.725c0-.259.049-.5.147-.727M5.986 15V9.8c0-.798.64-1.444 1.43-1.444h.19c.787 0 1.426.644 1.426 1.44v5.199c3.808-.798 6.558-4.512 5.86-8.73-.505-3.04-2.888-5.526-5.884-6.117C4.205-.796 0 2.894 0 7.578 0 11.239 2.57 14.293 5.986 15",
            fill: "#005AEE",
            fillRule: "nonzero"
        })
    }));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(94614);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-powerplug@1.0.0_react@17.0.2/node_modules/react-powerplug/dist/react-powerplug.esm.js
var react_powerplug_esm = __webpack_require__(41491);
;// CONCATENATED MODULE: ./components/profile/ChangeableProfilePicture.tsx










function ChangeableProfilePicture(_param) {
    var _image = _param.image, image = _image === void 0 ? null : _image, name = _param.name, onChange = _param.onChange, props = (0,_object_without_properties/* default */.Z)(_param, [
        "image",
        "name",
        "onChange"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Filestack */.QZ, {
        options: {
            transformations: {
                rotate: false,
                circle: false,
                crop: true
            }
        },
        onSuccess: function(result) {
            if (result.filesUploaded.length > 0) {
                onChange(result.filesUploaded[0].url);
            }
        },
        customRender: function(param) {
            var onPick = param.onPick;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_powerplug_esm/* Hover */.TM, {
                children: function(param) {
                    var hovered = param.hovered, bind = param.bind;
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, bind), {
                        css: {
                            position: "relative",
                            display: "flex",
                            zIndex: 2
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(profile_picture/* default */.Z, (0,_object_spread/* default */.Z)({
                                image: image,
                                name: name,
                                size: 100
                            }, props)),
                            hovered && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                css: {
                                    position: "absolute",
                                    width: "100%",
                                    height: "100%",
                                    borderRadius: "100%",
                                    background: "rgba(0, 0, 0, 0.6)",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    flexDirection: "column"
                                },
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                                        onClick: onPick,
                                        type: "button",
                                        css: {
                                            color: "#fff",
                                            border: 0,
                                            textTransform: "uppercase",
                                            letterSpacing: 0.5,
                                            fontSize: 14,
                                            fontWeight: 500,
                                            backgroundColor: "transparent",
                                            cursor: "pointer",
                                            outline: 0
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Change",
                                            id: "BY343C"
                                        })
                                    }),
                                    image && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
                                        type: "button",
                                        onClick: function() {
                                            return onChange("");
                                        },
                                        css: {
                                            color: palette/* orange */.$y,
                                            border: 0,
                                            textTransform: "uppercase",
                                            letterSpacing: 0.5,
                                            fontSize: 14,
                                            fontWeight: 500,
                                            marginTop: 10,
                                            backgroundColor: "transparent",
                                            cursor: "pointer",
                                            outline: 0
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Remove",
                                            id: "G/yZLu"
                                        })
                                    })
                                ]
                            })
                        ]
                    }));
                }
            });
        }
    });
};

// EXTERNAL MODULE: ./components/profile/NewLinkTab.tsx
var NewLinkTab = __webpack_require__(37897);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+popover@0.10.2_qlbrybfyutdb3nzvgq5n4v5xcq/node_modules/@govlaunch/popover/index.js + 59 modules
var popover = __webpack_require__(70271);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/fp.js
var fp = __webpack_require__(56365);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/fp/chunk.js
var chunk = __webpack_require__(74012);
var chunk_default = /*#__PURE__*/__webpack_require__.n(chunk);
// EXTERNAL MODULE: ./lib/hooks/useIsTablet.ts
var useIsTablet = __webpack_require__(2518);
// EXTERNAL MODULE: ./lib/hooks/useShowMoreCounter.ts
var useShowMoreCounter = __webpack_require__(87386);
// EXTERNAL MODULE: ./lib/mutations/ToggleFollow.tsx + 1 modules
var ToggleFollow = __webpack_require__(81177);
// EXTERNAL MODULE: ./components/DelayedHover.ts
var DelayedHover = __webpack_require__(94662);
;// CONCATENATED MODULE: ./components/profile/icons-and-shapes.tsx




var EmptyIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 1010 790",
        "data-name": "Layer 1",
        width: 1009.54,
        height: 789.93
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("defs", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                    id: "prefix__a",
                    x1: 318.22,
                    y1: 488.45,
                    x2: 630.35,
                    y2: 488.45,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                            offset: 0,
                            stopColor: "gray",
                            stopOpacity: 0.25
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                            offset: 0.54,
                            stopColor: "gray",
                            stopOpacity: 0.12
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                            offset: 1,
                            stopColor: "gray",
                            stopOpacity: 0.1
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("title", {
                children: "empty"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
                cx: 354.13,
                cy: 741.27,
                rx: 176.1,
                ry: 33.36,
                fill: "#4285f4",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M586.55 111.4c-64.72-2.24-126.36-23.14-185.22-46S284.17 17.22 221 5.11c-40.63-7.79-87.1-8.9-119.83 12.86-31.51 21-41.69 57.15-47.16 90.72-4.12 25.26-6.54 51.85 4.74 75.5 7.84 16.42 21.74 30.22 31.36 45.95 33.47 54.72 9.81 122.2-26.45 175.63-17 25.06-36.75 49-49.88 75.65s-19.2 57.29-7.71 84.55c11.38 27 38.51 47.24 67.9 61.49 59.69 28.95 130 37.23 198.61 41.93 151.83 10.38 304.46 5.89 456.69 1.38 56.34-1.66 112.92-3.35 168.34-12.06 30.78-4.84 62.55-12.52 84.9-31.06 28.36-23.53 35.39-63.37 16.38-92.87-31.88-49.5-120-61.79-142.31-114.9-12.26-29.24.33-61.8 18.16-88.91 38.24-58.17 102.33-109.2 105.7-175.68 2.32-45.66-28.49-91.39-76.13-113-49.93-22.65-119.18-19.8-156 17.69-37.95 38.56-104.61 53.41-161.76 51.42z",
                fill: "#4285f4",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M630.35 416.77l-30.63-20.65 15.45-23-80.9-6.45-29.07 22.48-36.39-20.4-30.35 3.65-.36-8a225.78 225.78 0 0 0-2.51-24.9c.13-2.5.22-5.37.21-8.49 0-13.15-1.78-30.58-9.6-42.2l1.8-16.18-14.6-17.25a110.37 110.37 0 0 1 8-13.46c.5-.72 1-1.42 1.54-2.1 18.95-1.37 33.9-16.95 33.9-36 0-.88 0-1.76-.1-2.63 0-.35-.07-.71-.11-1.06 1.85 1 3.72 2 5.59 3 .35.5.75 1 1.19 1.59l.09.11.56.69.18.21c.2.24.41.47.62.71l.14.16c.53.59 1.09 1.19 1.69 1.78a1.8 1.8 0 0 1 .2.19l.75.7.21.19c.64.57 1.32 1.12 2 1.64l.22.16.86.59.28.18c.33.2.67.41 1 .6l.12.07c.39.21.79.41 1.19.6l.2.08q.51.22 1 .42l.31.11c.35.12.69.23 1.05.33l.22.06c.44.11.88.2 1.33.27h.05a10.88 10.88 0 0 0 1.28.13h.29a11 11 0 0 0 1.15 0h.25a11.85 11.85 0 0 0 1.43-.17 15.78 15.78 0 0 0 6.3-2.26 5.5 5.5 0 0 0 1.28-1.19c2-2.62-.2-5.49-.2-5.49-.78-1.86-5.84-3.17-5.84-3.17s-16-6.68-16-12-4-32.92-45.29-39.23c0 0-26.86-1.51-34.41 12.87l-.16 1.68c-2.22 1.39-4.06 4.18-6.25 5a10.21 10.21 0 0 0-2.71 1v-.19a2.58 2.58 0 0 0-.61.79 8 8 0 0 0-.83 3 11.3 11.3 0 0 1-1.31 3.63 8.07 8.07 0 0 1-.6.92l-.17.27a7.3 7.3 0 0 0 3.4-.55 16.93 16.93 0 0 1-1 4 3.32 3.32 0 0 0 3.08-1.84v-.08l.13-.18a8.44 8.44 0 0 0 .62-1.45l-.11.12c.2-.65.38-1.31.6-1.95a3.06 3.06 0 0 1 .49-1 2.42 2.42 0 0 1 2.07-.69l-.41 8.67h.18a11.83 11.83 0 0 1-.88 1.82c-1.42 2.3-4 3.87-4.95 6.39a9.4 9.4 0 0 0-.46 3.78c0 .75.09 1.51.15 2.26v-.06c.14 2 .18 3.9-.9 5.51-.74 1.1-1.93 1.93-2.34 3.18a3.1 3.1 0 0 0-.15 1.08 12.13 12.13 0 0 0 .68 3.21.14.14 0 0 0 0-.06 4.88 4.88 0 0 1 .17 2.36c-.45 2-2.88 3.67-2.76 5.58a2.15 2.15 0 0 0 .11.74 4.05 4.05 0 0 0 2.26 2 8.8 8.8 0 0 0 5.08 1.12 6.68 6.68 0 0 0 1.9-.65c-.7 1.61-1.42 3.2-2.15 4.71-.11.24-.23.48-.35.72 0 0-6.18-4.13-9.69 4.29a18.68 18.68 0 0 0-2.17 5.64 13.42 13.42 0 0 1-.74 2.32 14.93 14.93 0 0 1-6.68 6c-7.16 3.28-36.08 39.35-36.59 48.69a54.49 54.49 0 0 1-1.84 10.78 64.15 64.15 0 0 0-1.72 25.49 48.77 48.77 0 0 0 1.77 8.13c3.07 9.33 5.12 26.74 5.12 26.74l3.32 30.22a86 86 0 0 0 .54 12.49c-3.39 3.87-17 20-11.8 24.39 4 3.46 11 2.89 14.93 2.18-3.31 8.19-8.52 22.43-9.21 32.21-1 14.47 1.71 33.64 6 41s18.59 26.24 18.59 26.24-.67 25.9 4.44 35.31 7.17 28.93 7.17 28.93 4.77 16.48 2.38 22.54 4.43 11.1-2.73 15.13-16.32 94.86-16.32 94.86-3.69 59.53 0 62.56a3.75 3.75 0 0 0 .63.37v20s-2.56 4.2 7.85 5.05c7.13.57 27.34 1.86 39.33 2.61l9.29.58s22 4.38 31.72 0 26.95-4.28 24.39-15.85a32.92 32.92 0 0 0-1.36-4.63c-2.81-7.18-7.58-8-16.37-10-.51-.11-1-.21-1.45-.29-9.26-1.61-12.3 2.7-17.49-2.91-4.51-4.85-18.87-10.28-23.76-12 .12-.36.27-.71.39-1.08a7.32 7.32 0 0 1-3.71-1.81l13.25.84 7.89.49s18.7 3.73 27 0 22.9-3.63 20.72-13.46a28.21 28.21 0 0 0-1.15-3.94c-2.39-6.1-6.45-6.77-13.92-8.46-.43-.09-.83-.18-1.23-.25-7.87-1.37-10.45 2.29-14.86-2.47-3.78-4.06-15.71-8.61-20-10.16 0-2.22-3-5.38-4.89-8.55-2.22-3.7 1.88-16.65 1.88-16.65l2.34-53.73a10.38 10.38 0 0 1 2.8-.8s10.58-10.1 8.19-20.86a69.13 69.13 0 0 1-.76-9.83c3.48-3.23 8.27-8 9.63-10.94 2.22-4.79 0-28 0-28v-88.75l17.7 1.79 16.06 1.65 4.89.5 16.06 1.62 36.91 3.73 33.26-6.3 14.39-2.72 29.59-5.6v-72.4zM386.74 176.86l-2.06-.22c.68.03 1.4.16 2.06.22z",
                transform: "translate(-95.23 -55.03)",
                fill: "url(#prefix__a)"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M463.33 408.75c-10 14.31-45.95 6.73-45.95 6.73l-27.86-26.07-3.75-3.53 6.29-13.36s2 .55 5.43 1.53c18.01 5.23 74.28 22.67 65.84 34.7z",
                fill: "#efb7b9"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M397.47 374.05c-1.23 4.28-4.6 10.69-7.95 15.36l-3.75-3.53 6.29-13.36s2.02.55 5.41 1.53z",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M301.92 223.39s-25.68 11.39-24.42 39.36a461.14 461.14 0 0 0 5.88 53.76s-5.25 42.09 16.61 52.94 42.09 19.77 42.09 19.77 34.2 3.68 38.45 5.2 17.53-21.72 15.08-25.34-33.84-11.21-37.84-17.25-13.25-9.77-13.25-9.77-9.55-5.78-10.2-11 1.87-9.11 2.51-11.4 2.26-24.4 2.26-24.4 10.78-78.7-37.17-71.87z",
                fill: "#dce6f2"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M318.87 315.36s-35.23 5.9-31.82 18.23c0 0 12.79-13.31 31.82-18.23zM319.14 320.35s-19.37 15.81-15.58 16.62 15.58-16.62 15.58-16.62zM328.45 325.86s-5.19 10.63-2 9.91 2-9.91 2-9.91z",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M398.77 375.18l-2.14-.61c.61-2 .78-3.62.28-4.37-2.45-3.62-33.82-11.2-37.81-17.25s-13.25-9.77-13.25-9.77-9.55-5.78-10.2-11 1.87-9.11 2.51-11.4 2.26-24.41 2.26-24.41 10.75-78.69-37.2-71.86c0 0-25.68 11.4-24.43 39.37a459.85 459.85 0 0 0 5.89 53.76s-5.25 42.09 16.61 52.94 42.09 19.77 42.09 19.77 34.19 3.67 38.45 5.2c1.61.58 4.52-2.41 7.37-6.52l1.62 1.51 27.86 26.06s35.95 7.59 45.95-6.72c8.45-12.04-47.81-29.48-65.86-34.7z",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M287.14 118.41a8.5 8.5 0 0 0-2.77 1.07c-1 .83-1 2.25-1.25 3.49a11.48 11.48 0 0 1-2 4.78 7.19 7.19 0 0 0 3.33-.55 17.14 17.14 0 0 1-1 4 3.24 3.24 0 0 0 3-1.83 19.26 19.26 0 0 0 1.25-3.51 2.89 2.89 0 0 1 .48-1c.92-1.09 2.63-.6 4.05-.46a6.65 6.65 0 0 0 6.08-2.92c1.51-2.29 1.6-8.15-2-8.77-3.76-.62-6.1 4.56-9.17 5.7z",
                fill: "#965d7b"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                opacity: 0.1,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M284.27 120.71c.09-.49.15-1 .26-1.49-.95.83-1 2.24-1.25 3.49a11 11 0 0 1-.59 2.11 11.46 11.46 0 0 0 1.58-4.11zM284.59 128.97a16.63 16.63 0 0 0 1-4 7.16 7.16 0 0 1-3.17.55 11.57 11.57 0 0 1-1.15 2 7.12 7.12 0 0 0 3.32-.54 16.63 16.63 0 0 1-1 4 3.25 3.25 0 0 0 3-1.83 7.46 7.46 0 0 0 .6-1.43 3 3 0 0 1-2.6 1.25zM293.37 122.17c-1.42-.14-3.14-.63-4.06.46a3.09 3.09 0 0 0-.48 1c-.09.26-.17.53-.24.8.95-.75 2.49-.35 3.78-.22a6.68 6.68 0 0 0 6.08-2.92 5.54 5.54 0 0 0 .67-1.57 6.66 6.66 0 0 1-5.75 2.45z"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                fill: "#dce6f2",
                d: "M317.24 201l15.25 18.34-1.99 18.51L312.07 209l5.17-8z"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                opacity: 0.1,
                d: "M332.48 219.34l-1.87 17.41-.12 1.1-16.63-26.04-1.79-2.81.52-.81 4.64-7.19 1.03 1.24 14.22 17.1z"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M340.4 176.17c-5.16 1.48-10.09 6.56-14.38 12.73a108.65 108.65 0 0 0-7.76 13.34c-1.41 2.82-2.65 5.53-3.68 7.89l-.72 1.68c-1.74 4.11-2.71 6.86-2.71 6.86s-39.5-29.7-33.25-31.7c2.1-.67 4.86-5.17 7.59-10.84l.34-.72c1.73-3.64 3.43-7.7 4.94-11.52 3.09-7.85 5.38-14.67 5.38-14.67s60 22.45 44.25 26.95z",
                fill: "#efb7b9"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M364.03 147.55s9.12 16.5 21.37 14.25 7.21-8.86 7.21-8.86z",
                fill: "#444053"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M346.36 718.7c-8.08 3.69-26.35 0-26.35 0l-7.7-.48c-10-.64-26.74-1.72-32.66-2.2-8.64-.71-6.52-4.25-6.52-4.25v-21.39l41.92-10.62s16.57 5.67 21.11 10.62c4.31 4.72 6.83 1.09 14.52 2.45.38.07.78.15 1.2.25 7.3 1.67 11.26 2.33 13.6 8.38a28.1 28.1 0 0 1 1.13 3.9c2.16 9.74-12.18 9.67-20.25 13.34z",
                fill: "#a36468"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M365.48 701.46a31.34 31.34 0 0 1-4.72 2.42c-5.5 2.51-10.73 5.57-16.29 7.94s-11.55 4.06-17.57 3.61c-3.15-.23-6.37-1-9.38-.1a21.66 21.66 0 0 0-5.21 2.89c-10-.64-26.74-1.72-32.66-2.2-8.64-.71-6.52-4.25-6.52-4.25v-2.5c.31 0 .66-.09 1.06-.12a18.88 18.88 0 0 1 6.1.91c4.34 1.18 8.66 2.34 13 3.5a10.27 10.27 0 0 1 5-6.38 15.94 15.94 0 0 1 8.06-1.85c6.73.09 13.1 3.28 19.82 3.6a10.92 10.92 0 0 0 5.49-.92c.92-.46 1.73-1.13 2.63-1.64a19.2 19.2 0 0 1 4.53-1.53 99.76 99.76 0 0 0 12.95-4.18c1.2-.47 2.6-1.32 2.44-2.6-.21-1.7-2.88-1.9-3.58-3.46a2 2 0 0 1 .08-1.77c.38.07.78.15 1.2.25 7.27 1.67 11.23 2.33 13.57 8.38z",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M337.82 765.5c-9.5 4.34-31 0-31 0l-9.05-.53c-11.72-.75-31.46-2-38.43-2.59-10.17-.84-7.67-5-7.67-5v-25.21l49.33-12.5s19.5 6.67 24.84 12.5c5.07 5.55 8 1.28 17.09 2.88.45.08.92.18 1.41.29 8.59 2 13.25 2.75 16 9.87a32.1 32.1 0 0 1 1.33 4.59c2.48 11.46-14.35 11.37-23.85 15.7z",
                fill: "#a36468"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M360.32 745.21a37.23 37.23 0 0 1-5.55 2.85c-6.47 2.95-12.63 6.55-19.17 9.34s-13.59 4.77-20.68 4.25c-3.7-.27-7.49-1.2-11-.12a25.5 25.5 0 0 0-6.15 3.44c-11.72-.75-31.46-2-38.43-2.59-10.17-.84-7.67-5-7.67-5v-2.94a12.5 12.5 0 0 1 1.25-.14 21.94 21.94 0 0 1 7.18 1.07l15.29 4.12a12.1 12.1 0 0 1 5.93-7.51 18.66 18.66 0 0 1 9.49-2.18c7.92.11 15.41 3.86 23.32 4.24a12.91 12.91 0 0 0 6.44-1.07c1.09-.55 2-1.34 3.1-1.93a21.75 21.75 0 0 1 5.33-1.8 119.69 119.69 0 0 0 15.16-4.92c1.41-.56 3.06-1.56 2.87-3.06-.25-2-3.39-2.24-4.22-4.08a2.41 2.41 0 0 1 .1-2.08c.45.08.92.18 1.41.29 8.59 1.92 13.25 2.7 16 9.82z",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M316.32 592.51l-2.67 62.83s-4 12.83-1.83 16.5 5.83 7.33 4.5 9.5-17.33 25.63-22.5 16.63-10.27-48-10.27-48l4.77-48.17zM327.9 435.97l7.42 9.92v86.28s2.17 23 0 27.75-13.17 14.25-13.17 14.25l-9.25-47.5 2-50.25z",
                fill: "#444053"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M316.32 592.51l-2.67 62.83s-4 12.83-1.83 16.5 5.83 7.33 4.5 9.5-17.33 25.63-22.5 16.63-10.27-48-10.27-48l4.77-48.17zM327.9 435.97l7.42 9.92v86.28s2.17 23 0 27.75-13.17 14.25-13.17 14.25l-9.25-47.5 2-50.25z",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M335.32 399.17v46.67l-8.33 36.33s-2.67 87.67-.34 98.33-8 20.67-8 20.67-6 .67-6 5.33-10 18-10 18l.33 26s4.34 48.67-2.33 58 2.33 10.67 2.33 10.67c-8.33 27.33-48.33 21-51.94 18s0-62 0-62 8.94-90 15.94-94 .34-9 2.67-15-2.33-22.33-2.33-22.33-2-19.34-7-28.67-4.34-35-4.34-35-14-18.67-18.16-26-6.84-26.33-5.84-40.67c.68-9.69 5.77-23.8 9-31.92 1.55-3.89 2.67-6.41 2.67-6.41l.95.25 54.62 14.3z",
                fill: "#444053"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M340.4 176.17c-5.16 1.48-10.09 6.56-14.38 12.73h-1.12a35.72 35.72 0 0 1-31-17.93 35.18 35.18 0 0 1-3.14-7.15c3.09-7.85 5.38-14.67 5.38-14.67s60.01 22.52 44.26 27.02z",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M360.65 151.17a35.75 35.75 0 1 1-66.88-17.52 34.93 34.93 0 0 1 3.78-5.46 36.18 36.18 0 0 1 8.22-7.22 35.75 35.75 0 0 1 54.83 27.58c.02.88.05 1.75.05 2.62z",
                fill: "#efb7b9"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M330.61 236.75l-.12 1.1-16.63-26c-1.74 4.11-2.71 6.86-2.71 6.86s-39.5-29.74-33.25-31.74c2.1-.67 4.86-5.17 7.59-10.84l.34-.72c2.9 8.64 19.75 25.91 26.76 32.83.81.8 1.48 1.46 2 1.94l1.07 1 .56.56c2.55 2.63 13.31 14.23 14.39 25.01z",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M343.04 324.97l-1.82 58.57-.32 10.43s-21.56-2-41.68-4.2c-16.2-1.77-31.47-3.68-33.82-4.8-3-1.41-9.43-2.5-14.5-3.19-3.92-.53-7-.81-7-.81s-1.15.34-2.92.66c-3.86.7-10.64 1.27-14.59-2.16-5.05-4.39 8.22-20.34 11.53-24.17l.73-.83-1.25-11.55-3.25-29.95s-2-17.25-5-26.5a48.88 48.88 0 0 1-1.73-8.05 64.48 64.48 0 0 1 1.68-25.26 55.08 55.08 0 0 0 1.8-10.69c.5-9.25 28.75-45 35.75-48.25a14.84 14.84 0 0 0 7.16-7.14 13.64 13.64 0 0 0 1.09-3.11c3-13 10.59-7.84 10.59-7.84 1.83 10.17 30.16 37.09 30.16 37.09l.56.56c2.81 2.88 15.33 16.4 14.44 27.94a33.87 33.87 0 0 0 1.89 12.64 213.75 213.75 0 0 1 9.85 56z",
                fill: "#dce6f2"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M302.9 255.42s-7 17-12.25 19.75 14.75 5.8 12.25-19.75zM308.15 287.17s-16 2-16 5 16-5 16-5zM324.9 306.67s-23.25 49.5-29.75 51 29.75-51 29.75-51zM315.21 215.73l-19.23 8.36-23.21-35.06a13.64 13.64 0 0 0 1.09-3.11c3-13 10.59-7.84 10.59-7.84 1.83 10.17 30.16 37.09 30.16 37.09z",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M316.21 213.73l-19.23 8.36-23.21-35.06a13.64 13.64 0 0 0 1.09-3.11c3-13 10.59-7.84 10.59-7.84 1.83 10.17 30.16 37.09 30.16 37.09z",
                fill: "#dce6f2"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M340.9 393.97s-21.56-2-41.68-4.2l36.1 9.45v11c-1.58 1.43-2.95 2.17-3.84 1.79-4.16-1.75-38.11-7.25-38.11-7.25s-19.72-10-41-22a16.43 16.43 0 0 1-1.5-.94 23.64 23.64 0 0 1-6.3-6.31c-3.93-5.69-5.85-13-6.68-20.17a87.22 87.22 0 0 1-.52-12.38 101.51 101.51 0 0 1 1.28-13.99 460.08 460.08 0 0 1-3-54c.25-28 26.5-38 26.5-38 48.25-4.25 33.29 73.75 33.29 73.75s-2.79 22-3.55 24.25-3.49 6-3.12 11.25 9.59 11.53 9.59 11.53 9 4.22 12.71 10.47c2.7 4.61 20.24 10.86 30.15 15.32zM357.06 128.97a11.32 11.32 0 0 1-1 4.78 29.55 29.55 0 0 1-1.78 3.56 16.4 16.4 0 0 1-4.38 5.44c-2.31 1.65-5.23 2.11-8 2.78s-5.65 1.74-7.23 4.1a14.34 14.34 0 0 0-1.69 4.9 10.54 10.54 0 0 1-2 4.74 3.93 3.93 0 0 1-4.68 1.12 4.73 4.73 0 0 1-1.81-2.33c-1.14-2.57-1.43-5.42-1.89-8.19s-1.11-5.62-2.81-7.85-4.71-3.7-7.38-2.83a7.11 7.11 0 0 0-4 3.88 22.24 22.24 0 0 0-1.51 5.52q-1.86 10.18-4.39 20.24a1.86 1.86 0 0 1-.33.76 1.44 1.44 0 0 1-1 .42c-2.24.3-4.39-1.27-6.65-1.1a3.82 3.82 0 0 0-.69.11 35.73 35.73 0 0 1 3.61-40.8l.18-.05a10.78 10.78 0 0 0 4-2.52 42.22 42.22 0 0 0 4-4.63l.8-1a45.61 45.61 0 0 1 7.8-7.41 8 8 0 0 1 2.66-1.44 7.88 7.88 0 0 1 2.52-.08 63.57 63.57 0 0 0 10.41.39 66.79 66.79 0 0 1 7.31-.74c6.33.18 11.73 4.65 15.73 9.55 2.15 2.51 4.07 5.4 4.2 8.68z",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M289.1 134.6c-1.39 2.28-3.9 3.83-4.84 6.33-1.38 3.63.95 8.15-1.19 11.39-.71 1.09-1.88 1.9-2.28 3.15-.68 2.11 1.18 4.36.7 6.53s-3.34 4-2.58 6.12a4 4 0 0 0 2.2 2 8.6 8.6 0 0 0 5 1.11c2.73-.45 4.76-3.13 7.53-3.33 2.25-.16 4.4 1.4 6.64 1.11a1.5 1.5 0 0 0 1-.43 1.73 1.73 0 0 0 .33-.76q2.52-10.05 4.4-20.24a21.8 21.8 0 0 1 1.5-5.52 7.17 7.17 0 0 1 4-3.88c2.67-.86 5.67.6 7.38 2.83s2.36 5.08 2.82 7.85.75 5.62 1.88 8.19a4.78 4.78 0 0 0 1.82 2.34c1.5.87 3.52.18 4.67-1.12a10.43 10.43 0 0 0 2-4.75 14.28 14.28 0 0 1 1.69-4.89c1.58-2.36 4.47-3.43 7.23-4.1s5.67-1.14 8-2.79a16.46 16.46 0 0 0 4.38-5.43c1.48-2.58 2.86-5.38 2.74-8.35-.13-3.24-2.05-6.13-4.1-8.65-4-4.9-9.41-9.37-15.74-9.54a62.2 62.2 0 0 0-7.31.74 62.57 62.57 0 0 1-10.41-.4 8.18 8.18 0 0 0-2.52.09 7.54 7.54 0 0 0-2.65 1.44 45.63 45.63 0 0 0-7.81 7.4 57.31 57.31 0 0 1-4.82 5.6 10.85 10.85 0 0 1-4 2.53c-1 .28-2 .08-2.95.39-2.95.93-3.34 4.78-4.71 7.04z",
                fill: "#965d7b"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M385.4 161.79c-8 1.47-14.63-5-18.3-9.72a39.22 39.22 0 0 1-3.07-4.52l27.46 5.18 1.11.21s5.05 6.61-7.2 8.85z",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                opacity: 0.1,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M281.49 159.14a8.33 8.33 0 0 0-.58-3.84c0 .1-.09.2-.12.3-.43 1.34.15 2.73.52 4.12a3 3 0 0 0 .18-.58zM283.87 142.77a22.22 22.22 0 0 0 .08 4.15 22.28 22.28 0 0 0-.08-4.15zM353.32 133.42a16.4 16.4 0 0 1-4.38 5.44c-2.31 1.65-5.22 2.11-8 2.78s-5.65 1.74-7.23 4.1a14.41 14.41 0 0 0-1.69 4.9 10.47 10.47 0 0 1-2 4.75c-1.15 1.3-3.17 2-4.67 1.12a4.78 4.78 0 0 1-1.82-2.34c-1.13-2.57-1.43-5.41-1.88-8.19s-1.12-5.62-2.82-7.85-4.71-3.7-7.38-2.83a7.14 7.14 0 0 0-4 3.88 21.8 21.8 0 0 0-1.5 5.52q-1.87 10.19-4.4 20.24a1.73 1.73 0 0 1-.33.76 1.5 1.5 0 0 1-1 .43c-2.24.29-4.39-1.27-6.64-1.11-2.77.2-4.8 2.88-7.53 3.32a8.45 8.45 0 0 1-5-1.11 5.35 5.35 0 0 1-1.83-1.3 2.7 2.7 0 0 0-.37 2.33 3.9 3.9 0 0 0 2.2 2 8.45 8.45 0 0 0 5 1.11c2.73-.44 4.76-3.12 7.53-3.32 2.25-.16 4.4 1.4 6.64 1.11a1.5 1.5 0 0 0 1-.43 1.73 1.73 0 0 0 .33-.76q2.52-10 4.4-20.24a21.8 21.8 0 0 1 1.5-5.52 7.14 7.14 0 0 1 4-3.88c2.67-.87 5.67.6 7.38 2.83s2.36 5.08 2.82 7.85.75 5.62 1.88 8.19a4.78 4.78 0 0 0 1.82 2.34c1.5.87 3.52.18 4.67-1.12a10.47 10.47 0 0 0 2-4.75 14.41 14.41 0 0 1 1.69-4.9c1.58-2.36 4.47-3.42 7.23-4.1s5.67-1.13 8-2.78a16.4 16.4 0 0 0 4.38-5.44c1.48-2.57 2.86-5.37 2.74-8.34a10.74 10.74 0 0 0-.12-1.14 19.65 19.65 0 0 1-2.62 6.45z"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M356.1 133.72a35.33 35.33 0 0 1 4.45 14.85c-8.91-5-17.29-10.49-21.52-12.4-7.37-3.33-34.93-2.83-45.29-2.52a34.93 34.93 0 0 1 3.78-5.46 36.18 36.18 0 0 1 8.25-7.22 35.77 35.77 0 0 1 50.38 12.73zM387.9 157.55c-4.81 1.48-12.66-1.38-20.8-5.48a39.22 39.22 0 0 1-3.07-4.52l27.46 5.18c1.82 1.24 2.28 3.01-3.59 4.82z",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M327.03 99.05s-26.25-1.5-33.63 12.75l-1.19 12.63-2-.22-.4 8.59s40.12-1.75 49.25 2.37 37.5 24.88 48.87 21.38-1-6.75-1-6.75-15.65-6.63-15.65-11.83-3.88-32.67-44.25-38.92z",
                fill: "#444053"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M276.4 567.25s16.75 16.25 24 15c0 0-20.5-1.75-24-15zM272.9 574.78s1.5 8.36 5.5 7.54-5.5-7.54-5.5-7.54zM299.15 714.5s-23.78 18.5-19.77 19 19.77-19 19.77-19z",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                fill: "#4285f4",
                d: "M330.96 347.33l77-12.53v72.9l-73.16-3.83-3.84-56.54z"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                opacity: 0.05,
                d: "M330.96 347.33l77-12.53v72.9l-73.16-3.83-3.84-56.54z"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                fill: "#4285f4",
                d: "M407.96 334.8l92.34 6.91-5.11 63.44-87.23 2.55v-72.9z"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                opacity: 0.1,
                d: "M407.96 334.8l92.34 6.91-5.11 63.44-87.23 2.55v-72.9z"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                fill: "#4285f4",
                d: "M436.35 312.55l-28.39 22.25 92.34 6.91 15.09-22.77-79.04-6.39zM303.08 323.03l69.32-8.44 35.56 20.21-77 12.53-27.88-24.3zM424.84 353.73v99.67l-36.07-3.7-15.69-1.6-4.78-.5-15.68-1.61-21.66-2.22v-96.44l76.99 5.24 16.89 1.16z"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                fill: "#4285f4",
                d: "M500.3 341.71v97.2l-28.91 5.55-14.06 2.7-32.49 6.24v-99.67l75.46-12.02z"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                opacity: 0.05,
                d: "M500.3 341.71v97.2l-28.91 5.55-14.06 2.7-32.49 6.24v-99.67l75.46-12.02z"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                fill: "#4285f4",
                d: "M303.08 368.31l27.88-20.98 93.88 6.4-13.82 23.28-107.94-8.7z"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                fill: "#fff",
                opacity: 0.1,
                d: "M303.08 368.31l27.88-20.98 93.88 6.4-13.82 23.28-107.94-8.7z"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                fill: "#4285f4",
                d: "M500.3 341.71l-75.46 12.02 24.56 22 80.83-13.56-29.93-20.46z"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                fill: "#fff",
                opacity: 0.1,
                d: "M500.3 341.71l-75.46 12.02 24.56 22 80.83-13.56-29.93-20.46zM471.39 444.46l-14.06 2.7v-20.77l13.17-3.32.89 21.39zM388.77 435.96v13.74l-15.69-1.6v-12.14h15.69zM368.3 440.29v7.31l-15.68-1.61v-5.7h15.68z"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M415.4 428.67c-10.75 13.75-46.25 4.25-46.25 4.25l-26.38-27.52-3.58-3.73 7-13s2 .66 5.34 1.82c17.68 6.18 72.92 26.61 63.87 38.18z",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M414.4 426.67c-10.75 13.75-46.25 4.25-46.25 4.25l-26.38-27.52-3.58-3.73 7-13s2 .66 5.34 1.82c17.68 6.18 72.92 26.61 63.87 38.18z",
                fill: "#efb7b9"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M350.49 388.49c-1.46 4.2-5.17 10.42-8.76 14.91l-3.58-3.73 7-13s2.01.66 5.34 1.82z",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M263.15 232.97s-26.25 10-26.5 38a460.08 460.08 0 0 0 3 54s-7.5 41.75 13.75 53.75 41 22 41 22 33.95 5.5 38.12 7.25 18.66-20.75 16.41-24.5-33.16-13-36.83-19.25-12.71-10.46-12.71-10.46-9.22-6.29-9.59-11.54 2.35-9 3.12-11.25 3.56-24.25 3.56-24.25 14.92-78.05-33.33-73.75z",
                fill: "#dce6f2"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M275.15 325.67s-35.5 4-32.75 16.5c0 0 13.49-12.61 32.75-16.5zM275.15 330.67S255 345.42 258.7 346.42s16.45-15.75 16.45-15.75zM284.15 336.67s-5.75 10.34-2.5 9.8 2.5-9.8 2.5-9.8z",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M653.77 112.39s-38-2.29-33.56 24.37c0 0-.89 4.71 3.38 6.85 0 0 .07-2 3.9-1.31a17.51 17.51 0 0 0 4.13.2 8.57 8.57 0 0 0 5.06-2.09s10.69-4.41 14.85-21.89c0 0 3.08-3.82 3-4.8l-6.42 2.75s2.19 4.63.46 8.48c0 0-.2-8.31-1.44-8.12-.25 0-3.33 1.61-3.33 1.61s3.77 8.06.92 13.93c0 0 1.08-9.94-2.1-13.35l-4.52 2.64s4.41 8.33 1.42 15.13c0 0 .77-10.43-2.37-14.49l-4.1 3.19s4.15 8.22 1.62 13.86c0 0-.33-12.14-2.51-13.06 0 0-3.58 3.16-4.12 4.46 0 0 2.83 6 1.07 9.11 0 0-1.08-8.09-2-8.13 0 0-3.57 5.36-3.94 9a19.46 19.46 0 0 1 3.07-9.54 10.71 10.71 0 0 0-5.46 2.83s.55-3.79 6.34-4.12c0 0 3-4.07 3.74-4.32 0 0-5.76-.48-9.25 1.07 0 0 3.07-3.57 10.31-2l4-3.3s-7.58-1-10.8.11c0 0 3.7-3.16 11.89-.86l4.4-2.63s-6.46-1.4-10.31-.89c0 0 4.06-2.19 11.6.18l3.15-1.41s-4.74-.93-6.12-1.08-1.46-.53-1.46-.53a16.36 16.36 0 0 1 8.89 1s6.75-2.43 6.61-2.85z",
                fill: "#4285f4"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M769.23 245.73s-38-2.29-33.56 24.37c0 0-.89 4.71 3.38 6.85 0 0 .07-2 3.91-1.31a17.51 17.51 0 0 0 4.13.2 8.56 8.56 0 0 0 5-2.08s10.7-4.42 14.86-21.9c0 0 3.07-3.81 2.95-4.79l-6.42 2.74s2.19 4.63.47 8.48c0 0-.21-8.31-1.44-8.12-.25 0-3.34 1.61-3.34 1.61s3.78 8.07.93 13.93c0 0 1.08-9.94-2.11-13.35l-4.47 2.61s4.41 8.33 1.42 15.13c0 0 .77-10.43-2.37-14.49l-4.09 3.2s4.14 8.21 1.62 13.85c0 0-.33-12.14-2.51-13.06 0 0-3.58 3.16-4.13 4.46 0 0 2.84 6 1.08 9.11 0 0-1.08-8.09-2-8.13 0 0-3.57 5.36-3.94 9a19.52 19.52 0 0 1 3.08-9.54 10.76 10.76 0 0 0-5.47 2.83s.56-3.79 6.35-4.12c0 0 2.95-4.07 3.74-4.32 0 0-5.76-.48-9.25 1.07 0 0 3.07-3.57 10.3-1.95l4-3.3s-7.59-1-10.8.11c0 0 3.7-3.16 11.89-.86l4.4-2.63s-6.47-1.39-10.32-.89c0 0 4.07-2.19 11.61.18l3.15-1.41s-4.74-.93-6.13-1.08-1.46-.53-1.46-.53a16.39 16.39 0 0 1 8.9 1s6.76-2.45 6.64-2.87zM538.38 222.06s8.75-37.09-18.29-37.22c0 0-4.49-1.68-7.32 2.16 0 0 1.93.41.62 4.07a17.8 17.8 0 0 0-.9 4 8.59 8.59 0 0 0 1.19 5.33s2.53 11.3 19 18.38c0 0 3.24 3.68 4.22 3.72l-1.6-6.79s-4.94 1.37-8.44-1c0 0 8.23 1.21 8.24 0 0-.25-1-3.56-1-3.56s-8.59 2.34-13.89-1.47c0 0 9.61 2.76 13.52.21l-1.8-4.92s-9 2.93-15.16-1.18c0 0 10.15 2.54 14.69.14l-2.45-4.58s-8.8 2.68-13.93-.77c0 0 12 1.74 13.3-.24 0 0-2.5-4.07-3.69-4.83 0 0-6.36 1.78-9.16-.49 0 0 8.15.31 8.34-.55 0 0-4.67-4.43-8.23-5.43a19.6 19.6 0 0 1 8.89 4.66 10.79 10.79 0 0 0-1.86-5.87s3.64 1.2 3 7c0 0 3.5 3.6 3.61 4.42 0 0 1.45-5.59.52-9.3 0 0 3 3.64.17 10.49l2.56 4.55s2.32-7.3 1.73-10.66c0 0 2.49 4.18-1.18 11.86l1.85 4.79s2.47-6.14 2.63-10c0 0 1.47 4.38-2.16 11.41l.86 3.34s1.72-4.51 2.1-5.85.77-1.35.77-1.35a16.38 16.38 0 0 1-2.49 8.6s1.31 6.98 1.74 6.93zM455.16 234.7s-30.52-22.83-41.43 1.9c0 0-3.33 3.45-.94 7.58 0 0 1.14-1.61 4 1.06a17.51 17.51 0 0 0 3.34 2.44 8.58 8.58 0 0 0 5.37 1s11.36 2.19 24.44-10.12c0 0 4.67-1.5 5.11-2.38l-6.89-1.21s-.72 5.07-4.27 7.34c0 0 4.39-7.06 3.25-7.57-.23-.11-3.67-.5-3.67-.5s-1.28 8.82-6.88 12.15c0 0 6.37-7.71 5.58-12.31l-5.23-.28s-.89 9.39-7.13 13.43c0 0 6.37-8.29 6-13.41l-5.18.42s-1.05 9.13-6.26 12.45c0 0 6.39-10.32 5.08-12.28 0 0-4.73.67-5.9 1.45 0 0-.91 6.54-4.11 8.2 0 0 3.55-7.35 2.83-7.86 0 0-5.93 2.51-8.26 5.37a19.53 19.53 0 0 1 7.82-6.28 10.77 10.77 0 0 0-6.12-.64s2.54-2.86 7.56.05c0 0 4.7-1.77 5.5-1.55 0 0-4.55-3.57-8.32-4.19 0 0 4.54-1.3 9.69 4l5.19-.53s-5.77-5-9.08-5.84c0 0 4.83-.61 10.4 5.81l5.12.23s-4.63-4.72-8.12-6.42c0 0 4.59.4 9.59 6.53l3.41.55s-3.45-3.38-4.53-4.26-.93-1.25-.93-1.25a16.43 16.43 0 0 1 6.89 5.72s6.95 1.61 7.08 1.2zM556.77 22.59s-30.52-22.84-41.43 1.9c0 0-3.33 3.45-.94 7.58 0 0 1.14-1.61 4 1.06a17.79 17.79 0 0 0 3.35 2.43 8.57 8.57 0 0 0 5.37 1s11.36 2.19 24.44-10.13c0 0 4.67-1.49 5.1-2.38l-6.89-1.19s-.71 5.07-4.27 7.34c0 0 4.4-7.06 3.26-7.57-.23-.11-3.67-.5-3.67-.5s-1.32 8.84-6.92 12.15c0 0 6.36-7.71 5.58-12.31l-5.23-.28s-.9 9.39-7.13 13.42c0 0 6.37-8.29 6-13.41l-5.17.42s-1.06 9.14-6.27 12.46c0 0 6.4-10.32 5.09-12.28 0 0-4.73.67-5.9 1.45 0 0-.91 6.54-4.11 8.2 0 0 3.55-7.35 2.83-7.87 0 0-5.93 2.52-8.26 5.38a19.44 19.44 0 0 1 7.82-6.28 10.7 10.7 0 0 0-6.13-.64s2.55-2.86 7.57.05c0 0 4.7-1.78 5.5-1.55 0 0-4.55-3.57-8.32-4.2 0 0 4.53-1.29 9.68 4l5.19-.53s-5.76-5-9.08-5.85c0 0 4.83-.6 10.41 5.82l5.12.22s-4.63-4.72-8.13-6.41c0 0 4.6.4 9.6 6.53l3.4.55s-3.46-3.34-4.54-4.2-.93-1.24-.93-1.24a16.4 16.4 0 0 1 6.89 5.72s6.95 1.52 7.12 1.14zM673.39 51.52s-12.2-36.11-35.21-21.92c0 0-4.7 1-5.07 5.71 0 0 1.85-.68 2.67 3.12a18 18 0 0 0 1.37 3.91 8.66 8.66 0 0 0 3.84 3.89s8.12 8.25 25.88 5.52c0 0 4.69 1.42 5.55.93l-5-4.91s-3.46 3.77-7.68 3.62c0 0 7.63-3.32 7-4.39-.13-.21-2.74-2.48-2.74-2.48s-6.06 6.53-12.56 6.1c0 0 9.61-2.74 11.57-7l-4.14-3.19s-6.06 7.22-13.49 7c0 0 10-3.21 12.53-7.65l-4.5-2.59s-6 6.93-12.22 6.71c0 0 11.12-4.87 11.15-7.23 0 0-4.27-2.13-5.68-2.15 0 0-4.46 4.87-8 4.43 0 0 7.08-4.05 6.78-4.88 0 0-6.3-1.29-9.85-.25a19.49 19.49 0 0 1 10-.75 10.79 10.79 0 0 0-4.69-4s3.72-.91 6.21 4.33c0 0 4.88 1.21 5.4 1.84 0 0-1.72-5.51-4.47-8.17 0 0 4.47 1.51 5.69 8.82l4.58 2.5s-1.89-7.41-4.17-10c0 0 4.33 2.24 5.27 10.69l4.1 3.09s-1.14-6.52-3.06-9.9c0 0 3.56 2.94 4.2 10.83l2.49 2.38s-.92-4.74-1.3-6.08-.07-1.43-.07-1.43a16.49 16.49 0 0 1 2.43 8.62s4.84 5.19 5.19 4.93zM593.77 53.3s-37.9-4.22-34.77 22.67c0 0-1.13 4.66 3 7 0 0 .17-2 4-1.1a18.4 18.4 0 0 0 4.12.41 8.6 8.6 0 0 0 5.15-1.83s10.91-3.87 16-21.12c0 0 3.26-3.65 3.19-4.64l-6.55 2.42s2 4.73 0 8.49c0 0 .21-8.31-1-8.18-.25 0-3.41 1.44-3.41 1.44s3.36 8.25.22 14c0 0 1.58-9.88-1.43-13.44l-4.65 2.4s4 8.55.65 15.19c0 0 1.3-10.38-1.63-14.59l-4.25 3s3.72 8.41.91 13.92c0 0 .29-12.14-1.84-13.17 0 0-3.74 3-4.35 4.24 0 0 2.53 6.1.62 9.15 0 0-.67-8.13-1.55-8.21 0 0-3.84 5.17-4.4 8.82a19.47 19.47 0 0 1 3.56-9.38 10.76 10.76 0 0 0-5.6 2.55s.74-3.75 6.54-3.79c0 0 3.15-3.91 4-4.12 0 0-5.73-.77-9.3.6 0 0 3.25-3.42 10.39-1.43l4.21-3.09s-7.61-1.54-10.83-.54c0 0 3.86-3 11.92-.25l4.53-2.41s-6.39-1.72-10.26-1.41c0 0 4.17-2 11.58.77l3.22-1.25s-4.69-1.17-6.07-1.39-1.43-.6-1.43-.6a16.45 16.45 0 0 1 8.84 1.44s6.74-2.15 6.67-2.57zM925.37 347.47s-37.88-4.22-34.75 22.64c0 0-1.13 4.66 3 7 0 0 .17-2 4-1.11a17.3 17.3 0 0 0 4.12.41 8.53 8.53 0 0 0 5.15-1.83s10.91-3.87 15.95-21.11c0 0 3.26-3.66 3.19-4.64l-6.55 2.41s2 4.74 0 8.5c0 0 .21-8.32-1-8.18-.25 0-3.41 1.43-3.41 1.43s3.36 8.25.22 14c0 0 1.58-9.87-1.43-13.44l-4.65 2.41s4 8.55.66 15.19c0 0 1.29-10.38-1.64-14.6l-4.25 3s3.72 8.41.91 13.91c0 0 .29-12.14-1.84-13.16 0 0-3.73 3-4.35 4.24 0 0 2.54 6.1.62 9.15 0 0-.67-8.13-1.55-8.21 0 0-3.84 5.17-4.4 8.82a19.47 19.47 0 0 1 3.56-9.38 10.67 10.67 0 0 0-5.6 2.55s.74-3.76 6.54-3.8c0 0 3.16-3.91 4-4.11 0 0-5.73-.78-9.3.59 0 0 3.25-3.41 10.4-1.42l4.2-3.09s-7.52-1.42-10.79-.44c0 0 3.86-3 11.92-.26l4.53-2.4s-6.39-1.72-10.26-1.41c0 0 4.17-2 11.58.77l3.22-1.26s-4.69-1.17-6.07-1.38-1.43-.6-1.43-.6a16.39 16.39 0 0 1 8.84 1.43s6.76-2.19 6.66-2.62zM983.28 382.85s-37.88-4.21-34.75 22.64c0 0-1.12 4.66 3 7 0 0 .17-2 4-1.1a17.65 17.65 0 0 0 4.11.4 8.64 8.64 0 0 0 5.13-1.82s10.9-3.87 15.94-21.12c0 0 3.27-3.65 3.19-4.64l-6.55 2.41s2 4.74 0 8.5c0 0 .21-8.31-1-8.18-.25 0-3.41 1.43-3.41 1.43s3.36 8.25.22 14c0 0 1.58-9.87-1.43-13.43l-4.65 2.4s4 8.55.66 15.19c0 0 1.29-10.38-1.64-14.59l-4.25 3s3.72 8.41.92 13.92c0 0 .28-12.15-1.85-13.17 0 0-3.73 3-4.35 4.24 0 0 2.54 6.1.62 9.15 0 0-.67-8.13-1.55-8.21 0 0-3.84 5.17-4.39 8.82a19.52 19.52 0 0 1 3.55-9.38 10.76 10.76 0 0 0-5.6 2.55s.75-3.76 6.55-3.79c0 0 3.15-3.91 4-4.12 0 0-5.73-.77-9.3.6 0 0 3.25-3.42 10.4-1.43l4.2-3.09s-7.52-1.42-10.79-.44c0 0 3.86-3 11.92-.25l4.53-2.41s-6.39-1.72-10.26-1.41c0 0 4.17-2 11.58.77l3.22-1.25s-4.69-1.17-6.06-1.39-1.44-.6-1.44-.6a16.45 16.45 0 0 1 8.84 1.44s6.79-2.21 6.69-2.64zM854.71 84.84s-30.52-22.83-41.43 1.9c0 0-3.33 3.45-.94 7.58 0 0 1.14-1.61 4 1.06a17.51 17.51 0 0 0 3.34 2.44 8.59 8.59 0 0 0 5.37 1s11.36 2.19 24.45-10.12c0 0 4.66-1.5 5.1-2.38l-6.87-1.24s-.72 5.07-4.27 7.34c0 0 4.39-7.06 3.25-7.57-.23-.11-3.66-.5-3.66-.5s-1.29 8.82-6.89 12.15c0 0 6.37-7.71 5.58-12.31l-5.23-.28s-.89 9.39-7.13 13.43c0 0 6.38-8.29 6-13.41l-5.18.42s-1 9.13-6.26 12.45c0 0 6.4-10.32 5.08-12.28 0 0-4.73.67-5.9 1.45 0 0-.9 6.54-4.1 8.2 0 0 3.54-7.35 2.82-7.86 0 0-5.93 2.51-8.26 5.37a19.53 19.53 0 0 1 7.82-6.28 10.77 10.77 0 0 0-6.12-.64s2.55-2.86 7.57.05c0 0 4.69-1.77 5.49-1.55 0 0-4.55-3.57-8.32-4.19 0 0 4.54-1.3 9.69 4l5.19-.53s-5.76-5-9.08-5.84c0 0 4.83-.61 10.4 5.81l5.13.23s-4.64-4.72-8.13-6.42c0 0 4.6.4 9.59 6.53l3.41.55s-3.45-3.38-4.53-4.26-.92-1.17-.92-1.17a16.44 16.44 0 0 1 6.88 5.72s6.93 1.56 7.06 1.15zM878.29 249.66s-10.52-36.63-34.18-23.48c0 0-4.74.73-5.33 5.47 0 0 1.88-.59 2.53 3.24a17.73 17.73 0 0 0 1.2 4 8.59 8.59 0 0 0 3.66 4.08s7.74 8.6 25.6 6.68c0 0 4.62 1.62 5.5 1.18l-4.73-5.14s-3.63 3.62-7.83 3.28c0 0 7.76-3 7.16-4.07-.12-.22-2.62-2.61-2.62-2.61s-6.34 6.26-12.82 5.53c0 0 9.73-2.3 11.87-6.44l-4-3.38s-6.38 6.94-13.79 6.4c0 0 10.08-2.77 12.86-7.08l-4.38-2.79s-6.35 6.65-12.51 6.15c0 0 11.33-4.37 11.47-6.72 0 0-4.18-2.32-5.59-2.4 0 0-4.67 4.66-8.22 4.06 0 0 7.26-3.73 7-4.57 0 0-6.24-1.57-9.83-.7a19.51 19.51 0 0 1 10-.29 10.73 10.73 0 0 0-4.5-4.2s3.76-.75 6 4.6c0 0 4.81 1.42 5.31 2.08 0 0-1.47-5.59-4.1-8.36 0 0 4.4 1.7 5.29 9.06l4.46 2.71s-1.56-7.5-3.72-10.14c0 0 4.22 2.43 4.79 10.91l4 3.27s-.85-6.56-2.61-10c0 0 3.43 3.1 3.71 11l2.38 2.5s-.7-4.78-1-6.14 0-1.55 0-1.55a16.39 16.39 0 0 1 2.05 8.72s4.56 5.38 4.92 5.14zM643.87 332.2s-20.43-32.18-39.4-12.92c0 0-4.34 2-3.58 6.75 0 0 1.65-1.1 3.35 2.4a17.12 17.12 0 0 0 2.26 3.46 8.54 8.54 0 0 0 4.65 2.88s9.85 6.08 26.45-.8c0 0 4.89.26 5.61-.41l-6-3.6s-2.47 4.5-6.6 5.35c0 0 6.62-5 5.73-5.92-.17-.18-3.25-1.76-3.25-1.76s-4.33 7.78-10.75 8.91c0 0 8.69-4.95 9.59-9.53l-4.79-2.11s-4.17 8.45-11.43 10c0 0 8.9-5.49 10.35-10.41l-5-1.44s-4.22 8.17-10.27 9.42c0 0 9.64-7.38 9.11-9.68 0 0-4.66-1.05-6-.73 0 0-3.17 5.79-6.75 6.21 0 0 5.92-5.62 5.43-6.36 0 0-6.43.25-9.63 2.1a19.46 19.46 0 0 1 9.54-3.1 10.73 10.73 0 0 0-5.49-2.77s3.39-1.77 7 2.73c0 0 5 0 5.69.5 0 0-3-5-6.29-6.87 0 0 4.7.4 7.62 7.21l5.05 1.34s-3.61-6.75-6.42-8.68c0 0 4.73 1.14 7.66 9.13l4.72 2s-2.66-6.05-5.33-8.88c0 0 4.16 2 6.65 9.51l3 1.73s-2-4.39-2.71-5.6-.43-1.49-.43-1.49a16.4 16.4 0 0 1 4.41 7.79s5.98 3.98 6.25 3.64z",
                fill: "#4285f4",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M778.14 167.78s-19.43-32.79-39-14.13c0 0-4.4 1.9-3.78 6.64 0 0 1.67-1.06 3.27 2.49a17.28 17.28 0 0 0 2.15 3.54 8.49 8.49 0 0 0 4.56 3s9.65 6.38 26.46 0c0 0 4.88.41 5.62-.24l-5.87-3.78s-2.6 4.41-6.76 5.14c0 0 6.77-4.83 5.92-5.74-.18-.19-3.2-1.87-3.2-1.87s-4.57 7.65-11 8.58c0 0 8.84-4.68 9.87-9.22l-4.72-2.22s-4.43 8.33-11.74 9.66c0 0 9.07-5.21 10.67-10.08l-4.94-1.6s-4.48 8-10.56 9.1c0 0 9.86-7.08 9.4-9.39 0 0-4.62-1.2-6-.92 0 0-3.35 5.69-6.94 6 0 0 6.09-5.42 5.63-6.18 0 0-6.44.05-9.69 1.8a19.52 19.52 0 0 1 9.63-2.8 10.75 10.75 0 0 0-5.41-2.94s3.45-1.67 7 2.94c0 0 5 .17 5.67.68 0 0-2.83-5-6.07-7.06 0 0 4.68.54 7.39 7.44l5 1.5s-3.39-6.86-6.15-8.88c0 0 4.7 1.29 7.38 9.36l4.65 2.17s-2.47-6.13-5-9c0 0 4.09 2.13 6.36 9.71l2.93 1.82s-1.88-4.45-2.54-5.68-.38-1.5-.38-1.5a16.43 16.43 0 0 1 4.17 7.92s5.73 4.07 6.02 3.74zM655.21 236.73s1-38.1-25.47-32.73c0 0-4.74-.73-6.74 3.61 0 0 2 0 1.44 3.85a17.56 17.56 0 0 0-.06 4.14 8.55 8.55 0 0 0 2.25 5s4.77 10.54 22.38 14.12c0 0 3.91 2.95 4.89 2.79l-3-6.32s-4.55 2.34-8.46.75c0 0 8.3-.49 8.07-1.71 0-.25-1.72-3.29-1.72-3.29s-7.94 4.05-13.89 1.39c0 0 10 .75 13.27-2.54l-2.79-4.43s-8.18 4.68-15.08 1.92c0 0 10.45.42 14.41-2.85l-3.33-4s-8.07 4.42-13.79 2.08c0 0 12.12-.73 13-2.94 0 0-3.28-3.47-4.6-4 0 0-5.86 3-9.06 1.38 0 0 8-1.34 8.05-2.23 0 0-5.47-3.39-9.16-3.64a19.47 19.47 0 0 1 9.65 2.76 10.75 10.75 0 0 0-3-5.37s3.81.43 4.33 6.2c0 0 4.17 2.82 4.44 3.6 0 0 .29-5.77-1.38-9.21 0 0 3.68 2.95 2.3 10.23l3.43 3.94s.78-7.62-.47-10.79c0 0 3.28 3.59 1.26 11.85l2.77 4.31s1.18-6.51.55-10.34c0 0 2.32 4 .2 11.61l1.52 3.1s.77-4.77.87-6.16.48-1.48.48-1.48a16.42 16.42 0 0 1-.69 8.93s2.69 6.6 3.13 6.47z",
                fill: "#4285f4"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
                cx: 698.97,
                cy: 716.3,
                rx: 26.93,
                ry: 4.55,
                fill: "#4285f4",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
                cx: 600.8,
                cy: 785.38,
                rx: 26.93,
                ry: 4.55,
                fill: "#4285f4",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
                cx: 93.14,
                cy: 749.99,
                rx: 26.93,
                ry: 4.55,
                fill: "#4285f4",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
                cx: 805.06,
                cy: 780.83,
                rx: 26.93,
                ry: 4.55,
                fill: "#4285f4",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
                cx: 833.1,
                cy: 723.1,
                rx: 40.21,
                ry: 6.8,
                fill: "#4285f4"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M849.77 711.97a11.61 11.61 0 0 0 3.83-5.78c.5-2.3-.48-5.05-2.67-5.89-2.46-.94-5.09.76-7.09 2.48s-4.27 3.69-6.88 3.33a10.5 10.5 0 0 0 3.24-9.81 4.11 4.11 0 0 0-.9-2c-1.37-1.46-3.84-.83-5.48.32-5.2 3.66-6.65 10.72-6.68 17.08-.52-2.29-.08-4.68-.09-7s-.66-5-2.65-6.22a7.91 7.91 0 0 0-4-1c-2.34-.08-4.95.15-6.54 1.86-2 2.12-1.47 5.69.25 8s4.35 3.8 6.77 5.42a15.13 15.13 0 0 1 4.84 4.61 4.7 4.7 0 0 1 .35.82h14.66a40.44 40.44 0 0 0 9.04-6.22z",
                fill: "#4285f4"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M75.06 728.84s15.35-.47 20-3.77 23.63-7.23 24.78-1.94 23.08 26.29 5.74 26.43-40.29-2.7-44.91-5.52-5.61-15.2-5.61-15.2z",
                fill: "#a8a8a8"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M125.87 747.72c-17.34.14-40.29-2.7-44.91-5.52-3.52-2.14-4.92-9.83-5.39-13.38h-.51s1 12.39 5.59 15.2 27.57 5.66 44.91 5.52c5 0 6.73-1.82 6.64-4.46-.7 1.61-2.61 2.61-6.33 2.64z",
                opacity: 0.2
            })
        ]
    }));
};
var BlankIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 999 834",
        "data-name": "Layer 1",
        width: 998.95,
        height: 833.99
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("defs", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                    id: "prefix__a",
                    x1: 499.14,
                    y1: 857.42,
                    x2: 499.14,
                    y2: 171.42,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                            offset: 0,
                            stopColor: "gray",
                            stopOpacity: 0.25
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                            offset: 0.54,
                            stopColor: "gray",
                            stopOpacity: 0.12
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                            offset: 1,
                            stopColor: "gray",
                            stopOpacity: 0.1
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("title", {
                children: "blank canvas"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M323.83 29.66c29.21-26 75.06-31.33 116.8-29.26 131.09 6.52 249.42 69.8 351.78 141.39 37.06 25.91 73.54 53.84 97.59 89.53 49 72.65 34.44 173.29-33.64 233.14-23.17 20.36-51.25 36-80.08 49.81-51.26 24.6-106.57 44.35-164.75 50-41.48 4-83.48.75-124.73-4.84-115.23-15.66-228.32-50.22-323.15-109.34-41.58-25.93-80.77-58.17-97.91-100.1s-6.17-95.13 36.29-120c17.56-10.27 38.56-14.91 59.11-19.27 30.26-6.41 61-12.73 88.3-25.76 28.21-13.46 61.6-39.49 56-69.29-5.96-31.93-10.78-60.01 18.39-86.01z",
                fill: "#4285f4",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M684.95 668.89s25.06-44.39 62.79-57.18a77.24 77.24 0 0 0 39.12-29.26 129.52 129.52 0 0 0 11.54-20.76",
                fill: "none",
                stroke: "#535461",
                strokeMiterlimit: 10,
                strokeWidth: 2
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M822.14 553.48c-4.3 4.18-24.33 8.49-24.33 8.49s4.91-19.89 9.21-24.06a10.852 10.852 0 0 1 15.12 15.57zM810.81 589.47c-5.88 1.17-25-6.09-25-6.09s14.94-14 20.81-15.2a10.853 10.853 0 0 1 4.23 21.29zM769.56 628.41c-5.67-2-18.54-17.9-18.54-17.9s20-4.56 25.64-2.6a10.85 10.85 0 1 1-7.1 20.5zM731.71 650.85c-5.91-1-21.29-14.51-21.29-14.51s18.91-7.88 24.82-6.9a10.85 10.85 0 1 1-3.53 21.41zM769.07 567.84c0 6 10.84 23.37 10.84 23.37s10.86-17.37 10.86-23.36a10.85 10.85 0 1 0-21.7 0zM725.14 594.64c1.8 5.72 17.34 19.06 17.34 19.06s5.16-19.83 3.37-25.55a10.852 10.852 0 0 0-20.71 6.49zM686.02 626.54c.8 5.94 13.87 21.72 13.87 21.72s8.44-18.67 7.64-24.61a10.852 10.852 0 0 0-21.51 2.89z",
                fill: "#4285f4"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M822.14 553.48c-4.3 4.18-24.33 8.49-24.33 8.49s4.91-19.89 9.21-24.06a10.852 10.852 0 0 1 15.12 15.57zM810.81 589.47c-5.88 1.17-25-6.09-25-6.09s14.94-14 20.81-15.2a10.853 10.853 0 0 1 4.23 21.29zM769.56 628.41c-5.67-2-18.54-17.9-18.54-17.9s20-4.56 25.64-2.6a10.85 10.85 0 1 1-7.1 20.5zM731.71 650.85c-5.91-1-21.29-14.51-21.29-14.51s18.91-7.88 24.82-6.9a10.85 10.85 0 1 1-3.53 21.41zM769.07 567.84c0 6 10.84 23.37 10.84 23.37s10.86-17.37 10.86-23.36a10.85 10.85 0 1 0-21.7 0zM725.14 594.64c1.8 5.72 17.34 19.06 17.34 19.06s5.16-19.83 3.37-25.55a10.852 10.852 0 0 0-20.71 6.49zM686.02 626.54c.8 5.94 13.87 21.72 13.87 21.72s8.44-18.67 7.64-24.61a10.852 10.852 0 0 0-21.51 2.89z",
                opacity: 0.25
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M686.39 667.99s4.92-50.74 34.24-77.72a77.24 77.24 0 0 0 23.9-42.61 129.14 129.14 0 0 0 2.14-23.67",
                fill: "none",
                stroke: "#535461",
                strokeMiterlimit: 10,
                strokeWidth: 2
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M765.04 506.91c-2.24 5.56-18.8 17.62-18.8 17.62s-3.56-20.18-1.32-25.73a10.85 10.85 0 1 1 20.12 8.11zM769.27 544.4c-4.9 3.45-25.36 4.57-25.36 4.57s8-18.87 12.87-22.32a10.852 10.852 0 0 1 12.49 17.75zM747.34 596.72c-6 .5-24.2-8.86-24.2-8.86s16.41-12.26 22.34-12.77a10.853 10.853 0 0 1 1.82 21.63zM721.83 632.57c-5.8 1.5-25.34-4.64-25.34-4.64s14.09-14.87 19.89-16.37a10.85 10.85 0 1 1 5.45 21zM722.35 541.53c2.42 5.48 19.38 17 19.38 17s2.89-20.28.46-25.76a10.85 10.85 0 0 0-19.84 8.78zM693.05 583.84c3.95 4.5 23.57 10.4 23.57 10.4s-3.31-20.22-7.27-24.72a10.85 10.85 0 1 0-16.3 14.32zM670.21 628.86c3.14 5.11 21.48 14.23 21.48 14.23s.15-20.48-3-25.59a10.85 10.85 0 1 0-18.49 11.36z",
                fill: "#4285f4"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
                cx: 374.17,
                cy: 814.05,
                rx: 118.88,
                ry: 19.93,
                fill: "#4285f4",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
                cx: 608.16,
                cy: 661.06,
                rx: 118.88,
                ry: 19.93,
                fill: "#4285f4",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                fill: "#b77b7f",
                d: "M616.05 398.03l-.11 3.89-6.76 238.52h-11.36l5.57-238.52.11-4.49 12.55.6z"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                fill: "#dda2a6",
                d: "M681.82 600.09l-8.51-.02-126.44-.27-6.74-.01 3.59-11.06h137.2l.9 11.36z"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                opacity: 0.1,
                d: "M616.05 398.03l-.11 3.89h-12.55l.11-4.49 12.55.6z"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                fill: "#b77b7f",
                d: "M599.77 392.2h21.07v7.93h-21.07z"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                opacity: 0.1,
                d: "M547.99 588.73l-1.12 11.07-6.74-.01 3.59-11.06h4.27z"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                fill: "#dda2a6",
                d: "M566.14 392.05l-.35 3.44-28.05 276.64-12.85-.61 29.56-276.03.33-3.14 11.36-.3z"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                opacity: 0.1,
                d: "M681.82 600.09l-8.51-.02-1.15-11.34h8.76l.9 11.36z"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                fill: "#dda2a6",
                d: "M695.27 671.52l-12.86.61-28.04-276.64-.35-3.44 11.35.3.33 3.14 29.57 276.03z"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                fill: "#fff",
                d: "M466.6 119.3h283.36V391H466.6z"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M613.81 28.43v65.61h-11.05V28.43a5.53 5.53 0 1 1 11.05 0z",
                fill: "#dda2a6"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                opacity: 0.1,
                d: "M602.75 88.07h11.06v5.97h-11.06z"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M618.15 92.55v21.66h-19.67V92.55a2.68 2.68 0 0 1 2.69-2.69h14.31a2.69 2.69 0 0 1 2.67 2.69z",
                fill: "#dda2a6"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("circle", {
                cx: 608.28,
                cy: 103.61,
                r: 4.18,
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("circle", {
                cx: 608.28,
                cy: 102.71,
                r: 4.18,
                fill: "#b77b7f"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                opacity: 0.1,
                d: "M598.42 111.53h19.73v2.69h-19.73zM590.35 115.12h35.87v5.98h-35.87z"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                fill: "#dda2a6",
                d: "M590.35 113.32h35.87v5.98h-35.87z"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M535.72 384h150.65a6.5 6.5 0 0 1 6.5 6.5v1.42H529.22v-1.42a6.5 6.5 0 0 1 6.5-6.5zM554.78 392.35l11.36-.3-.35 3.44h-11.34l.33-3.14zM599.77 392.2h21.07v3.29h-21.07zM665.7 395.49h-11.33l-.35-3.44 11.35.3.33 3.14z",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M535.72 385.77h150.65a6.5 6.5 0 0 1 6.5 6.5v1.42H529.22v-1.42a6.5 6.5 0 0 1 6.5-6.5z",
                fill: "#dda2a6"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M603.21 292.64c-2.27-1.2-27-19.88-27-19.88l-39.91-25.31s-.21-.6-.59-1.63c10.95-12.43 8.56-30.47-2.58-43.15-13.5-15.38-74.5-48.49-92.88-20.17-2.57 4-2.66 8.54-3.33 12.94-1.57 10.27-6.63 20.22-14.57 28.6-6.12 6.47-14.15 12.43-17.67 19.75 0-.09-.07-.18-.1-.28a18.36 18.36 0 0 0-1.83 5c-1.75 8.93 4.25 17.49 7.44 26.18a47.5 47.5 0 0 1 2.32 9.08c.08-.62.15-1.23.22-1.85a58.06 58.06 0 0 1 .79 13.36c-22.15 4.51-22.16 42.4-22.16 42.4s-2.73 15.06-2.27 20.49.45 17.17.45 20-2.73 20.48-3 22.6a.51.51 0 0 1 0 .09c-.4 2.32-4.55 13.5 5.48 16 .7.18 1.44.33 2.21.47.43 9.05 1.21 28 .52 32.22 0 0 3.65 25.46 6.68 31.93a73.44 73.44 0 0 0 6.7 10.82 11.92 11.92 0 0 1-1.54 4.39c-1.55 2.23-.75 4.06 1.84 4.85-.09.77-.19 1.64-.3 2.62-1.11 9.82-2.77 29.34.05 39.23 3.87 13.56 4.1 18.08 4.1 18.08s0 4.06 1.6 6.32 4.55 23.28 4.55 26.67 7.74 33.89 5.46 41.12-.45 17.4-.45 17.4-1.37 17.85-3 21.69-2.28 65.75.22 81.79 4.1 29.37 4.1 29.37-1.59 14.69-.23 16.72 3.87 14.24 2.05 14.91-2.73 5.65-2.73 5.65a50.39 50.39 0 0 0 3.11 4.23 17 17 0 0 1-2.05-.87c.72 1 1.8 2.42 3.13 4l-1.25 16.25a2.72 2.72 0 0 0 2 2.85 22.87 22.87 0 0 0 22.62-6.36c11.38-11.52 15.25-9.94 17.3-16.94.22-.75.41-1.49.57-2.19 1.47-6.24-5.18-10.88-10.47-8.22.73-4.94 1.3-10.55.75-13.72-1.14-6.55-.91-23.72-.91-23.72l-1.59-82.25s2.95-16.27 6.37-22.59 3-28.47 3-28.47l3.87-72.76 3.64-35.47s3.64-12.2 8.19 1.36c0 0-2.5 27.33-1.36 33.89s2.73 38.41 1.59 45.41-6.14 45.42-3 55.13S486 694.15 485.3 698s-3 87.21-3 87.21 6.15 16 1.6 21.24-.23 26-.23 26 .55.39 1.49.93l-.13 1.73-1.43 18.69a2.74 2.74 0 0 0 2 2.86 22.86 22.86 0 0 0 22.62-6.36c11.38-11.53 15.25-9.94 17.3-16.95.22-.75.41-1.48.58-2.19 1.6-6.81-6.5-11.75-11.92-7.3l-.27.23a9.41 9.41 0 0 1-.89.67 4.3 4.3 0 0 1-.45.29c1.14-5.16 2.8-14 2-18.14-1.14-6.1 1.13-24.62 1.13-24.62s6.6-22.15 6.83-31l1.82-70.49s-.22-28.7.69-35.7 8.19-67.56 15.47-85.64c5.59-13.84 8.09-49.16 6.61-67.07-.08-.88-.16-1.73-.26-2.52 8.93-6.59 9.82-17.55 9.82-17.55s-8.2-15.66-16.09-22.29-9.59-18.03-9.31-22.88a11.88 11.88 0 0 0-2.73-8.13s-3.64-11.75-6.07-12.95a1.9 1.9 0 0 1-.53-.4c-1.65-1.77-.38-6.83-.38-6.83v-.16c.29-1.17 2-8.75 1.49-10.69-.61-2.1.3-12.05.3-12.05s5.77-17.17 4.86-30.73 11.84-12.35 11.84-12.35l39.37-.41h4.48a31.53 31.53 0 0 0 4.31-4.46c7.5-.89 22.67-3.72 24.37-12 2.31-10.99-7.1-22.14-9.38-23.35zM420.81 418l.27-6.89c.93.8 1.55 1.31 1.55 1.31a10.78 10.78 0 0 1 .07 5.52 5.89 5.89 0 0 1-3.41 3.82 4.14 4.14 0 0 0-.55.29l-.38-3.89zm142.8-121c-1.67-.75-7.29-.6-10.18-.6s-7.58-2.41-7.58-2.41c-1-1.95-6.53-3.11-11.45-3.77-3.74-9.22-9-18.21-9.71-27.82 0-.35 0-.7-.05-1.05l.57 1s22.92 14.62 25.5 19c2 3.34 11.63 10.8 16.09 14.14a4.59 4.59 0 0 1-2.45 1.64 1.35 1.35 0 0 1-.74-.13z",
                transform: "translate(-100.52 -33.01)",
                fill: "url(#prefix__a)"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M425.24 798.21c-.17.7-.35 1.43-.57 2.17-2 7-5.83 5.38-17 16.81a22.38 22.38 0 0 1-22.27 6.32 2.7 2.7 0 0 1-2-2.84l1.41-18.54.67-8.92s17.84 5 26.92-1.35a10.77 10.77 0 0 0 .88-.67 2.75 2.75 0 0 0 .2-.2 7.29 7.29 0 0 1 11.76 7.22zM369.24 791.21c-.17.7-.35 1.43-.57 2.17-2 7-5.83 5.38-17 16.81a22.38 22.38 0 0 1-22.27 6.32 2.7 2.7 0 0 1-2-2.84l1.41-18.54.67-8.92s17.84 5 26.92-1.35a10.77 10.77 0 0 0 .88-.67 2.75 2.75 0 0 0 .2-.2 7.29 7.29 0 0 1 11.76 7.22z",
                fill: "#67647e"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M350.81 793.99l.72 9.64c-10.24 10.23-22.43-5-26-10 9.39 4.84 25.28.36 25.28.36zM411 797.91l1.34-.89c-9.35 14.22-23.24 7.66-27.57 5.11l.67-8.92s17.84 5 26.92-1.35c-.71 3.48-1.36 6.05-1.36 6.05z",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M439.48 528.68c-7.18 17.93-14.35 78-15.25 85s-.67 35.42-.67 35.42l-1.8 69.89c-.23 8.75-6.73 30.72-6.73 30.72s-2.24 18.38-1.12 24.43-2.91 22-2.91 22l1.34-.9c-11.21 17-28.92 4.26-28.92 4.26s-4.26-20.62.23-25.78-1.57-21.07-1.57-21.07 2.24-82.72 2.91-86.53-2.69-15.47-5.83-25.11 1.8-47.75 2.92-54.7-.45-38.56-1.57-45.06 1.34-33.63 1.34-33.63c-4.48-13.45-8.07-1.34-8.07-1.34l-3.59 35.19-3.81 72.19s.45 22-2.91 28.25-6.28 22.41-6.28 22.41l1.57 81.61s-.22 17 .9 23.53-2.47 23.32-2.47 23.32c-12.55 29.57-32.71-2.49-32.71-2.49s.9-4.93 2.69-5.6-.67-12.78-2-14.8.22-16.59.22-16.59-1.57-13.22-4-29.14-1.79-77.34-.22-81.15 2.91-21.52 2.91-21.52-1.79-10.09.45-17.27-5.38-37.43-5.38-40.8-2.91-24.21-4.48-26.45-1.57-6.28-1.57-6.28-.22-4.48-4-17.93c-2.78-9.82-1.14-29.18-.05-38.93.39-3.61.73-5.91.73-5.91s128.57-20.85 133.7-16.14c1.2 1.11 2 4.92 2.47 10.35 1.53 17.76-.99 52.86-6.47 66.55z",
                fill: "#444053"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M390.82 629.48c.6 0 14.8 1.2 20 .15s-20-.15-20-.15zM391.87 637.85s19.61 3.44 20.61 1.65-20.61-1.65-20.61-1.65zM331.94 634.26s10.16.45 15.69 3-15.69-3-15.69-3z",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M295.02 382.89s1.64 31.23.75 36.76c0 0 3.58 25.26 6.57 31.68s9.42 14.5 9.42 14.5l8.82-62-2.1-21.24z",
                fill: "#efb7b9"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("circle", {
                cx: 387.68,
                cy: 206.09,
                r: 34.52,
                fill: "#efb7b9"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M369.75 222.22s-10.76 21.08-21.52 30.94 64.56 21.07 66.35 21.07-13.45-44.83-10.76-50.24-34.07-1.77-34.07-1.77z",
                fill: "#efb7b9"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M445.97 462.13a22.43 22.43 0 0 1-5.54 3.1c-13.74 5.38-28.69 12.85-38.85 9.87s-31.68 0-31.68 0-43.35-3.59-52-1.5c-3.94.95-7 .91-9 .23.39-3.61.73-5.91.73-5.91s128.72-20.85 133.85-16.14c1.22 1.11 2 4.92 2.49 10.35z",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M455.38 442.21s-1.19 14.95-14.95 20.33-28.69 12.85-38.85 9.87-31.68 0-31.68 0-43.35-3.59-52-1.5-13.16-.59-10.47-4.48 2.4-16.74 2.4-22.12-3-27.2-.31-31.09 5.08-18.83 10.46-21.23a5.86 5.86 0 0 0 3.36-3.79 10.84 10.84 0 0 0-.07-5.47s-.91-.75-2.16-1.86c-3.17-2.83-8.53-8.08-6.81-9.8 2.39-2.4 0-17.94 0-17.94s-5.68-11.95-3.58-16.43-18.24-28.1-18.24-28.1 0-40.64 24.51-42.44c0 0 17.34.6 19.43-7.17s15.84-12.26 15.84-12.26l31.39 6.88s27.79 6 32.88 2.39 9 4.78 9 4.78 17.33.9 19.12 4.49-5.67 38.55-5.67 38.55-12.56-1.19-11.66 12.26-4.84 30.49-4.84 30.49-.9 9.86-.3 11.95c.56 1.93-1.18 9.45-1.46 10.61v.15s-1.25 5 .37 6.78a2 2 0 0 0 .52.4c2.4 1.19 6 12.85 6 12.85a11.83 11.83 0 0 1 2.69 8.07c-.29 4.79 1.5 16.14 9.27 22.72s15.81 22.11 15.81 22.11z",
                fill: "#a36468"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M322.07 372.99v1.27l-.54 14s-18.39 1.49-28.4-1-5.8-13.6-5.4-15.9a.37.37 0 0 0 0-.09c.29-2.1 3-19.58 3-22.42s0-14.5-.45-19.88 2.2-20.37 2.2-20.37l1.94-2.38 21.06 8.07z",
                fill: "#a36468"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M322.02 374.29l-.54 14s-18.39 1.49-28.4-1-5.8-13.6-5.4-15.9z",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M323.34 388.21a10.84 10.84 0 0 0-.07-5.47s-.91-.75-2.16-1.86c15.83-2.21 78.52-10.81 99.63-11.75v.15s-1.25 5 .37 6.78zM423.1 398.99s3.89 22-10.61 29.74c-.01.04 8.22-10.87 10.61-29.74zM328.2 429.36s35-6 41.85-1.34-41.85 1.34-41.85 1.34zM411 293.21s-5.38 22.12-1.35 27.2 1.35-27.2 1.35-27.2zM309.67 275.13s4.93 8.22 1.94 16.74-1.94-16.74-1.94-16.74zM299.48 347.17s6.28 3.73 4.19 9.56-4.19-9.56-4.19-9.56zM298.91 330.13s5.82 3.14 6.57 7.77-6.57-7.77-6.57-7.77zM385.29 508.87s36.62 3.74 43.94-4.93c0 .05-33.03 6.58-43.94 4.93zM322.07 506.78s39.31 9.27 47.08 1.94c0 0-33.78 2.54-47.08-1.94zM388.13 520.99s16.44 0 24.06.45-24.06-.45-24.06-.45zM324.76 527.99s8.07 9.12 17.19 7.48-17.19-7.48-17.19-7.48z",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M340.61 154.64c-2.53 3.93-2.62 8.48-3.28 12.84-1.54 10.19-6.53 20.06-14.34 28.38-7.17 7.62-17 14.53-18.86 23.84-1.76 8.84 4.21 17.35 7.34 26 8.25 22.69-3.27 46.49-6.63 69.91-.93 6.47.19 14.74 8.16 16.89 2.49.68 5.34.59 7.58 1.67 3 1.44 3.92 4.43 4.47 7.12a108.82 108.82 0 0 1 2.06 29.28c-.36 5.5-.76 11.83 4.44 15.61 2.36 1.73 5.54 2.61 8.61 3.44 8.19 2.21 18.78 4 24.3-1.19 2.32-2.17 3.19-5.23 6.08-6.95 4.33-2.57 10.47-.83 15.92-.56 11.19.56 21.47-6 25.88-13.91s4-17 2.4-25.53-4.46-17-4.66-25.66c-.07-3 .2-6.05 1.92-8.71 3.33-5.15 11.08-7.49 16.38-11.54 9.93-7.6 9.9-20.05 6.29-30.47s-10.09-20.41-10.89-31.18a11.87 11.87 0 0 1 1.47-7.53c1.42-2.19 3.9-3.83 6-5.64 14.49-12.24 12.78-32.34.8-46.1-13.26-15.25-73.34-48.1-91.44-20.01z",
                fill: "#e3787d"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("g", {
                opacity: 0.1,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M313.31 255.12c1.13-9.09.92-18.1-2.29-26.95-1.58-4.34-3.87-8.65-5.54-13a18.76 18.76 0 0 0-1.8 5c-1.76 8.84 4.21 17.35 7.34 26a47.28 47.28 0 0 1 2.29 8.95zM326.66 353.04a109.22 109.22 0 0 0-2.05-29.28c-.56-2.69-1.48-5.67-4.48-7.11-2.24-1.08-5.09-1-7.58-1.67a10.33 10.33 0 0 1-7-5.78c-.46 2.28-.86 4.55-1.19 6.83-.93 6.47.19 14.74 8.16 16.89 2.49.67 5.34.58 7.58 1.66 3 1.44 3.92 4.43 4.48 7.12a110.81 110.81 0 0 1 1.92 13.52c.07-.74.11-1.46.16-2.18zM411.9 349.49c-4.42 7.94-14.7 14.47-25.89 13.91-5.45-.28-11.59-2-15.91.56-2.89 1.71-3.77 4.78-6.09 6.95-5.52 5.15-16.11 3.4-24.3 1.19-3.07-.84-6.24-1.71-8.61-3.44a10.8 10.8 0 0 1-4.25-6.9c.06 3.07 0 6.15-.19 9.22-.36 5.5-.76 11.83 4.44 15.62 2.37 1.72 5.54 2.6 8.61 3.43 8.19 2.21 18.78 4 24.3-1.19 2.32-2.17 3.2-5.23 6.09-7 4.32-2.57 10.46-.83 15.91-.56 11.19.56 21.47-6 25.89-13.91 4.24-7.64 4.05-16.28 2.57-24.53a26.87 26.87 0 0 1-2.57 6.65zM430.84 203.27c-2.14 1.8-4.62 3.45-6 5.64a11.87 11.87 0 0 0-1.47 7.53 40.06 40.06 0 0 0 2.06 9.6 39.94 39.94 0 0 1 5.45-4.84c9.8-8.27 12.18-20.14 9-31.22a28.54 28.54 0 0 1-9.04 13.29zM427.93 278.04c-5.29 4.05-13.05 6.4-16.37 11.55-1.73 2.66-2 5.73-1.93 8.7a60.08 60.08 0 0 0 1.28 10.4 9.62 9.62 0 0 1 .65-1.17c3.32-5.15 11.08-7.49 16.37-11.54 9.07-6.94 9.83-17.92 7.15-27.71a20.76 20.76 0 0 1-7.15 9.77z"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M482.28 299.34s25.86-1.34 28.1-12.25-7-22-9.26-23.17-26.64-19.73-26.64-19.73l-39.3-25.1s-18.83-54-23-33.33 12.11 48.12 12.11 48.12 22.56 14.5 25.1 18.83 18.09 15.69 18.09 15.69z",
                fill: "#efb7b9"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M496.18 281.7c-6.12 15.55-14.05 21.68-14.05 21.68h-4.41l-38.77.4-4.47-12.21 6.28-26.46 3.88.16s4.64 2.39 7.47 2.39 8.38-.15 10 .59a1.23 1.23 0 0 0 .73.11c1.47-.15 3-2.35 3-2.35s36.47.15 30.34 15.69z",
                fill: "#a36468"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M496.18 281.7c-6.12 15.55-14.05 21.68-14.05 21.68h-4.41c2.3-6.16 7.15-18.8 9-21.72 1.81-2.76-14.43-9.63-23.93-13.34 1.47-.15 3-2.35 3-2.35s36.52.19 30.39 15.73z",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
                cx: 90.82,
                cy: 763.14,
                rx: 44.18,
                ry: 8.64,
                fill: "#4285f4",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
                cx: 827.28,
                cy: 706.15,
                rx: 32.18,
                ry: 6.29,
                fill: "#4285f4",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
                cx: 966.77,
                cy: 731.64,
                rx: 32.18,
                ry: 6.29,
                fill: "#4285f4",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
                cx: 750.78,
                cy: 784.14,
                rx: 32.18,
                ry: 6.29,
                fill: "#4285f4",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M132.57 523.3s7.24 9.47-3.34 23.75-19.29 26.34-15.75 35.25c0 0 15.95-26.53 28.94-26.9s4.44-16.14-9.85-32.1z",
                fill: "#4285f4"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M132.57 523.3a11.79 11.79 0 0 1 1.48 3c12.67 14.89 19.42 28.78 7.24 29.13-11.34.32-24.95 20.61-28.21 25.73a9.44 9.44 0 0 0 .39 1.17s15.95-26.53 28.94-26.9 4.45-16.17-9.84-32.13z",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M146.02 535.36c0 3.33-.37 6-.83 6s-.84-2.7-.84-6 .47-1.76.93-1.76.74-1.61.74 1.76z",
                fill: "#ffd037"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M150.64 539.34c-2.92 1.59-5.47 2.56-5.69 2.15s2-2 4.89-3.62 1.77-.43 2 0 1.72-.13-1.2 1.47z",
                fill: "#ffd037"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M94.36 523.3s-7.24 9.47 3.34 23.75 19.29 26.34 15.78 35.25c0 0-16-26.53-29-26.9s-4.41-16.14 9.88-32.1z",
                fill: "#4285f4"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M94.36 523.3a11.79 11.79 0 0 0-1.48 3c-12.67 14.89-19.42 28.78-7.24 29.13 11.34.32 25 20.61 28.21 25.73a11.41 11.41 0 0 1-.38 1.17s-16-26.53-29-26.9-4.4-16.17 9.89-32.13z",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M80.91 535.36c0 3.33.37 6 .83 6s.84-2.7.84-6-.47-1.76-.93-1.76-.74-1.61-.74 1.76z",
                fill: "#ffd037"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M76.29 539.34c2.93 1.59 5.47 2.56 5.7 2.15s-2-2-4.9-3.62-1.77-.43-2 0-1.72-.13 1.2 1.47z",
                fill: "#ffd037"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
                cx: 113.46,
                cy: 643.07,
                rx: 75.65,
                ry: 11.61,
                fill: "#4285f4",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M152.4 569.55l-.36 3-.51 4.17-.21 1.74-.51 4.18-.22 1.74-.51 4.17-5.78 47.44c-.52 4.24-7.44 7.54-15.8 7.54H98.48c-8.36 0-15.27-3.3-15.79-7.54l-5.79-47.45-.51-4.17-.21-1.74-.52-4.18-.21-1.74-.51-4.17-.36-3c-.29-2.4 3.45-4.42 8.18-4.42h61.52c4.67.01 8.42 2.03 8.12 4.43z",
                fill: "#65617d"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                fill: "#9d9cb5",
                d: "M152.03 572.5l-.5 4.18H75.39l-.5-4.18h77.14zM151.31 578.42l-.5 4.17H76.12l-.51-4.17h75.7zM150.59 584.33l-.51 4.17H76.84l-.51-4.17h74.26z"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("circle", {
                cx: 179.99,
                cy: 124.52,
                r: 31.5,
                fill: "#4285f4",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("circle", {
                cx: 113.99,
                cy: 49.52,
                r: 19.5,
                fill: "#4285f4",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("circle", {
                cx: 12,
                cy: 93.02,
                r: 12,
                fill: "#4285f4",
                opacity: 0.1
            })
        ]
    }));
};
var QuestionsIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        viewBox: "0 0 1004 837",
        "data-name": "Layer 1",
        width: 1003.92,
        height: 836.78
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("defs", {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("linearGradient", {
                    id: "prefix__a",
                    x1: 795.24,
                    y1: 863.66,
                    x2: 795.24,
                    y2: 394.91,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                            offset: 0,
                            stopColor: "gray",
                            stopOpacity: 0.25
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                            offset: 0.54,
                            stopColor: "gray",
                            stopOpacity: 0.12
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("stop", {
                            offset: 1,
                            stopColor: "gray",
                            stopOpacity: 0.1
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("title", {
                children: "questions"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
                cx: 713.5,
                cy: 826.66,
                rx: 102.56,
                ry: 10.11,
                fill: "#4285f4",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M439.53 12.24C484.7-4.55 539.69 9.89 586.65 30.95c147.49 66.16 254.94 191.75 340.31 319.7 30.91 46.33 60.27 94.7 71.89 146.42 23.66 105.27-38.05 214.25-143 252.44-35.69 13-74.9 18.33-114.17 21.3-69.83 5.29-142.13 3.19-211.4-16.4-49.4-14-96.13-36.52-140.95-61.4-125.17-69.52-239.48-159.8-321.79-270.08C31.44 374.56.9 320.03.02 264.22s35.49-111.89 95.33-121.38c24.74-3.92 50.91.16 76.44 4.36 37.59 6.19 75.69 12.7 112.85 10 38.39-2.81 88.32-17.81 95.32-54.46 7.41-39.35 14.46-73.73 59.57-90.5z",
                fill: "#4285f4",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M244.02 768.81s48.26-2.91 42.57 30.91c0 0 1.13 6-4.29 8.69 0 0-.08-2.51-4.95-1.66a21.8 21.8 0 0 1-5.24.26 10.93 10.93 0 0 1-6.41-2.65s-13.57-5.6-18.84-27.78c0 0-3.91-4.83-3.75-6.08l8.14 3.48s-2.78 5.88-.59 10.76c0 0 .26-10.54 1.83-10.3.31.05 4.23 2 4.23 2s-4.79 10.23-1.18 17.67c0 0-1.37-12.61 2.67-16.93l5.74 3.35s-5.6 10.57-1.8 19.19c0 0-1-13.23 3-18.38l5.2 4s-5.26 10.42-2.05 17.58c0 0 .41-15.41 3.17-16.57 0 0 4.55 4 5.24 5.66 0 0-3.6 7.56-1.37 11.55 0 0 1.37-10.26 2.5-10.31 0 0 4.52 6.8 5 11.46 0 0-.2-6.93-3.91-12.11 0 0 4.38.75 6.94 3.59 0 0-.71-4.81-8.05-5.23 0 0-3.74-5.15-4.75-5.47 0 0 7.31-.61 11.74 1.36 0 0-3.9-4.54-13.08-2.48l-5.13-4.18s9.63-1.32 13.7.14c0 0-4.69-4-15.08-1.09l-5.58-3.34s8.2-1.77 13.09-1.13c0 0-5.16-2.78-14.73.23l-4-1.79s6-1.18 7.77-1.37 1.85-.67 1.85-.67a20.82 20.82 0 0 0-11.29 1.25s-8.46-3.03-8.31-3.61z",
                fill: "#4285f4"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
                cx: 277.26,
                cy: 811.36,
                rx: 34.16,
                ry: 5.77,
                fill: "#4285f4",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M179.37 746.06s27.21-1.64 24 17.43a4.63 4.63 0 0 1-2.41 4.9s-.05-1.41-2.79-.93a12.13 12.13 0 0 1-2.95.14 6.06 6.06 0 0 1-3.62-1.49s-7.64-3.17-10.64-15.67c0 0-2.2-2.73-2.12-3.43l4.6 2s-1.57 3.32-.34 6.07c0 0 .15-5.95 1-5.81.18 0 2.39 1.15 2.39 1.15s-2.7 5.77-.66 10c0 0-.78-7.11 1.5-9.55l3.23 1.89s-3.15 6-1 10.82c0 0-.55-7.46 1.69-10.36l2.93 2.28s-3 5.87-1.15 9.91c0 0 .23-8.69 1.79-9.34 0 0 2.56 2.26 2.95 3.19 0 0-2 4.26-.77 6.51 0 0 .77-5.78 1.41-5.81 0 0 2.55 3.83 2.81 6.46a14 14 0 0 0-2.2-6.83 7.63 7.63 0 0 1 3.91 2s-.39-2.71-4.54-2.95c0 0-2.11-2.91-2.67-3.08 0 0 4.12-.35 6.62.76 0 0-2.2-2.56-7.38-1.4l-2.89-2.36s5.43-.74 7.73.08c0 0-2.65-2.26-8.51-.61l-3.14-1.89a28.57 28.57 0 0 1 7.37-.63s-2.9-1.57-8.3.13l-2.25-1s3.39-.67 4.38-.77 1.05-.38 1.05-.38a11.79 11.79 0 0 0-6.37.71s-4.74-1.81-4.66-2.14z",
                fill: "#4285f4"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
                cx: 198.11,
                cy: 770.04,
                rx: 19.26,
                ry: 3.26,
                fill: "#4285f4",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M848.78 764.39s32.85-2 29 21a5.64 5.64 0 0 1-2.92 5.92s-.06-1.71-3.37-1.13a14.81 14.81 0 0 1-3.57.17 7.35 7.35 0 0 1-4.36-1.8s-9.24-3.81-12.83-18.91c0 0-2.66-3.29-2.55-4.13l5.54 2.36s-1.89 4-.4 7.33c0 0 .18-7.18 1.24-7 .22 0 2.88 1.38 2.88 1.38s-3.26 7-.8 12c0 0-.93-8.58 1.82-11.52l3.9 2.27s-3.81 7.2-1.22 13.07c0 0-.67-9 2-12.51l3.54 2.76s-3.58 7.09-1.4 12c0 0 .29-10.48 2.17-11.28 0 0 3.09 2.73 3.56 3.85 0 0-2.45 5.15-.93 7.87 0 0 .93-7 1.7-7 0 0 3.08 4.63 3.4 7.8a16.81 16.81 0 0 0-2.65-8.24 9.29 9.29 0 0 1 4.72 2.44s-.48-3.27-5.49-3.56c0 0-2.54-3.51-3.22-3.72 0 0 5-.42 8 .92 0 0-2.66-3.08-8.91-1.68l-3.49-2.85s6.55-.9 9.33.09c0 0-3.2-2.73-10.27-.74l-3.8-2.27s5.58-1.2 8.91-.77c0 0-3.51-1.89-10 .16l-2.72-1.22s4.09-.81 5.29-.93 1.26-.46 1.26-.46a14.2 14.2 0 0 0-7.68.85s-5.78-2.14-5.68-2.52z",
                fill: "#4285f4"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("ellipse", {
                cx: 871.4,
                cy: 793.36,
                rx: 23.25,
                ry: 3.93,
                fill: "#4285f4",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M914.09 553.23a71.34 71.34 0 0 1-1.09-10.66c0-4.29-5.83-8.09-5.83-8.09s-3.6-8.33-6-9.56-9.81-12.13-9.81-12.13a9.91 9.91 0 0 0-2.23-5.88 84.52 84.52 0 0 1-6.07-9.16c-1-1.22-.5-2.08-2-9.19-.08-.37-.17-.73-.28-1.07 0-.16-.1-.3-.16-.46a12 12 0 0 0 2.83-12.43 5 5 0 0 0-1.42-2.2c-1.69-1.38-4.39-.81-6.13-2.12l1.85-8.18c.44-2 .67-4.53-1.08-5.61a9.08 9.08 0 0 0-2.06-.69c-3-1-4.74-4.17-5.52-7.22a24.74 24.74 0 0 1-.6-9c.34-2.9 1.19-5.72 1.5-8.63a23.7 23.7 0 0 0-3.67-15.34 11.81 11.81 0 0 0-4.85-4.58c-1.85-.83-4-1-5.73-2-3.72-2.37-3.53-8-6.5-11.23s-8.23-3.22-12.56-2.11-8.64 3-13.08 2.53c-2.86-.32-5.54-1.62-8.41-1.92a8.86 8.86 0 0 0-2.46.11v-.09c-2.12.38-4.07 1.56-4.57 3.57a5.45 5.45 0 0 0-.14 1.46c0 1.17.28 2.39.3 3.51a3.34 3.34 0 0 1-.81 2.47c-.57.61-1.41.93-2 1.56a2.5 2.5 0 0 0-.73 1.84c0 1.78 2.22 3.35 3.71 4.07h.06c-.4.4-.8.82-1.17 1.25a26.34 26.34 0 0 0-6.62 17.49A26.7 26.7 0 0 0 817 457.92l-.21.65a37.31 37.31 0 0 1-1.47 3.78 7.49 7.49 0 0 0-6.28.7c-2.86 2-8.45 1.84-9.94 1.47s-17-2.33-18.25-1.84-3.72-1.71-5.33 1.23-2.36 4.53-4 5.27-4.47 3.06-4.09 3.55-4.1 3.43-4.1 3.43-3.85 4-6.08 4.53-6.95 3.56-6.95 3.56l-5.47 4.28s-4.09.62-2.85-2.2-2.24-6.37-2.24-6.37-6.95-14.09-6.95-17-5.71-15.32-5.71-15.32l-.7-.07-.32-.91c-1.05-2.95-2.41-6.57-3.45-8.69-2-4.05-3.23-4.47-3.23-4.47s-24.08-18.08-39.72-12.57 28.55 21.93 32.52 23.65c1.39.6 2.39 2.54 3.09 4.81a20.58 20.58 0 0 0-8.55 7.69s9.56 21.19 9.81 26.46 6.58 20 6.58 20 2.36 10.91 15.14 10.29c0 0 17.63 3.24 21.48 0s7.32-5.78 9.19-6.15a7.25 7.25 0 0 0 3.47-2.45s-5.83 36.75-8.69 39.94-28.13 44.45-19.06 51.83a181.21 181.21 0 0 0 22.71 15c.77.38 3.08-3.47 6.38-6.2v2.13c.06 14.68 2 37 4.68 42 4 7.35 2.36 21.56 2.36 21.56a17 17 0 0 0 6.71 1.61c.12.48.26 1 .39 1.5 2.19 8.27 5.74 21.06 7.55 24.46 2.73 5.15 4.71 21.45 4.71 21.45s1.62 16 1 18.25c-.24.85.81 7.51 2.46 16-1 11.49-2.9 33.64-3.22 41.65V796.99a2.44 2.44 0 0 1 0 .27v.49a7.48 7.48 0 0 0 .06 1.51 4.9 4.9 0 0 1-.17 2.28 39.82 39.82 0 0 1-2.69 6.42 30.57 30.57 0 0 0-1.2 3.1c-1 .44-2.22 1.51-2.9 4.12-1.24 4.78-3.1 18-3.1 18s-.75 8.09-2.23 9.93-3 13.35 7.57 14.82 15.14-5.6 15.14-5.6l-.37-32.08v-.06a4.86 4.86 0 0 0 .55-.87v-.08c.07-.15.15-.31.22-.49l.09-.24.16-.39a.57.57 0 0 1 0-.14 21.2 21.2 0 0 0 .9-9.55V808.02v-.75-.19q0-.32.06-.66v-.12l.06-.39v-.17c0-.13 0-.26.08-.4a.44.44 0 0 1 0-.1c.1-.46.22-1 .35-1.44v-.11l.15-.48c.15-.51.32-1 .5-1.54v-.1c0-.16.11-.32.17-.47v-.06c.18-.49.37-1 .55-1.42l.05-.13.16-.4.05-.12.38-.89 2.93 9.05s1.62 6.74.75 8.33 1 8.21 2.23 8.33l-1.15 8.33a127.4 127.4 0 0 0-1.11 13.85c-.08.53-.16 1-.22 1.32-.8 4.27 1.12 10.89 1.12 10.89 9.8 11.59 21.48.9 21.48.9s1.36-6.13 0-7.35-.75-5.64-.75-5.64.62-10.91.74-18.87-6.51-15-6.51-15l-.37.33c-1.21-3.12-2.59-6.76-2.3-8.39.5-2.82-1.37-32.59-1.37-32.59a176.54 176.54 0 0 0 .44-24c.16-1.35.31-2.68.46-4 .75-6.4 1.36-11.87 1.6-14.74v-.34c.06-.77.09-1.32.08-1.58 0-1 0-2.14.1-3.39.23-3.44.77-7.27.77-7.27l2.6-15.81s2-7.72 4.85-12l.34-.54c.11-.19.22-.4.34-.62l.05-.09c.11-.21.23-.43.34-.66l.05-.09c.4-.79.83-1.7 1.28-2.7 0-.08.07-.15.1-.23l.34-.76c0-.1.08-.2.13-.3s.21-.51.32-.76a2.88 2.88 0 0 0 .13-.31c.13-.3.27-.61.4-.93l.19-.46c.09-.23.19-.46.29-.69l.24-.61c.07-.15.13-.3.19-.45l.27-.69c0-.1.09-.21.13-.31.71-1.77 1.39-3.52 2-5.11.19-.5.38-1 .55-1.44 6.36.39 10.68.74 10.68.74s2-14.33 1.36-23.76c-.42-6.44.78-14.54 1.57-19 .09-.49.17-.93.25-1.33l.17.14c3.11 2.45 5.34-5.64 5.34-5.64s-.84-7.55-2-16.7l-.12-.91a47 47 0 0 0 5.43.83s1-.09 2.37-.26a65.61 65.61 0 0 0 11.94 5.4l6.61-12.2a49.64 49.64 0 0 1 4.35-7.23c2-2.45 9.06-10.29 8.94-11.76s2.36-9.93 4.84-13.73 3.47-11.44 3.35-12.05zm-27.56 9.31c-2.61 1.1-5.09 7.23-5.21 9.07s-2.86 9.92-5.71 10.9c-2.63.9-7.65 5.52-8.45 6.26-.82.07-1.75.18-2.72.34-1.09-7.73-2.17-14.13-2.86-15.42-2-3.68 2.19-15.44 2.19-15.44s.41-11.88 3-14.7 2-9.93 2-9.93.62-2.94.87-4.28 3.69 0 3.72 0 6.7 3.67 7.7 9.18 8.32 15.07 8.32 15.07-1.12 3.31 0 5-.24 2.85-2.85 3.95z",
                transform: "translate(-98.04 -31.61)",
                fill: "url(#prefix__a)"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M608.96 426.22a20 20 0 0 1 20-9.42v14.31h-8.69l-6.8-1.72z",
                fill: "#4c4981"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M608.96 426.22a20 20 0 0 1 20-9.42v14.31h-8.69l-6.8-1.72z",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M629.61 420.59l-10.65 7.46s-.09-1.49-.36-3.53c-.53-3.86-1.72-9.65-4.29-10.77-3.91-1.72-47.44-18.1-32-23.61s39.13 12.55 39.13 12.55 1.22.42 3.17 4.45c1 2.12 2.37 5.73 3.4 8.68.95 2.66 1.6 4.77 1.6 4.77z",
                fill: "#ae6e79"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                fill: "#4c4981",
                d: "M714.69 432.08l1.21-.57 3.4 3.88-2.78 5.93-4.74-1.9 1.1-4.74 1.81-2.6z"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M698.58 779.39s-3.06-.36-4.28 4.41-3.06 18-3.06 18-.73 8.07-2.2 9.91-2.93 13.33 7.46 14.79 14.92-5.59 14.92-5.59l-.37-32.07zM734.84 780.83s6.54 7 6.42 14.94-.74 18.83-.74 18.83-.6 4.41.74 5.63 0 7.34 0 7.34-11.5 10.67-21.16-.9c0 0-1.88-6.61-1.1-10.87s2.96-23.41 2.96-23.41z",
                fill: "#444053"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M751.04 634.6s-6.6 18.46-9.42 22.74-4.76 12-4.76 12l-2.57 15.77a88 88 0 0 0-.86 10.64c.12 3.55-6.36 55.27-6.36 55.27l-10.27 13.09s-4.52 9.17-3.79 13-.49 9.91-2 11.74c0 0-.24 12-.61 14.67s1.35 10.28 0 11.62-19.32.74-19.81-1.47 2.2-12.84 2.2-12.84l1.59-10.27s3.18-5.62 2.45-7.46 1.34-6.11 1.46-6.48 3.43-6.36 2.82-8.68 3.85-51.66 3.85-51.66l12.59-88.41z",
                fill: "#ae6e79"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M751.04 634.6s-1 2.78-2.37 6.43c-2.18 5.76-5.32 13.69-7.05 16.31-2.81 4.28-4.77 12-4.77 12l-2.57 15.78a88.68 88.68 0 0 0-.85 10.64c0 1.4-.94 10.33-2.14 20.62-1.85 15.73-4.22 34.65-4.22 34.65l-10.27 13.09s-.52 1-1.17 2.58c-1.29 3-3.11 7.87-2.62 10.38.73 3.79-.49 9.9-2 11.74 0 0-.25 12-.61 14.67s1.35 10.27 0 11.62-19.32.74-19.81-1.46 2.2-12.84 2.2-12.84l1.59-10.28s3.18-5.62 2.44-7.46 1.35-6.11 1.47-6.48 3.43-6.36 2.82-8.68c-.47-1.77 2-30.74 3.15-44.48.39-4.32.64-7.13.64-7.13l10.83-76.06.88-6.13.88-6.22z",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M740.04 818.51c.11 1.35-17.25 3.31-19.73 1.84s0-19.69 0-19.69l1.13-8.31c-1.21-.13-3.05-6.73-2.2-8.32s-.73-8.31-.73-8.31l-2.88-9-1.76-5.51c-2.86-6.31-7-24.31-9.57-37.75-1.62-8.44-2.65-15.09-2.42-15.94.61-2.2-1-18.22-1-18.22s-2-16.27-4.64-21.4c-1.79-3.4-5.28-16.17-7.44-24.41-1.1-4.23-1.86-7.27-1.86-7.27s18.48-1.55 29.69-2.09c5.15-.25 8.77-.28 8.35.14s-.53 2.66-.51 5.9c.05 8.39 1.22 23.15 2.46 27.12 1.71 5.5 3.42 22 2.69 23.6s-.49 12.23-.49 12.23a55 55 0 0 1 2.16 13.27 179.39 179.39 0 0 1-.42 23.89s1.83 29.72 1.34 32.53 3.91 11.62 3.91 13.33 1.22 13.33 1.22 13.33 2.62 17.7 2.7 19.04zM749.69 461.31l-2.1 2.27-1.37 1.48-8 8.6-20.67 2.33-11-2.94-2.72-.73s0-5.52.49-12.14c.7-8.49 2.37-18.8 6.36-21.61a15.89 15.89 0 0 0 4.65-5.89 33.18 33.18 0 0 0 2-4.94c.08-.22.14-.43.21-.65a55.22 55.22 0 0 0 1.94-9.07s2.64-1.46 6.31-3.16c9.57-4.47 26.1-10.64 20.35 3.16a54 54 0 0 0-2.16 6.2c-.09.31-.17.62-.24.92-1.92 7.68-.65 12.34.78 14.91a9.33 9.33 0 0 0 .83 1.27 6.67 6.67 0 0 0 1.39 1.41l2.38 15.11.2 1.25z",
                fill: "#ae6e79"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M746.15 418.76c-1.09 2.62.53-2.14 0 0-4.36 3.1-14.63 11.93-20.4 11.93-3.9 0-5.07-.71-8.41-2.22a54.56 54.56 0 0 0 2.15-9.71s34.61-19.08 26.66 0z",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M754.96 402.69a26.68 26.68 0 0 1-23.87 26.51c-.92.09-1.85.15-2.79.15a26.66 26.66 0 1 1 26.66-26.66z",
                fill: "#ae6e79"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M758.75 520.87l-3.8 9.91s-3.09.13-7.91.28c-16.27.52-52.12 1.18-53.72-3a10.63 10.63 0 0 1-.56-3.29c-.21-6.37 2.76-16.15 2.76-16.15s1.71-19.57 1.71-20.42-1.47-14.56-1.47-14.56l2.94-11 8.19-5.75s3.67 5.63 5.87 6.11 5.14 3.19 5.14 3.19 7.21 4.4 9.54 1.95 20.42-13.21 20.42-13.21l9.54 10.52z",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M758.75 522.39l-3.8 9.9s-3.09.14-7.91.29h-.47c-2.08.07-4.46.14-7 .19-12.93.3-30.74.38-40.05-1-3.5-.5-5.79-1.22-6.17-2.2a8.83 8.83 0 0 1-.44-1.82c-.06-.46-.1-1-.12-1.47-.21-6.37 2.76-16.15 2.76-16.15s1.71-19.57 1.71-20.42-1.47-14.56-1.47-14.56l2.94-11 5.63-3.94 2.56-1.8a38.37 38.37 0 0 0 2.81 3.7 7.48 7.48 0 0 0 3.06 2.41c2.21.49 5.14 3.19 5.14 3.19s7.21 4.4 9.54 1.95c1.77-1.87 12.77-8.6 17.85-11.67 1.56-.95 2.57-1.54 2.57-1.54l1.28 1.42 8.26 9.1z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M629.61 420.59l-10.65 7.46s-.09-1.49-.36-3.53c5.26-2.22 8.46-7.13 9.38-8.7.98 2.66 1.63 4.77 1.63 4.77z",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M667.03 445.91l-2.32-.62s-3.8 4-6 4.53-6.84 3.54-6.84 3.54l-5.39 4.28s-4 .62-2.81-2.2-2.2-6.36-2.2-6.36-6.85-14.06-6.85-17-5.66-15.28-5.66-15.28-7.1 13.82-20.06 9.42c0 0 9.42 21.15 9.66 26.41s6.48 19.93 6.48 19.93 2.33 10.89 14.92 10.28c0 0 17.37 3.23 21.16 0s7.21-5.77 9-6.14 3.42-2.44 3.42-2.44v-14.54z",
                fill: "#4c4981"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M645.26 459.72s3.06 11.38 1.1 12.6zM747.04 532.53c-16.27.52-52.12 1.17-53.72-3a10.63 10.63 0 0 1-.56-3.29l53.15 2.8zM751.04 634.6s-1 2.78-2.37 6.43c-6.75-.41-15.69-.84-24.18-.9-3 0-5.94 0-8.72.1-5.9.18-11 .66-14.25 1.58a37.79 37.79 0 0 1-12.7 1.64c-1.1-4.23-1.86-7.27-1.86-7.27s18.48-1.55 29.69-2.09l.88-6.22z",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M765.35 589.84l-2.08 4.4s-.29 1.31-.66 3.39c-.78 4.48-2 12.56-1.54 19 .61 9.42-1.35 23.72-1.35 23.72s-45-3.79-58.2 0-19.7 0-19.7 0 1.6-14.18-2.32-21.52c-2.67-5-4.55-27.32-4.61-42 0-6.77.34-11.9 1.19-12.94 2.69-3.3 14.18-36.32 14.18-36.32l2.62.14 7 .37 39.8 2.1 6.25.33.66 2z",
                fill: "#444053"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M785.16 575.16l.37 3.92s-19.71-6.42-18.71-14.31 0-7 0-7l15.84 1.34z",
                fill: "#4c4981"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M785.16 575.16l.37 3.92s-19.71-6.42-18.71-14.31 0-7 0-7l15.84 1.34zM658.41 462.88a17.56 17.56 0 0 0 6.94 3.61 4.52 4.52 0 0 1-2-1c-1.41-1-2.75-2.09-4.11-3.15-1.1-.86-2.47-2.29-3.82-2.64a21.06 21.06 0 0 0 2.99 3.18zM658.71 468.03a8.83 8.83 0 0 1 1.52 2.41 14.57 14.57 0 0 1-.11 7.57l-3.16-7.62c-.55-1.3-1.1-2.6-1.76-3.84-.29-.53-2.11-2.74-1.9-3.2.56-1.3 4.82 3.95 5.41 4.68zM746.88 510.23a10.18 10.18 0 0 0 5.75-2.69c-3.25.41-6.33 1.69-9.53 2.36a14.16 14.16 0 0 1-8.88-.82c3.68 1.8 8.74 1.86 12.66 1.15zM737.69 487.84a2.23 2.23 0 0 1-1.65-.41q-3.66-2.1-7.22-4.38c-2.31-1.49-5.1-3-7.07-4.88 4.85 4.38 9.37 8.08 15.94 9.67zM744.47 513.78a15.22 15.22 0 0 0 3.82-.31 5.12 5.12 0 0 0 3.14-2.06 1.8 1.8 0 0 0-1.33.21 22.44 22.44 0 0 1-12.28 1.47c1.99.85 4.54.68 6.65.69zM721.31 570.56a40.11 40.11 0 0 1-7.81 1.53 47.19 47.19 0 0 1-6.18-.12l-10-.63-5-.32c-.59 0-3 0-1.81-1.19.6-.58 3.94-.21 4.8-.24q2.49-.08 5-.09c3.31 0 6.63 0 9.94.2 3.71.18 7.36.46 11.06.86zM709.72 575.51c-1.7-.07-3.89.94-5.64 1.16a37.53 37.53 0 0 1-5.9.23 32.9 32.9 0 0 1-11.37-2.32c7.63.39 15.28.62 22.91.93zM688.3 580.75a16.35 16.35 0 0 1 2.18.6c4.22 1.2 8.71.14 13-.92-1.07 1.61-3 2.3-4.93 2.74a22.86 22.86 0 0 1-9.6.35c-1-.2-3.51-.56-4-1.6-.82-1.53 2.41-1.32 3.35-1.17zM711.96 588.64a32.61 32.61 0 0 1 3.74 1c4.75 1.18 9.68-.44 14.45-1.53a67.27 67.27 0 0 1 17.49-1.62c-1.05 0-2.72.92-3.75 1.23-1.35.41-2.72.79-4.09 1.13-2.69.66-5.42 1.2-8.17 1.59a84 84 0 0 1-16.77.73c-2.56-.14-7 .12-9.19-1.17a10.13 10.13 0 0 1 6.29-1.36zM713.75 437.82s.24 11.26-1.59 16.4c-.58 1.6-1.48 4.55-2.46 7.86-1.07 3.67-2.24 7.78-3.14 11s-1.5 5.38-1.5 5.38-4.13 33.64-5.2 49.67c0 .28 0 .57-.06.84-.06.9-.16 1.84-.31 2.81-2.38 15.92-16.11 40.47-20.72 42.43a13.72 13.72 0 0 0-3.88 2.67c0-6.77.34-11.9 1.19-12.94 2.69-3.3 14.18-36.32 14.18-36.32l2.62.14c-.06-.46-.1-1-.12-1.47-.21-6.37 2.76-16.15 2.76-16.15s1.71-19.57 1.71-20.42-1.47-14.56-1.47-14.56l2.94-11 5.63-3.94c.7-8.49 2.37-18.8 6.36-21.61a15.89 15.89 0 0 0 4.65-5.89c.79.11-.65-.59-.65-.59z",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M715.9 431.51a7.28 7.28 0 0 0-6.19.7c-2.82 2-8.32 1.83-9.79 1.47s-16.75-2.33-18-1.84-3.67-1.71-5.26 1.23-2.32 4.52-3.91 5.25-4.41 3.06-4 3.55-4 3.42-4 3.42l8.92 29s-5.75 36.68-8.56 39.86-27.76 44.39-18.83 51.73a177.72 177.72 0 0 0 22.38 15c1 .49 4.52-6.11 9.41-8.19s20.06-29.6 21-45.25 5.26-50.5 5.26-50.5 5.26-19.08 7.09-24.22 1.59-16.4 1.59-16.4z",
                fill: "#4c4981"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M765.35 589.84l-2.08 4.4s-.29 1.31-.66 3.39a1.87 1.87 0 0 1-1-.45c-3.06-2.45-21-20.91-21.89-37.3-.63-12.09-.33-22.51-.13-27.15.06-1.46.12-2.34.12-2.53s13.94-16.88 12.35-22.86-5.26-38-5.26-38l-.54-4.2-.93-7.1-2.22-17.18 2.3.54a6.67 6.67 0 0 0 1.39 1.41l2.38 15.11 8.26 9.1 1.35 55.4-3.8 9.9s-3.09.14-7.91.29h-.47z",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M773.05 498.39s-3.42-1.35-3.66 0-.86 4.27-.86 4.27.61 7.1-2 9.91-3 14.67-3 14.67-4.12 11.74-2.17 15.41c.71 1.33 1.81 8 2.91 16 .7 5 1.39 10.49 2 15.51 1.11 9.12 1.94 16.67 1.94 16.67s-2.21 8.07-5.27 5.62-21-20.91-21.88-37.3c-.6-11.51-.36-21.51-.16-26.44.08-2.09.16-3.27.16-3.27s13.94-16.88 12.35-22.87-5.26-38-5.26-38l-.64-4.95-.69-5.32-.16-1.17-2.21-17c.39.09 14.11 3.19 15.92 5s13 4.4 13 4.4a9.78 9.78 0 0 1 6.94 7.12c.11.34.19.7.27 1.07 1.47 7.1 1 7.95 2 9.18s-9.53 31.49-9.53 31.49z",
                fill: "#4c4981"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M766.35 574.15c-5-1-12.42-3.31-12.25-8.41.15-4.77 5.89-6.49 10.24-7.1.7 4.98 1.39 10.49 2.01 15.51z",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M781.86 571.61c-.2.43-1 .8-2.14 1.13a57.67 57.67 0 0 1-8.13 1.33s-17-1.35-16.76-9.06c.18-5.53 7.86-7 12.17-7.33a28 28 0 0 1 2.87-.12s12.72 12.47 11.99 14.05z",
                fill: "#ae6e79"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M781.86 571.61c-.2.43-1 .8-2.14 1.13-4.43-5.93-10.61-13.54-13.64-14.21l.92-.85a28 28 0 0 1 2.87-.12s12.72 12.47 11.99 14.05z",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M777.58 466.08l5 .74a86.89 86.89 0 0 0 6 9.17 10 10 0 0 1 2.2 5.87s7.34 10.88 9.66 12.1 5.87 9.54 5.87 9.54 5.75 3.79 5.75 8.07a71.89 71.89 0 0 0 1.1 10.64c.13.61-.85 8.2-3.3 12s-4.9 12.18-4.77 13.68-6.85 9.3-8.8 11.74a49.72 49.72 0 0 0-4.28 7.22l-6.48 12.23s-13.7-20.18-18.71-21.28c0 0 5.62-5.38 8.43-6.36s5.51-9 5.63-10.88 2.57-7.95 5.13-9 3.92-2.2 2.82-3.92 0-5 0-5-7.22-9.54-8.2-15-7.58-9.17-7.58-9.17l-3.79-9.3z",
                fill: "#4c4981"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M795.77 511.73a15.87 15.87 0 0 1 9.87-3.74c-2.32.4-4.76.91-6.46 2.53a15.24 15.24 0 0 0-1.79 2.28c-.58.83-5.3 6.83-6 5.88-1.17-1.39 3.43-6.14 4.38-6.95zM784.69 505.94a4.23 4.23 0 0 0 3.49-2.47 13.85 13.85 0 0 0 1.09-4.34 64.76 64.76 0 0 1 1.51-7.43 3.44 3.44 0 0 0-.21-3 10.15 10.15 0 0 0-1.08-2.22c-.9 1-1.16 3.33-1.53 4.67-.46 1.66-.88 3.33-1.28 5-.21.8-1.87 9.79-1.99 9.79zM780.36 456.57a10.3 10.3 0 0 1-1.69 1.74c-2 1.59-4.65 2.93-4.9 5.44a5.85 5.85 0 0 1-.3 2.41c-.64 1.1-2.21 1-3.46.79a6 6 0 0 1-2.93-1.08c-1.31-1.12-1.43-3.12-2.43-4.53a6.17 6.17 0 0 0-5-2.21c-1.87-.06-3.73.36-5.6.44a15.39 15.39 0 0 1-3.59-.24 11.36 11.36 0 0 1-1.16-.24 14.92 14.92 0 0 1-2.44-.83 10.74 10.74 0 0 1-1.19-.56 15.8 15.8 0 0 1-3.45-2.4c-1.83-1.68-3.35-4-3.2-6.49.09-1.53.78-2.94 1-4.45.75-4.32-2.12-8.4-5.23-11.49-1.24-1.23-2.56-2.42-3.8-3.67a18.29 18.29 0 0 1-4.47-6.38 19 19 0 0 1-.8-8 55.19 55.19 0 0 0 .23-8.22c-.92-9.72-9.22-17.17-17.52-21.22l-.37-.19a26.65 26.65 0 1 1 35.85 39c-.09.31-.17.62-.24.92-1.92 7.68-.65 12.34.78 14.91.39.09 14.11 3.19 15.92 5s13 4.4 13 4.4a9.78 9.78 0 0 1 6.99 7.15z",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M706.3 378.14c.55-.63 1.38-.95 1.94-1.56 1.73-1.88 0-4.95.63-7.43.68-2.75 4.06-3.95 6.88-3.66s5.46 1.59 8.28 1.91c4.38.49 8.62-1.41 12.89-2.52s9.43-1.17 12.37 2.1 2.74 8.84 6.4 11.21c1.69 1.09 3.82 1.21 5.65 2a11.61 11.61 0 0 1 4.78 4.57 23.94 23.94 0 0 1 3.62 15.31c-.31 2.9-1.15 5.72-1.49 8.62a25.1 25.1 0 0 0 .6 9c.77 3 2.44 6.24 5.43 7.2a9.16 9.16 0 0 1 2 .69c1.73 1.08 1.5 3.62 1.06 5.6l-1.78 8.21c1.71 1.3 4.37.74 6 2.11a5 5 0 0 1 1.4 2.2 12 12 0 0 1-3.59 13.14c-2 1.59-4.65 2.93-4.9 5.43a5.64 5.64 0 0 1-.3 2.41c-.63 1.1-2.21 1-3.46.79a6 6 0 0 1-2.92-1.08c-1.32-1.12-1.43-3.12-2.43-4.53a6.19 6.19 0 0 0-5-2.21c-1.88-.06-3.73.36-5.61.45a16.58 16.58 0 0 1-11.79-4.26c-1.84-1.69-3.35-4-3.21-6.5.09-1.52.78-2.94 1-4.45.74-4.31-2.12-8.4-5.23-11.49s-6.76-5.94-8.28-10.05c-1.9-5.09-.06-10.77-.57-16.17-.92-9.73-9.21-17.17-17.52-21.23-1.85-.95-5-3.36-2.85-5.81z",
                fill: "#444053"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M771.7 462.12c-1.32-1.13-1.43-3.12-2.43-4.53a6.21 6.21 0 0 0-5-2.22c-1.88-.06-3.74.36-5.61.45a16.53 16.53 0 0 1-11.83-4.27c-1.84-1.68-3.34-4-3.2-6.49.09-1.53.78-2.95 1-4.45.75-4.32-2.12-8.41-5.23-11.5s-6.75-5.94-8.28-10.05c-1.89-5.08 0-10.76-.56-16.17-.93-9.73-9.22-17.17-17.52-21.23-1.94-.95-5.09-3.36-2.94-5.81.54-.63 1.37-.95 1.93-1.56 1.73-1.87 0-4.95.64-7.42a4.08 4.08 0 0 1 .63-1.37c-2.09.39-4 1.57-4.51 3.57-.61 2.48 1.1 5.55-.63 7.43-.56.61-1.39.93-1.94 1.55-2.15 2.45 1 4.87 2.94 5.81 8.31 4.06 16.6 11.51 17.52 21.23.51 5.41-1.33 11.09.57 16.18 1.52 4.1 5.17 7 8.28 10.05s6 7.17 5.23 11.49a38.3 38.3 0 0 0-1 4.45c-.14 2.49 1.37 4.81 3.21 6.49a16.49 16.49 0 0 0 11.82 4.27c1.88-.09 3.73-.5 5.61-.45a6.22 6.22 0 0 1 5 2.22c1 1.41 1.11 3.41 2.43 4.53a6 6 0 0 0 2.92 1.07c1.25.23 2.83.31 3.46-.78a2.7 2.7 0 0 0 .28-1.44 5.75 5.75 0 0 1-2.79-1.05z",
                opacity: 0.1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M626.13 402.69h-69.17v-68.16h69.22zm-1-102.77h-67.17c0-105.92 100.68-99.73 100.68-166.74 0-36.91-30.21-66.48-67.12-66.48s-67.11 31.88-67.11 67.53h-67.12A134 134 0 0 1 591.52 0c74.14 0 134.23 59.15 134.23 133.18 0 83.79-100.67 93.33-100.67 166.74z",
                fill: "#4285f4"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M281.14 382.39H263.3v-17.62h17.84zm-.27-26.5h-17.3c0-27.3 25.95-25.71 25.95-43a17.22 17.22 0 0 0-17.3-17.15 17.67 17.67 0 0 0-17.26 17.4h-17.3a34.61 34.61 0 0 1 69.21-.27c-.05 21.6-26 24.06-26 42.98zM416.22 504.8h-17.84v-17.57h17.84zm-.26-26.49h-17.3c0-27.31 25.95-25.71 25.95-43a17.21 17.21 0 0 0-17.3-17.14 17.67 17.67 0 0 0-17.35 17.42h-17.3a34.61 34.61 0 0 1 69.21-.27c.03 21.6-25.91 24.07-25.91 42.99zM498.36 288.1h-12.93v-12.71h12.93zm-.19-19.21h-12.54c0-19.78 18.81-18.63 18.81-31.15a12.48 12.48 0 0 0-12.54-12.42 12.8 12.8 0 0 0-12.54 12.62h-12.54a25.08 25.08 0 0 1 50.16-.2c-.02 15.65-18.81 17.44-18.81 31.15zM719.2 306.04h-7.31v-7.2h7.31zm-.11-10.85h-7.13c0-11.18 10.63-10.53 10.63-17.61a7 7 0 0 0-7.08-7 7.24 7.24 0 0 0-7.09 7.13h-7.09a14.18 14.18 0 0 1 28.35-.11c.04 8.79-10.59 9.84-10.59 17.59zM830.96 633.51h-7.31v-7.2h7.31zm-.11-10.85h-7.09c0-11.19 10.64-10.53 10.64-17.61a7.05 7.05 0 0 0-7.09-7 7.23 7.23 0 0 0-7.09 7.13h-7.09a14.18 14.18 0 0 1 28.35-.11c.04 8.83-10.59 9.84-10.59 17.59z",
                fill: "#4285f4",
                opacity: 0.1
            })
        ]
    }));
};

;// CONCATENATED MODULE: ./components/profile/profile-components.tsx




















var emptyCovers = [
    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyIcon, {
        width: 300,
        height: 300
    }, 1),
    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BlankIcon, {
        width: 300,
        height: 300
    }, 2),
    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(QuestionsIcon, {
        width: 300,
        height: 300
    }, 3), 
];
var EmptyMemo = function(props) {
    var index = (0,fp.random)(0, emptyCovers.length - 1);
    var Icon = emptyCovers[index];
    return /*#__PURE__*/ react.cloneElement(Icon, props);
};
var Empty = /*#__PURE__*/ react.memo(EmptyMemo);
function Following(param) {
    var user = param.user;
    var isTablet = (0,useIsTablet/* default */.Z)();
    var isMobile = (0,useIsMobile/* default */.Z)();
    var ref = (0,useShowMoreCounter/* default */.Z)((user.following || []).length, isTablet ? 3 : 8), offset = ref.offset, hasMore = ref.hasMore, showMore = ref.showMore;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        "data-intercom-target": user.isSelfie ? "User Following" : null,
        css: {
            backgroundColor: palette/* white */.ix,
            borderRadius: 5,
            border: "solid 1px ".concat(palette/* lightestGray */.v2)
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    padding: 15,
                    borderBottom: "solid 1px ".concat(palette/* lightestGray */.v2)
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h1", {
                    css: {
                        textTransform: "uppercase",
                        fontSize: 12,
                        color: palette/* sealBlue */.N9,
                        letterSpacing: 0.5,
                        fontWeight: 500,
                        margin: 0
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                        defaultMessage: "Following ({count})",
                        id: "wnR8JW",
                        values: {
                            count: user.following.length
                        }
                    })
                })
            }),
            isMobile ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    padding: 10
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Grid */.rj, {
                    gutter: 15,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* RowWrap */.xv, {
                        children: user.following.slice(0, offset).map(function(follow) {
                            if (!follow) {
                                return null;
                            }
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(core/* Col */.JX, {
                                mt: 10,
                                mb: 10,
                                width: [
                                    1,
                                    6 / 12,
                                    1,
                                    1
                                ],
                                children: [
                                    (follow.__typename === "GovernmentUser" || follow.__typename === "PendingUser" || follow.__typename === "VendorUser") && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                        passHref: true,
                                        href: "/[userSlug]/[[...tab]]",
                                        as: "/@".concat(follow.slug),
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                css: {
                                                    display: "flex",
                                                    alignItems: "center"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(profile_picture/* default */.Z, {
                                                        size: 48,
                                                        image: follow.avatar,
                                                        name: follow.fullName,
                                                        innovator: follow.isInnovator
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                        css: {
                                                            marginLeft: 15,
                                                            display: "flex",
                                                            flexDirection: "column"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                                css: {
                                                                    fontSize: 16,
                                                                    fontWeight: 600,
                                                                    color: palette/* text */.fL
                                                                },
                                                                children: follow.fullName
                                                            }),
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                                css: {
                                                                    fontSize: 14,
                                                                    color: palette/* mediumGray */.rF
                                                                },
                                                                children: follow.jobTitle
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    follow.__typename === "Government" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                        href: "/governments/[governmentSlug]/[[...content]]",
                                        as: "/governments/".concat(follow.slug),
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                css: {
                                                    display: "flex",
                                                    alignItems: "center"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(profile_picture/* default */.Z, {
                                                        size: 48,
                                                        image: follow.logo,
                                                        name: follow.name
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                        css: {
                                                            marginLeft: 15,
                                                            display: "flex",
                                                            flexDirection: "column"
                                                        },
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                            css: {
                                                                fontSize: 16,
                                                                fontWeight: 600,
                                                                color: palette/* text */.fL
                                                            },
                                                            children: follow.name
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            }, follow._id);
                        })
                    })
                })
            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Grid */.rj, {
                gutter: 15,
                children: chunk_default()(4, user.following.slice(0, offset)).map(function(row, index) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* RowWrap */.xv, {
                        mt: 15,
                        mb: 15,
                        css: {
                            justifyContent: row.length % 4 === 0 ? "center" : "flex-start"
                        },
                        children: row.map(function(follow) {
                            if (!follow) {
                                return null;
                            }
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(core/* Col */.JX, {
                                width: 3 / 12,
                                style: {
                                    display: "flex",
                                    justifyContent: "center"
                                },
                                children: [
                                    (follow.__typename === "GovernmentUser" || follow.__typename === "PendingUser" || follow.__typename === "VendorUser") && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                        passHref: true,
                                        href: "/[userSlug]/[[...tab]]",
                                        as: "/@".concat(follow.slug),
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                            css: {
                                                display: "inline-flex"
                                            },
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DelayedHover/* default */.Z, {
                                                ms: 300,
                                                children: function(_param) /*#__PURE__*/ {
                                                    var hover = _param.hover, bind = (0,_object_without_properties/* default */.Z)(_param, [
                                                        "hover"
                                                    ]);
                                                    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(popover/* default */.Z, {
                                                        placement: "top",
                                                        isOpen: hover,
                                                        backgroundColor: palette/* innovatorBlue */.LD,
                                                        borderColor: palette/* innovatorBlue */.LD,
                                                        boxStyle: {
                                                            boxShadow: "0 10px 40px 0 rgba(34, 35, 40, 0.2)"
                                                        },
                                                        render: function() {
                                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                                css: {
                                                                    padding: 10,
                                                                    display: "flex",
                                                                    flexDirection: "column",
                                                                    alignItems: "center",
                                                                    color: palette/* white */.ix,
                                                                    maxWidth: 200
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                                        css: {
                                                                            fontSize: 14,
                                                                            fontWeight: 600
                                                                        },
                                                                        children: follow.fullName
                                                                    }),
                                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                                        css: {
                                                                            fontSize: 12,
                                                                            fontWeight: 400,
                                                                            marginTop: 5
                                                                        },
                                                                        children: follow.jobTitle
                                                                    })
                                                                ]
                                                            });
                                                        },
                                                        children: function(param) {
                                                            var innerRef = param.innerRef;
                                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(profile_picture/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, bind), {
                                                                innerRef: innerRef,
                                                                size: 60,
                                                                image: follow.avatar,
                                                                name: follow.fullName,
                                                                innovator: follow.isInnovator
                                                            }));
                                                        }
                                                    });
                                                }
                                            })
                                        })
                                    }),
                                    follow.__typename === "Government" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                        href: "/governments/[governmentSlug]/[[...content]]",
                                        as: "/governments/".concat(follow.slug),
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                            css: {
                                                display: "inline-flex"
                                            },
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DelayedHover/* default */.Z, {
                                                ms: 300,
                                                children: function(_param) /*#__PURE__*/ {
                                                    var hover = _param.hover, bind = (0,_object_without_properties/* default */.Z)(_param, [
                                                        "hover"
                                                    ]);
                                                    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(popover/* default */.Z, {
                                                        placement: "top",
                                                        isOpen: hover,
                                                        backgroundColor: palette/* innovatorBlue */.LD,
                                                        borderColor: palette/* innovatorBlue */.LD,
                                                        boxStyle: {
                                                            boxShadow: "0 10px 40px 0 rgba(34, 35, 40, 0.2)"
                                                        },
                                                        render: function() {
                                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                                css: {
                                                                    padding: 10,
                                                                    display: "flex",
                                                                    flexDirection: "column",
                                                                    alignItems: "center",
                                                                    color: palette/* white */.ix
                                                                },
                                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                                    css: {
                                                                        fontSize: 14,
                                                                        fontWeight: 600
                                                                    },
                                                                    children: follow.name
                                                                })
                                                            });
                                                        },
                                                        children: function(param) {
                                                            var innerRef = param.innerRef;
                                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(profile_picture/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, bind), {
                                                                innerRef: innerRef,
                                                                size: 60,
                                                                image: follow.logo,
                                                                name: follow.name
                                                            }));
                                                        }
                                                    });
                                                }
                                            })
                                        })
                                    })
                                ]
                            }, follow._id);
                        })
                    }, index);
                })
            }),
            hasMore && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ShowMore, {
                onClick: showMore
            })
        ]
    });
}
var ShowMore = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        role: "button",
        "aria-label": "Show more",
        css: {
            padding: 15,
            textTransform: "uppercase",
            color: palette/* sealBlue */.N9,
            fontSize: 12,
            textAlign: "center",
            cursor: "pointer",
            borderTop: "solid 1px ".concat(palette/* lightestGray */.v2),
            "&:hover": {
                color: palette/* darkGray */.O5
            }
        }
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
            defaultMessage: "Show more",
            id: "aWpBzj"
        })
    }));
};
function FollowButton(param) {
    var user = param.user;
    if (user.isSelfie) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_powerplug_esm/* Hover */.TM, {
        children: function(param) {
            var hovered = param.hovered, bind = param.bind;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToggleFollow/* default */.Z, {
                targetId: user._id,
                entityType: user.__typename,
                viewerIsFollowing: user.isFollowing,
                children: function(param) {
                    var toggle = param.toggle;
                    if (!user.isFollowing) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            theme: "primary",
                            color: palette/* lightGray */.l2,
                            textColor: palette/* darkGray */.O5,
                            onClick: toggle,
                            style: {
                                height: 38,
                                padding: "0 38px",
                                fontWeight: "bold"
                            }
                        }, bind), {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "Follow",
                                id: "ieGrWo"
                            })
                        }));
                    }
                    if (!hovered) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            theme: "primary",
                            color: palette/* lightGray */.l2,
                            textColor: palette/* darkGray */.O5,
                            onClick: toggle,
                            style: {
                                height: 38,
                                padding: "0 32px",
                                fontWeight: "bold"
                            }
                        }, bind), {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "Following",
                                id: "cPIKU2"
                            })
                        }));
                    }
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        theme: "primary",
                        color: palette/* red */.Q6,
                        textColor: palette/* white */.ix,
                        onClick: toggle,
                        style: {
                            height: 38,
                            padding: "0 38px",
                            fontWeight: "bold"
                        }
                    }, bind), {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Unfollow",
                            id: "izWS4J"
                        })
                    }));
                }
            });
        }
    });
}

// EXTERNAL MODULE: ./components/profile/ProfileNavbar.tsx
var ProfileNavbar = __webpack_require__(81558);
// EXTERNAL MODULE: ./components/profile/Resources.tsx
var Resources = __webpack_require__(57473);
// EXTERNAL MODULE: ./components/profile/ResourcesForm.tsx + 2 modules
var ResourcesForm = __webpack_require__(5676);
// EXTERNAL MODULE: ./components/spacings.tsx
var spacings = __webpack_require__(52126);
// EXTERNAL MODULE: ./components/Tooltip.tsx
var Tooltip = __webpack_require__(79313);
;// CONCATENATED MODULE: ./components/user/GovernmentsBox.tsx















function GovernmentsBox(_param) {
    var title = _param.title, governments = _param.governments, props = (0,_object_without_properties/* default */.Z)(_param, [
        "title",
        "governments"
    ]);
    var isTablet = (0,useIsTablet/* default */.Z)();
    var ref = (0,useShowMoreCounter/* default */.Z)(governments.length, isTablet ? 3 : 8), offset = ref.offset, hasMore = ref.hasMore, showMore = ref.showMore;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        css: {
            backgroundColor: palette/* white */.ix,
            borderRadius: 5,
            border: "solid 1px ".concat(palette/* lightestGray */.v2)
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    padding: 15,
                    borderBottom: "solid 1px ".concat(palette/* lightestGray */.v2)
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h2", {
                    css: {
                        textTransform: "uppercase",
                        fontSize: 12,
                        color: palette/* darkGray */.O5,
                        letterSpacing: 0.5,
                        fontWeight: 500,
                        margin: 0
                    },
                    children: title
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Grid */.rj, {
                gutter: 15,
                children: chunk_default()(4, governments.slice(0, offset)).map(function(row, index) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* RowWrap */.xv, {
                        mt: 15,
                        mb: 15,
                        css: {
                            justifyContent: row.length % 4 === 0 ? "center" : "flex-start"
                        },
                        children: row.map(function(government) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Col */.JX, {
                                width: 3 / 12,
                                style: {
                                    display: "flex",
                                    justifyContent: "center"
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                    href: "/governments/[governmentSlug]/[[...content]]",
                                    as: "/governments/".concat(government.slug, "/settings"),
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                        css: {
                                            display: "inline-flex"
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tooltip/* default */.Z, {
                                            backgroundColor: palette/* innovatorBlue */.LD,
                                            borderColor: palette/* innovatorBlue */.LD,
                                            render: function() {
                                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                    css: {
                                                        padding: 6,
                                                        color: palette/* white */.ix,
                                                        maxWidth: 200,
                                                        textAlign: "center",
                                                        fontSize: 14,
                                                        fontWeight: 600
                                                    },
                                                    children: [
                                                        government.name,
                                                        " - ",
                                                        government.city.countryName
                                                    ]
                                                });
                                            },
                                            children: function(param) {
                                                var innerRef = param.innerRef, bind = param.bind;
                                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Box */.xu, {
                                                    position: "relative",
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(profile_picture/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, bind), {
                                                            innerRef: innerRef,
                                                            size: 60,
                                                            image: government.logo,
                                                            name: government.name
                                                        })),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                                            position: "absolute",
                                                            bottom: 1,
                                                            right: -3,
                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* CountryFlag */.AW, {
                                                                countryCode: government.city.country,
                                                                width: 24,
                                                                height: 14
                                                            })
                                                        })
                                                    ]
                                                });
                                            }
                                        })
                                    })
                                })
                            }, government._id);
                        })
                    }, index);
                })
            }),
            hasMore && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GovernmentsBox_ShowMore, {
                onClick: showMore
            })
        ]
    }));
};
var GovernmentsBox_ShowMore = function(props) {
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        role: "button",
        "aria-label": intl.formatMessage({
            defaultMessage: "Show more",
            id: "aWpBzj"
        }),
        css: {
            padding: 15,
            textTransform: "uppercase",
            color: palette/* darkGray */.O5,
            fontSize: 12,
            textAlign: "center",
            cursor: "pointer",
            borderTop: "solid 1px ".concat(palette/* lightestGray */.v2),
            "&:hover": {
                color: palette/* darkGray */.O5
            }
        }
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
            defaultMessage: "Show more",
            id: "aWpBzj"
        })
    }));
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(56262);
// EXTERNAL MODULE: ./lib/hooks/useClipboard.ts
var useClipboard = __webpack_require__(91472);
// EXTERNAL MODULE: ./components/icons/GearIcon.tsx
var GearIcon = __webpack_require__(74055);
// EXTERNAL MODULE: ./components/profile/EmptyBlocks.tsx
var EmptyBlocks = __webpack_require__(32796);
;// CONCATENATED MODULE: ./components/user/sharing/getSharingUrl.ts
function getSharingUrl(slug) {
    if (true) {
        return "https://".concat(slug, ".users.govlaunch.com");
    }
    if (false) {}
    return "http://localhost:3005/?user=".concat(slug);
};

;// CONCATENATED MODULE: ./components/user/sharing/SharingBox.tsx












var SharingBox = function(param) {
    var user = param.user, tab = param.tab;
    var inputRef = /*#__PURE__*/ react.createRef();
    var ref = (0,_sliced_to_array/* default */.Z)((0,useClipboard/* default */.Z)(inputRef), 2), copied = ref[0], setClipboard = ref[1];
    var router = (0,next_router.useRouter)();
    if (user.enabledSharing) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: {
                backgroundColor: palette/* white */.ix,
                borderRadius: 5,
                border: "solid 1px ".concat(palette/* lightestGray */.v2)
            },
            "data-intercom-target": "User Sharing",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: {
                        padding: 15,
                        textTransform: "uppercase",
                        fontSize: 12,
                        borderBottom: "1px solid ".concat(palette/* lightestGray */.v2),
                        color: palette/* darkGray */.O5,
                        letterSpacing: 0.5,
                        fontWeight: 500,
                        display: "flex",
                        alignItems: "center"
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Sharing",
                            id: "XfKNCg"
                        }),
                        user.enabledSharing && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            role: "button",
                            css: {
                                display: "inline-flex",
                                marginLeft: "auto",
                                cursor: "pointer"
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                passHref: true,
                                href: "/[userSlug]/[[...tab]]?tab=".concat(tab, "&sharing=1"),
                                as: "/@".concat(user.slug, "/").concat(tab),
                                scroll: false,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GearIcon/* default */.Z, {
                                        width: 20,
                                        height: 20
                                    })
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: {
                        padding: 15
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: {
                                fontWeight: 500,
                                fontSize: 14,
                                color: palette/* darkGray */.O5,
                                marginBottom: 15
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "Your custom public page is now live!",
                                id: "1lfWb3"
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: {
                                fontSize: 14,
                                color: palette/* darkGray */.O5
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                css: {
                                    position: "relative"
                                },
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                        css: {
                                            position: "absolute",
                                            left: 15,
                                            top: 14,
                                            display: "inline-flex"
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
                                            width: 15,
                                            height: 15,
                                            viewBox: "0 0 52.974 52.974",
                                            fill: palette/* sealBlue */.N9,
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                                    d: "M49.467 3.51c-4.677-4.679-12.291-4.681-16.97 0l-9.192 9.192a.999.999 0 1 0 1.414 1.414l9.192-9.192a9.927 9.927 0 0 1 7.07-2.915c2.681 0 5.191 1.036 7.071 2.916s2.916 4.391 2.916 7.071c0 2.68-1.036 5.19-2.916 7.07L36.033 31.088c-3.898 3.898-10.244 3.898-14.143 0a.999.999 0 1 0-1.414 1.414c2.34 2.339 5.412 3.509 8.485 3.509s6.146-1.17 8.485-3.509L49.467 20.48a11.914 11.914 0 0 0 3.502-8.485c0-3.214-1.244-6.227-3.502-8.485z"
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                                    d: "M26.84 40.279l-7.778 7.778a9.928 9.928 0 0 1-7.071 2.916 9.93 9.93 0 0 1-7.071-2.916c-3.898-3.898-3.898-10.243 0-14.142l11.314-11.314c3.899-3.898 10.244-3.896 14.142 0a.999.999 0 1 0 1.414-1.414c-4.677-4.679-12.291-4.681-16.97 0L3.505 32.502a11.914 11.914 0 0 0-3.501 8.485c0 3.214 1.244 6.227 3.502 8.484s5.271 3.502 8.484 3.502c3.215 0 6.228-1.244 8.485-3.502l7.778-7.778a.999.999 0 1 0-1.413-1.414z"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Input */.II, {
                                        innerRef: inputRef,
                                        readOnly: true,
                                        onChange: function() {},
                                        value: getSharingUrl(user.slug),
                                        onFocus: function(e) {
                                            return e.target.select();
                                        },
                                        css: {
                                            paddingLeft: 40,
                                            borderColor: palette/* lightSealBlue */.oz,
                                            borderStyle: "dashed"
                                        }
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: {
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "flex-end",
                        padding: 16,
                        borderTop: "1px solid ".concat(palette/* lightestGray */.v2)
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(core/* AnchorButton */.AN, {
                            href: getSharingUrl(user.slug),
                            target: "_blank",
                            rel: "noopener noreferrer",
                            size: "xsmall",
                            color: palette/* innovatorBlue */.LD,
                            css: {
                                display: "inline-flex",
                                marginRight: 8
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                    css: {
                                        marginRight: 10,
                                        display: "inline-flex"
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
                                        width: 15,
                                        height: 15,
                                        viewBox: "0 0 511.626 511.627",
                                        fill: "#fff",
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                                d: "M392.857 292.354h-18.274c-2.669 0-4.859.855-6.563 2.573-1.718 1.708-2.573 3.897-2.573 6.563v91.361c0 12.563-4.47 23.315-13.415 32.262-8.945 8.945-19.701 13.414-32.264 13.414H82.224c-12.562 0-23.317-4.469-32.264-13.414-8.945-8.946-13.417-19.698-13.417-32.262V155.31c0-12.562 4.471-23.313 13.417-32.259 8.947-8.947 19.702-13.418 32.264-13.418h200.994c2.669 0 4.859-.859 6.57-2.57 1.711-1.713 2.566-3.9 2.566-6.567V82.221c0-2.662-.855-4.853-2.566-6.563-1.711-1.713-3.901-2.568-6.57-2.568H82.224c-22.648 0-42.016 8.042-58.102 24.125C8.042 113.297 0 132.665 0 155.313v237.542c0 22.647 8.042 42.018 24.123 58.095 16.086 16.084 35.454 24.13 58.102 24.13h237.543c22.647 0 42.017-8.046 58.101-24.13 16.085-16.077 24.127-35.447 24.127-58.095v-91.358c0-2.669-.856-4.859-2.574-6.57-1.713-1.718-3.903-2.573-6.565-2.573z"
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                                d: "M506.199 41.971c-3.617-3.617-7.905-5.424-12.85-5.424H347.171c-4.948 0-9.233 1.807-12.847 5.424-3.617 3.615-5.428 7.898-5.428 12.847s1.811 9.233 5.428 12.85l50.247 50.248-186.147 186.151c-1.906 1.903-2.856 4.093-2.856 6.563 0 2.479.953 4.668 2.856 6.571l32.548 32.544c1.903 1.903 4.093 2.852 6.567 2.852s4.665-.948 6.567-2.852l186.148-186.148 50.251 50.248c3.614 3.617 7.898 5.426 12.847 5.426s9.233-1.809 12.851-5.426c3.617-3.616 5.424-7.898 5.424-12.847V54.818c-.001-4.952-1.814-9.232-5.428-12.847z"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "Open",
                                        id: "JfG49w"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            css: {
                                display: "flex",
                                alignItems: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(core/* Button */.zx, {
                                    theme: "secondary",
                                    size: "xsmall",
                                    onClick: setClipboard,
                                    color: palette/* innovatorBlue */.LD,
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                            css: {
                                                marginRight: 10,
                                                display: "inline-flex"
                                            },
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
                                                width: 15,
                                                height: 15,
                                                viewBox: "0 0 488.3 488.3",
                                                fill: palette/* primary */.T$,
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                                        d: "M314.25 85.4h-227c-21.3 0-38.6 17.3-38.6 38.6v325.7c0 21.3 17.3 38.6 38.6 38.6h227c21.3 0 38.6-17.3 38.6-38.6V124c-.1-21.3-17.4-38.6-38.6-38.6zm11.5 364.2c0 6.4-5.2 11.6-11.6 11.6h-227c-6.4 0-11.6-5.2-11.6-11.6V124c0-6.4 5.2-11.6 11.6-11.6h227c6.4 0 11.6 5.2 11.6 11.6v325.6z"
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                                        d: "M401.05 0h-227c-21.3 0-38.6 17.3-38.6 38.6 0 7.5 6 13.5 13.5 13.5s13.5-6 13.5-13.5c0-6.4 5.2-11.6 11.6-11.6h227c6.4 0 11.6 5.2 11.6 11.6v325.7c0 6.4-5.2 11.6-11.6 11.6-7.5 0-13.5 6-13.5 13.5s6 13.5 13.5 13.5c21.3 0 38.6-17.3 38.6-38.6V38.6c0-21.3-17.3-38.6-38.6-38.6z"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                defaultMessage: "Copy",
                                                id: "4l6vz1"
                                            })
                                        })
                                    ]
                                }),
                                copied && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                    css: {
                                        marginLeft: 6,
                                        color: palette/* greenSuccess */.CU
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Copied",
                                            id: "p556q3"
                                        }),
                                        "!"
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyBlocks/* NoSharingPage */.pH, {
        onStartSharing: function() {
            router.push("/[userSlug]/[[...tab]]?tab=".concat(tab, "&sharing=1"), "/@".concat(user.slug, "/").concat(tab));
        }
    });
};
/* harmony default export */ var sharing_SharingBox = (SharingBox);

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(38975);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/fp/omit.js
var omit = __webpack_require__(53104);
var omit_default = /*#__PURE__*/__webpack_require__.n(omit);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/fp/filter.js
var filter = __webpack_require__(54192);
var filter_default = /*#__PURE__*/__webpack_require__.n(filter);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/fp/identity.js
var identity = __webpack_require__(85579);
var identity_default = /*#__PURE__*/__webpack_require__.n(identity);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-use@17.4.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-use/esm/useToggle.js
var useToggle = __webpack_require__(35150);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-switch@6.1.0_sfoxds7t5ydpegc3knd667wn6m/node_modules/react-switch/index.js
var react_switch = __webpack_require__(86029);
;// CONCATENATED MODULE: ./lib/mutations/SaveUserSharing.ts

function SaveUserSharing_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation SaveUserSharing($userSlug: String!, $sharing: UserSharingInput, $enableSharing: Boolean!) {\n    saveUserSharing(userSlug: $userSlug, enableSharing: $enableSharing, sharing: $sharing) {\n      ... on GovernmentUser {\n        _id\n        enabledSharing\n        sharing {\n          projects\n          stories\n          resources\n        }\n      }\n    }\n  }\n"
    ]);
    SaveUserSharing_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var SaveUserSharing = ((0,lib/* gql */.Ps)(SaveUserSharing_templateObject()));

;// CONCATENATED MODULE: ./components/user/sharing/SharingSettingsModal.tsx


















var SharingSettingsModal = function(_param) {
    var handleSetSharing = function handleSetSharing(toggleEnabledSharing) {
        return function(options) {
            if (filter_default()((identity_default()), options).length === 0) {
                toggleEnabledSharing();
            }
            setSharing(options);
        };
    };
    var user = _param.user, isOpen = _param.isOpen, onRequestClose = _param.onRequestClose, props = (0,_object_without_properties/* default */.Z)(_param, [
        "user",
        "isOpen",
        "onRequestClose"
    ]);
    var ref = (0,_sliced_to_array/* default */.Z)((0,useToggle/* default */.Z)(user.enabledSharing || false), 2), enabledSharing = ref[0], toggleEnabledSharing = ref[1];
    var ref1 = (0,react.useState)(omit_default()([
        "__typename"
    ], user.sharing)), sharing = ref1[0], setSharing = ref1[1];
    var ref2 = (0,react.useState)(false), saving = ref2[0], setSaving = ref2[1];
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(core/* Modal */.u_, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        isOpen: isOpen,
        onRequestClose: function() {
            if (!saving) {
                onRequestClose();
            }
        },
        ariaHideApp: false,
        overlayStyle: {
            background: "rgba(255, 255, 255, 0.6)"
        },
        style: {
            boxShadow: "0 0 20px 0 #e1e1e1",
            border: null
        },
        children: [
            isOpen && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* BlockBodyOverflow */.Bm, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* ModalClose */.A3, {
                onClick: onRequestClose,
                style: {
                    cursor: "pointer"
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    padding: 20,
                    width: 450
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: {
                        display: "grid",
                        rowGap: 15
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                css: {
                                    display: "flex",
                                    justifyContent: "space-between"
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("h3", {
                                    css: {
                                        display: "flex",
                                        alignItems: "center",
                                        color: palette/* darkGray */.O5,
                                        margin: 0,
                                        fontWeight: 500,
                                        fontSize: 21
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Sharing",
                                            id: "XfKNCg"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                            css: {
                                                marginLeft: 5,
                                                fontSize: 14,
                                                color: enabledSharing ? "#178B61" : "#B44F4F"
                                            },
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_switch["default"], {
                                                uncheckedIcon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                    css: {
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        height: "100%",
                                                        fontSize: 15,
                                                        color: palette/* lightRed */.r6,
                                                        paddingRight: 10
                                                    },
                                                    children: "off"
                                                }),
                                                checkedIcon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                    css: {
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        height: "100%",
                                                        fontSize: 15,
                                                        color: "#fff",
                                                        paddingLeft: 10
                                                    },
                                                    children: "on"
                                                }),
                                                handleDiameter: 22,
                                                height: 26,
                                                width: 65,
                                                onChange: function(checked) {
                                                    toggleEnabledSharing();
                                                    if (checked) {
                                                        setSharing({
                                                            projects: true,
                                                            stories: true,
                                                            resources: true
                                                        });
                                                    } else {
                                                        setSharing({
                                                            projects: false,
                                                            stories: false,
                                                            resources: false
                                                        });
                                                    }
                                                },
                                                checked: enabledSharing,
                                                onColor: palette/* greenSuccess */.CU,
                                                offColor: palette/* red */.Q6
                                            })
                                        })
                                    ]
                                })
                            })
                        }),
                        enabledSharing ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("p", {
                            css: {
                                color: palette/* darkGray */.O5,
                                fontSize: 14,
                                margin: 0
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Select the items below to display in your public share page",
                                    id: "6kIwcu"
                                }),
                                ": ",
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                    css: {
                                        color: "#005AEE"
                                    },
                                    href: getSharingUrl(user.slug),
                                    rel: "noopener noreferrer",
                                    target: "_blank",
                                    children: getSharingUrl(user.slug)
                                })
                            ]
                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("p", {
                            css: {
                                color: palette/* darkGray */.O5,
                                fontSize: 14,
                                margin: 0
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Turn on sharing to create your custom page and then select what you want to share. It is that simple! Your User's unique URL",
                                    id: "H45RTJ"
                                }),
                                ": ",
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                    css: {
                                        color: "#005AEE"
                                    },
                                    href: getSharingUrl(user.slug),
                                    rel: "noopener noreferrer",
                                    target: "_blank",
                                    children: getSharingUrl(user.slug)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("p", {
                                    css: {
                                        color: palette/* darkGray */.O5,
                                        fontSize: 14,
                                        margin: 0,
                                        marginBottom: 5
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("strong", {
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                    defaultMessage: "Public",
                                                    id: "uhu5aG"
                                                }),
                                                ":"
                                            ]
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Anybody can view (including guests in Govlaunch)",
                                            id: "dF5LfH"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("p", {
                                    css: {
                                        color: palette/* darkGray */.O5,
                                        fontSize: 14,
                                        margin: 0
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("strong", {
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                    defaultMessage: "Private",
                                                    id: "viXE32"
                                                }),
                                                ":"
                                            ]
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Only verified users of the Govlaunch community can view",
                                            id: "bQmHhu"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            css: {
                                opacity: enabledSharing ? 1 : 0.3,
                                display: "grid",
                                rowGap: 10
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Toggle, {
                                    value: "stories",
                                    description: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                defaultMessage: "Stories",
                                                id: "Ldxym4"
                                            }),
                                            ":",
                                            " ",
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                                css: {
                                                    fontSize: 11
                                                },
                                                children: [
                                                    "(",
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                        defaultMessage: "only stories marked as public will be visible",
                                                        id: "UPxtYU"
                                                    }),
                                                    ")"
                                                ]
                                            })
                                        ]
                                    }),
                                    sharing: sharing,
                                    setSharing: handleSetSharing(toggleEnabledSharing),
                                    enabledSharing: enabledSharing
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Toggle, {
                                    value: "projects",
                                    description: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                defaultMessage: "Projects",
                                                id: "UxTJRa"
                                            }),
                                            ":",
                                            " ",
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                                css: {
                                                    fontSize: 11
                                                },
                                                children: [
                                                    "(",
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                        defaultMessage: "only projects marked as public will be visible",
                                                        id: "8uWZ5k"
                                                    }),
                                                    ")"
                                                ]
                                            })
                                        ]
                                    }),
                                    sharing: sharing,
                                    setSharing: handleSetSharing(toggleEnabledSharing),
                                    enabledSharing: enabledSharing
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Toggle, {
                                    value: "resources",
                                    description: intl.formatMessage({
                                        defaultMessage: "Resources",
                                        id: "c/KktL"
                                    }),
                                    sharing: sharing,
                                    setSharing: handleSetSharing(toggleEnabledSharing),
                                    enabledSharing: enabledSharing
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
                            mutation: SaveUserSharing,
                            children: function(saveUserSharing) {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, {
                                    disabled: saving,
                                    size: "small",
                                    color: palette/* innovatorBlue */.LD,
                                    css: {
                                        userSelect: "none",
                                        marginTop: 10
                                    },
                                    onClick: function() {
                                        setSaving(true);
                                        saveUserSharing({
                                            variables: {
                                                userSlug: user.slug,
                                                sharing: (0,_object_spread/* default */.Z)({
                                                    posts: false
                                                }, sharing || {}),
                                                enableSharing: enabledSharing
                                            }
                                        }).then(function() {
                                            setSaving(false);
                                            onRequestClose();
                                        });
                                    },
                                    children: saving ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "Saving",
                                        id: "QLkzoS"
                                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "Save",
                                        id: "jvo0vs"
                                    })
                                });
                            }
                        })
                    ]
                })
            })
        ]
    }));
};
var Toggle = function(param) {
    var value = param.value, description = param.description, sharing = param.sharing, setSharing = param.setSharing, enabledSharing = param.enabledSharing;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("label", {
            css: {
                display: "flex",
                alignItems: "center"
            },
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_switch["default"], {
                    uncheckedIcon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: {
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                            fontSize: 10,
                            color: palette/* lightRed */.r6,
                            paddingRight: 15
                        },
                        children: "off"
                    }),
                    checkedIcon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: {
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            height: "100%",
                            fontSize: 10,
                            color: "#fff",
                            paddingLeft: 15
                        },
                        children: "on"
                    }),
                    offColor: palette/* red */.Q6,
                    handleDiameter: 22,
                    height: 30,
                    width: 80,
                    onColor: palette/* greenSuccess */.CU,
                    onChange: function() {
                        return setSharing(omit_default()("__typename", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, sharing), (0,_define_property/* default */.Z)({}, value, !sharing[value]))));
                    },
                    checked: enabledSharing && Boolean(sharing[value])
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                    css: {
                        marginLeft: 10,
                        color: palette/* darkGray */.O5,
                        fontSize: 16
                    },
                    children: description
                })
            ]
        })
    });
};
/* harmony default export */ var sharing_SharingSettingsModal = (SharingSettingsModal);

// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.9_mnlteiidv5se4zpyvopwg4rohq/node_modules/@apollo/client/react/context/ApolloConsumer.js
var ApolloConsumer = __webpack_require__(78766);
// EXTERNAL MODULE: ./node_modules/.pnpm/detect-browser@5.3.0/node_modules/detect-browser/es/index.js
var es = __webpack_require__(81365);
;// CONCATENATED MODULE: ./components/Emoji.tsx






function Emoji(_param) {
    var children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children"
    ]);
    var browser = (0,es/* detect */.qY)();
    if (browser && browser.name === "ie") {
        // TODO: fallback to image
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        style: {
            // https://www.tjvantoll.com/2016/06/15/emoji-on-windows
            fontFamily: "Segoe UI Emoji"
        },
        children: children
    }));
};

// EXTERNAL MODULE: ./components/feed/card/LoadingFeedCard.tsx
var LoadingFeedCard = __webpack_require__(25936);
// EXTERNAL MODULE: ./components/feed/FeedItem.tsx + 8 modules
var FeedItem = __webpack_require__(93742);
// EXTERNAL MODULE: ./components/feed/PostFeedItem.tsx
var PostFeedItem = __webpack_require__(28933);
// EXTERNAL MODULE: ./components/icons/ProjectIcon.tsx
var ProjectIcon = __webpack_require__(20302);
// EXTERNAL MODULE: ./components/mediaQueries.ts
var mediaQueries = __webpack_require__(92418);
// EXTERNAL MODULE: ./components/profile/NoProjectsBox.tsx
var NoProjectsBox = __webpack_require__(88925);
// EXTERNAL MODULE: ./components/screen/Screen.tsx
var Screen = __webpack_require__(29142);
// EXTERNAL MODULE: ./components/story/StoryListItem.tsx + 3 modules
var StoryListItem = __webpack_require__(92136);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/fp/noop.js
var noop = __webpack_require__(98483);
var noop_default = /*#__PURE__*/__webpack_require__.n(noop);
;// CONCATENATED MODULE: ./components/story/StoryListItemActionsContext.ts


/* harmony default export */ var StoryListItemActionsContext = (react.createContext({
    onDelete: (noop_default()),
    onUnpublish: (noop_default())
}));

// EXTERNAL MODULE: ./components/story/StoryListItemDividers.tsx
var StoryListItemDividers = __webpack_require__(77966);
// EXTERNAL MODULE: ./components/story/StoryListItemHoverContainer.tsx
var StoryListItemHoverContainer = __webpack_require__(59933);
// EXTERNAL MODULE: ./components/story/ToggleBookmark.tsx
var ToggleBookmark = __webpack_require__(87636);
// EXTERNAL MODULE: ./components/BookmarkButton.tsx
var BookmarkButton = __webpack_require__(59837);
// EXTERNAL MODULE: ./components/tag/TagsPreview.tsx
var TagsPreview = __webpack_require__(3081);
// EXTERNAL MODULE: ./components/text/Dotdotdot.tsx
var Dotdotdot = __webpack_require__(3552);
;// CONCATENATED MODULE: ./components/user/ProductListItem.tsx













function ProductListItem(param) {
    var product = param.product, onBookmark = param.onBookmark, _displayBookmark = param.displayBookmark, displayBookmark = _displayBookmark === void 0 ? true : _displayBookmark;
    var linkTo = "/products/".concat(product.slug);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_powerplug_esm/* Hover */.TM, {
        children: function(param) {
            var hovered = param.hovered, bind = param.bind;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                css: {
                    padding: 15,
                    backgroundColor: hovered ? "rgba(250, 250, 250, 0.5)" : "inherit",
                    display: "flex"
                }
            }, bind), {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                        href: linkTo,
                        passHref: true,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                css: {
                                    display: "flex",
                                    alignItems: "center"
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                                    css: {
                                        height: 150,
                                        width: 110,
                                        pointerEvents: "none",
                                        objectFit: "cover",
                                        borderRadius: 5
                                    },
                                    src: product.thumbnail
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        css: {
                            marginLeft: 15,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "space-between",
                            width: "100%"
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                href: linkTo,
                                passHref: true,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                            mt: 10,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                css: {
                                                    display: "flex",
                                                    alignItems: "center"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(profile_picture/* default */.Z, {
                                                        size: 28,
                                                        image: product.logo,
                                                        name: product.name
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h1", {
                                                        css: {
                                                            fontSize: 18,
                                                            margin: 0,
                                                            marginLeft: 10,
                                                            color: palette/* text */.fL
                                                        },
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dotdotdot/* default */.Z, {
                                                            clamp: 2,
                                                            children: product.name
                                                        })
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                            mt: 10,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h2", {
                                                css: {
                                                    fontSize: 14,
                                                    margin: 0,
                                                    color: palette/* darkGray */.O5,
                                                    fontWeight: "normal"
                                                },
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dotdotdot/* default */.Z, {
                                                    clamp: 3,
                                                    children: product.description
                                                })
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                css: {
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "flex-end",
                                    marginTop: "auto",
                                    marginBottom: 10,
                                    minHeight: 24
                                },
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TagsPreview/* default */.Z, {
                                        tags: product.tags
                                    }),
                                    displayBookmark && hovered && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Desktop */.Hi, {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BookmarkButton/* default */.Z, {
                                            onClick: onBookmark,
                                            bookmarked: product.viewerDidBookmark
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }));
        }
    });
};

// EXTERNAL MODULE: ./lib/queries/ConnectQuery.ts + 1 modules
var ConnectQuery = __webpack_require__(76896);
// EXTERNAL MODULE: ./node_modules/.pnpm/@govlaunch+project@2.37.38_u5fk2u3bhbj7bxbqnju5id576a/node_modules/@govlaunch/project/index.ts + 59 modules
var project = __webpack_require__(78062);
;// CONCATENATED MODULE: ./lib/queries/fragments/StoryFields.ts

function StoryFields_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment StoryFieldsLegacy on Story {\n    _id\n    slug\n    title\n    introduction\n    viewerCanRead\n    viewerDidBookmark\n    viewerIsAuthor\n    viewerIsCollaborator\n    commentsCount\n    upvotesCount\n    medias {\n      type\n      url\n    }\n    verticalCover\n    updatedAt\n    modifiedAt\n    createdAt\n    lastPublishedAt\n    collaborators {\n      ... on GovernmentUser {\n        _id\n        slug\n        firstName\n        lastName\n        fullName\n        email\n        jobTitle\n        avatar\n        isInnovator\n        government {\n          _id\n          name\n          city {\n            _id\n            name\n            state\n          }\n        }\n      }\n      ... on PendingUser {\n        _id\n        slug\n        firstName\n        lastName\n        fullName\n        email\n        jobTitle\n        avatar\n      }\n    }\n    author {\n      ... on GovernmentUser {\n        _id\n        isSelfie\n      }\n      ... on VendorUser {\n        _id\n        isSelfie\n      }\n    }\n    tags {\n      _id\n      name\n    }\n  }\n"
    ]);
    StoryFields_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var StoryFields = ((0,lib/* gql */.Ps)(StoryFields_templateObject()));

;// CONCATENATED MODULE: ./lib/queries/fragments/BookmarkItemFields.ts

function BookmarkItemFields_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  fragment BookmarkStoryItem on Story {\n    _id\n    ...StoryFieldsLegacy\n    storyStatus: status\n    storyGovernment: government {\n      _id\n      name\n      slug\n      logo\n      isInnovator\n      state\n      city {\n        _id\n        country\n        countryName\n      }\n    }\n  }\n\n  fragment BookmarkItem on BookmarkTarget {\n    ... on Collection {\n      _id\n      viewerDidBookmark\n    }\n    ... on Story {\n      ...BookmarkStoryItem\n    }\n    ... on Product {\n      _id\n      name\n      slug\n      logo\n      company {\n        _id\n        name\n        slug\n        logo\n      }\n      tags {\n        _id\n        slug\n        name\n      }\n      viewerDidBookmark\n      thumbnail\n      isDisruptor\n      description\n      upvotesCount\n      commentsCount\n      governmentsUsingCount\n    }\n\n    ...ProjectCardFields\n\n    ... on GroupPost {\n      _id\n      body\n      audience\n      viewerCanEdit\n      upvotesCount\n      commentsCount\n      viewerDidBookmark\n      viewerDidUpvote\n      viewerDidComment\n      createdAt\n      postAuthor: author {\n        ... on GovernmentUser {\n          _id\n          slug\n          fullName\n          avatar\n          jobTitle\n          email\n          government {\n            _id\n            slug\n            name\n            logo\n          }\n        }\n        ... on VendorUser {\n          _id\n          slug\n          fullName\n          avatar\n          jobTitle\n          email\n          company {\n            _id\n            slug\n            name\n            logo\n          }\n        }\n      }\n      postGroup: group {\n        _id\n        slug\n        name\n        logo\n      }\n      postLinks: links {\n        url\n        description\n        favicon\n        title\n        siteName\n        addedAt\n      }\n      postAttachments: attachments {\n        mimeType\n        url\n        filename\n        sizeInBytes\n      }\n    }\n    ... on GovernmentPost {\n      _id\n      body\n      audience\n      viewerCanEdit\n      upvotesCount\n      commentsCount\n      viewerDidBookmark\n      viewerDidUpvote\n      viewerDidComment\n      createdAt\n      postGovernment: government {\n        _id\n        slug\n        name\n        logo\n        city {\n          _id\n          country\n          countryName\n        }\n      }\n      postAuthor: author {\n        __typename\n        ... on GovernmentUser {\n          _id\n          slug\n          fullName\n          avatar\n          jobTitle\n          email\n          government {\n            _id\n            slug\n            name\n            logo\n          }\n        }\n        ... on VendorUser {\n          _id\n          slug\n          fullName\n          avatar\n          jobTitle\n          email\n          company {\n            _id\n            slug\n            name\n            logo\n          }\n        }\n      }\n      postLinks: links {\n        url\n        description\n        favicon\n        title\n        siteName\n        addedAt\n      }\n      postAttachments: attachments {\n        mimeType\n        url\n        filename\n        sizeInBytes\n      }\n    }\n    ... on VendorPost {\n      _id\n      body\n      audience\n      viewerCanEdit\n      upvotesCount\n      commentsCount\n      viewerDidBookmark\n      viewerDidUpvote\n      viewerDidComment\n      createdAt\n      postVendor: vendor {\n        _id\n        slug\n        name\n        logo\n      }\n      postAuthor: author {\n        __typename\n        ... on GovernmentUser {\n          _id\n          slug\n          fullName\n          avatar\n          jobTitle\n          email\n          government {\n            _id\n            slug\n            name\n            logo\n          }\n        }\n        ... on VendorUser {\n          _id\n          slug\n          fullName\n          avatar\n          jobTitle\n          email\n          company {\n            _id\n            slug\n            name\n            logo\n          }\n        }\n      }\n      postLinks: links {\n        url\n        description\n        favicon\n        title\n        siteName\n        addedAt\n      }\n      postAttachments: attachments {\n        mimeType\n        url\n        filename\n        sizeInBytes\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    BookmarkItemFields_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



/* harmony default export */ var BookmarkItemFields = ((0,lib/* gql */.Ps)(BookmarkItemFields_templateObject(), StoryFields, project/* ProjectCardFieldsFragment */.SS));

;// CONCATENATED MODULE: ./lib/queries/UserBookmarksQuery.ts

function UserBookmarksQuery_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query UserBookmarks($slug: String!) {\n    user(slug: $slug) {\n      ... on GovernmentUser {\n        _id\n        bookmarks {\n          ...BookmarkItem\n        }\n      }\n      ... on VendorUser {\n        _id\n        bookmarks {\n          ...BookmarkItem\n        }\n      }\n      ... on PendingUser {\n        _id\n        bookmarks {\n          ...BookmarkItem\n        }\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    UserBookmarksQuery_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ var UserBookmarksQuery = ((0,lib/* gql */.Ps)(UserBookmarksQuery_templateObject(), BookmarkItemFields));

;// CONCATENATED MODULE: ./lib/queries/UserProjectsQuery.ts

function UserProjectsQuery_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query UserProjects($slug: String!, $cursor: Cursor) {\n    user(slug: $slug) {\n      ... on GovernmentUser {\n        _id\n        projectsCount\n        government {\n          _id\n          slug\n          name\n          state\n        }\n        projects(cursor: $cursor, limit: 8) {\n          items {\n            _id\n            ...ProjectCardFields\n          }\n          pageInfo {\n            hasNextPage\n            endCursor\n          }\n        }\n        projectsFromGovernment {\n          _id\n          ...ProjectCardFields\n        }\n        relatedProjects {\n          _id\n          ...ProjectCardFields\n        }\n      }\n\n      ... on VendorUser {\n        _id\n        projectsCount\n        company {\n          _id\n          slug\n          name\n        }\n        projects(cursor: $cursor, limit: 8) {\n          items {\n            _id\n            ...ProjectCardFields\n          }\n          pageInfo {\n            hasNextPage\n            endCursor\n          }\n        }\n      }\n\n      ... on PendingUser {\n        _id\n        projects(cursor: $cursor, limit: 8) {\n          items {\n            _id\n            ...ProjectCardFields\n          }\n          pageInfo {\n            hasNextPage\n            endCursor\n          }\n        }\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    UserProjectsQuery_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ var UserProjectsQuery = ((0,lib/* gql */.Ps)(UserProjectsQuery_templateObject(), project/* ProjectCardFieldsFragment */.SS));

;// CONCATENATED MODULE: ./lib/queries/UserStoriesQuery.ts

function UserStoriesQuery_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query UserStories($slug: String!, $cursor: Cursor) {\n    user(slug: $slug) {\n      ... on GovernmentUser {\n        _id\n        stories(cursor: $cursor, limit: 8) {\n          items {\n            _id\n            ...StoryFieldsLegacy\n            storyStatus: status\n          }\n          pageInfo {\n            hasNextPage\n            endCursor\n          }\n        }\n      }\n      ... on PendingUser {\n        _id\n        stories(cursor: $cursor, limit: 8) {\n          items {\n            _id\n            ...StoryFieldsLegacy\n            storyStatus: status\n          }\n          pageInfo {\n            hasNextPage\n            endCursor\n          }\n        }\n      }\n      ... on VendorUser {\n        _id\n        stories(cursor: $cursor, limit: 8) {\n          items {\n            _id\n            ...StoryFieldsLegacy\n            storyStatus: status\n          }\n          pageInfo {\n            hasNextPage\n            endCursor\n          }\n        }\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    UserStoriesQuery_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ var UserStoriesQuery = ((0,lib/* gql */.Ps)(UserStoriesQuery_templateObject(), StoryFields));

// EXTERNAL MODULE: ./lib/utils/governmentStates.ts
var governmentStates = __webpack_require__(58707);
// EXTERNAL MODULE: ./lib/utils/notUndefinedOrNull.ts
var notUndefinedOrNull = __webpack_require__(86457);
// EXTERNAL MODULE: ./src/components/project/CreateProjectModal.tsx
var CreateProjectModal = __webpack_require__(23115);
// EXTERNAL MODULE: ./src/components/project/listing/ProjectsListing.tsx
var ProjectsListing = __webpack_require__(93921);
// EXTERNAL MODULE: ./types/types.ts
var types = __webpack_require__(43845);
;// CONCATENATED MODULE: ./components/user/Tabs.tsx





function Tabs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                                fragment GovernmentUserFragment on GovernmentUser {\n                                  _id\n                                  storiesCount\n                                }\n                              "
    ]);
    Tabs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n                                fragment PendingUserFragment on PendingUser {\n                                  _id\n                                  storiesCount\n                                }\n                              "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






































function PostsTab(param) {
    var user = param.user;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(spacings/* Margin */.Zt, {
        mt: 20,
        children: [
            !user.posts || user.posts.length === 0 && user.isSelfie && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyBlocks/* NoPosts */.o0, {}),
            user.posts && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: (0,mediaQueries/* default */.Z)({
                    display: "grid",
                    gridRowGap: 16
                }),
                children: user.posts.map(function(post) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PostFeedItem/* default */.Z, {
                        createdAt: post.createdAt,
                        post: {
                            _id: post._id,
                            body: post.body,
                            upvotesCount: post.upvotesCount,
                            commentsCount: post.commentsCount,
                            viewerDidBookmark: post.viewerDidBookmark,
                            viewerDidUpvote: post.viewerDidUpvote,
                            viewerCanEdit: post.viewerCanEdit,
                            viewerDidComment: post.viewerDidComment,
                            group: post.__typename === "GroupPost" ? post.group : null,
                            government: post.__typename === "GovernmentPost" ? post.government : null,
                            vendor: post.__typename === "VendorPost" ? post.vendor : null,
                            createdAt: post.createdAt,
                            author: post.author,
                            attachments: post.attachments,
                            links: post.links,
                            audience: post.audience
                        }
                    }, post._id);
                })
            }),
            user.__typename === "GovernmentUser" && user.posts.length <= 4 && user.government && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Query/* Query */.A, {
                query: ConnectQuery/* default */.Z,
                notifyOnNetworkStatusChange: true,
                variables: {
                    targetId: user.government._id,
                    targetType: types/* IConnectTargetType.Government */.QY.Government,
                    limit: 15,
                    beforeThisId: null,
                    excludeUser: user._id
                },
                children: function(param) {
                    var data = param.data, fetchMore = param.fetchMore, loading = param.loading;
                    if (!data || !user.government) {
                        return null;
                    }
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                mt: 26,
                                mb: 16,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h2", {
                                    css: {
                                        margin: 0,
                                        color: palette/* sealBlue */.N9,
                                        fontWeight: "normal",
                                        fontSize: 16
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "From {name}",
                                        id: "6ERahF",
                                        values: {
                                            name: user.government.name
                                        }
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                css: {
                                    display: "grid",
                                    gridRowGap: 16
                                },
                                children: [
                                    data && data.connect && data.connect.items && data.connect.items.map(function(feedItem) {
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeedItem/* default */.Z, {
                                            feedItem: feedItem
                                        }, feedItem._id);
                                    }),
                                    loading && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoadingFeedCard/* default */.Z, {}),
                                    !loading && data && data.connect.items.length > 0 && data.connect.items.length < data.connect.totalCount && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("button", {
                                        type: "button",
                                        css: {
                                            justifySelf: "center",
                                            color: palette/* primary */.T$,
                                            fontWeight: 600,
                                            fontSize: 13,
                                            letterSpacing: 1,
                                            textTransform: "uppercase",
                                            background: "none",
                                            border: "none",
                                            outline: "none",
                                            cursor: "pointer"
                                        },
                                        onClick: function() {
                                            if (!data || !user.government) {
                                                return null;
                                            }
                                            fetchMore({
                                                query: ConnectQuery/* default */.Z,
                                                variables: {
                                                    targetId: user.government._id,
                                                    targetType: types/* IConnectTargetType.Government */.QY.Government,
                                                    beforeThisId: data.connect.items[data.connect.items.length - 1]._id,
                                                    limit: 15,
                                                    excludeUser: user._id
                                                },
                                                updateQuery: function(previousQueryResult, param) {
                                                    var fetchMoreResult = param.fetchMoreResult;
                                                    if (fetchMoreResult) {
                                                        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, previousQueryResult), {
                                                            connect: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, fetchMoreResult.connect), {
                                                                items: (0,_to_consumable_array/* default */.Z)(previousQueryResult.connect.items).concat((0,_to_consumable_array/* default */.Z)(fetchMoreResult.connect.items))
                                                            })
                                                        });
                                                    }
                                                    return previousQueryResult;
                                                }
                                            });
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                defaultMessage: "View more",
                                                id: "34Up+l"
                                            }),
                                            " ↓"
                                        ]
                                    })
                                ]
                            })
                        ]
                    });
                }
            })
        ]
    });
}
function StoriesTab(param) {
    var user = param.user;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            (0,fp.get)("government.viewerIsMember", user) && user && user.__typename === "GovernmentUser" && user.isInnovator && user.isSelfie && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                mt: 20,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WriteStory, {})
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                mt: 20,
                children: user.storiesCount === 0 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NoPublishedStories, {
                    user: user
                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Stories, {
                    user: user
                })
            })
        ]
    });
}
function ProjectsTab(param) {
    var user = param.user;
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
        mt: 20,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Query/* Query */.A, {
            query: UserProjectsQuery,
            notifyOnNetworkStatusChange: true,
            variables: {
                slug: user.slug || "",
                cursor: null
            },
            children: function(param) {
                var data = param.data, loading = param.loading, fetchMore = param.fetchMore;
                var ref, ref1;
                if (!data || !data.user || loading) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: {
                            display: "flex",
                            justifyContent: "center"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* LoadingIndicator */.TF, {})
                    });
                }
                var userProjects = data.user.projects && data.user.projects.items ? data.user.projects.items : [];
                var governmentProjects = data.user.__typename === "GovernmentUser" ? clampProjects(data.user.projectsFromGovernment, userProjects.length) : [];
                var relatedProjects = data.user.__typename === "GovernmentUser" ? clampProjects(data.user.relatedProjects, userProjects.length + governmentProjects.length) : [];
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    children: [
                        userProjects.length === 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NoProjectsBlock, {
                            user: user
                        }),
                        userProjects.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            "data-intercom-target": user.isSelfie ? "User Projects" : null,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProjectsListing/* default */.Z, {
                                withAddProjectSlot: user.__typename !== "PendingUser" && user.isSelfie || false,
                                projects: userProjects,
                                gridProps: {
                                    columns: [
                                        1,
                                        1,
                                        2
                                    ],
                                    spacingY: 6
                                },
                                hasNextPage: ((ref = data.user.projects) === null || ref === void 0 ? void 0 : (ref1 = ref.pageInfo) === null || ref1 === void 0 ? void 0 : ref1.hasNextPage) || false,
                                onModalClose: function() {
                                    router.push("/[userSlug]/[[...tab]]", "/@".concat(user.slug, "/projects"));
                                },
                                onLoadMore: function() {
                                    fetchMore({
                                        variables: {
                                            slug: user.slug,
                                            cursor: data.user.projects.pageInfo.endCursor
                                        },
                                        updateQuery: function(previousResult, param) {
                                            var fetchMoreResult = param.fetchMoreResult;
                                            if (!fetchMoreResult) {
                                                return previousResult;
                                            }
                                            return {
                                                __typename: "Query",
                                                user: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, fetchMoreResult.user), {
                                                    projects: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                        __typename: "Projects"
                                                    }, fetchMoreResult.user.projects), {
                                                        items: previousResult.user.projects.items.concat(fetchMoreResult.user.projects.items),
                                                        pageInfo: (0,_object_spread/* default */.Z)({}, fetchMoreResult.user.projects.pageInfo)
                                                    })
                                                })
                                            };
                                        }
                                    });
                                }
                            })
                        }),
                        data.user && data.user.__typename === "GovernmentUser" && data.user.government && governmentProjects.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                    my: 30,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h1", {
                                        css: {
                                            fontSize: 16,
                                            color: palette/* mediumGray */.rF,
                                            fontWeight: 400
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "From <government>{governmentName}</government>",
                                            id: "hbMGfD",
                                            values: {
                                                governmentName: data.user.government.name,
                                                // eslint-disable-next-line
                                                government: function() {
                                                    if (data.user && data.user.__typename === "GovernmentUser" && data.user.government) {
                                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                                            href: "/governments/[governmentSlug]/[[...content]]",
                                                            as: "/governments/".concat(data.user.government.slug),
                                                            passHref: true,
                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                                                css: {
                                                                    color: palette/* darkGray */.O5,
                                                                    fontWeight: "bold",
                                                                    ":hover": {
                                                                        textDecoration: "underline !important"
                                                                    }
                                                                },
                                                                children: data.user.government.name
                                                            })
                                                        });
                                                    }
                                                    return null;
                                                }
                                            }
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProjectsListing/* default */.Z, {
                                    projects: governmentProjects,
                                    onModalClose: function() {
                                        router.push("/[userSlug]/[[...tab]]", "/@".concat(user.slug, "/projects"));
                                    },
                                    gridProps: {
                                        columns: [
                                            1,
                                            1,
                                            2
                                        ],
                                        spacingY: 6
                                    }
                                })
                            ]
                        }),
                        relatedProjects.length > 0 && data.user.__typename === "GovernmentUser" && data.user.government && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                    my: 30,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("h1", {
                                        css: {
                                            color: palette/* mediumGray */.rF,
                                            fontWeight: 400,
                                            fontSize: 16
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                defaultMessage: "From other governments in",
                                                id: "jl/ere"
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                css: {
                                                    color: palette/* darkGray */.O5,
                                                    fontWeight: "bold"
                                                },
                                                children: governmentStates/* default */.Z[data.user.government.state]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProjectsListing/* default */.Z, {
                                    projects: relatedProjects,
                                    onModalClose: function() {
                                        router.push("/[userSlug]/[[...tab]]", "/@".concat(user.slug, "/projects"));
                                    },
                                    gridProps: {
                                        columns: [
                                            1,
                                            1,
                                            2
                                        ],
                                        spacingY: 6
                                    }
                                })
                            ]
                        })
                    ]
                });
            }
        })
    });
}
function getDefaultFilter(user, subtab) {
    if (subtab) {
        return subtab;
    }
    if (user.savedPostsCount > 0) {
        return "posts";
    }
    if (user.savedProjectsCount > 0) {
        return "projects";
    }
    if (user.savedStoriesCount > 0) {
        return "stories";
    }
    if (user.savedProductsCount > 0) {
        return "products";
    }
    return "projects";
}
var SavedTab = function(param) {
    var user = param.user, subtab = param.subtab;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(getDefaultFilter(user, subtab)), 2), filter = ref[0], setFilter = ref[1];
    var router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Query/* Query */.A, {
        query: UserBookmarksQuery,
        variables: {
            slug: user.slug
        },
        fetchPolicy: "network-only",
        children: function(param) {
            var data = param.data, loading = param.loading;
            if (loading) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                    mt: 20,
                    mb: 20,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: {
                            display: "flex",
                            flex: 1,
                            justifyContent: "center",
                            padding: "30px 0",
                            backgroundColor: palette/* white */.ix,
                            border: "solid 1px ".concat(palette/* lightestSealBlue */.ks),
                            borderRadius: 4
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Loader */.aN, {})
                    })
                });
            } else if (!data || !data.user) {
                return null;
            }
            var bookmarks = data.user.bookmarks;
            if (!bookmarks) {
                return null;
            }
            var filtered = bookmarks.filter(function(bookmark) {
                if (bookmark === null) {
                    return false;
                }
                if (filter === "all") {
                    return [
                        "Story",
                        "Product"
                    ].includes(bookmark.__typename);
                } else if (filter === "stories") {
                    return bookmark.__typename === "Story";
                } else if (filter === "projects") {
                    return [
                        "GroupProject",
                        "GovernmentProject",
                        "VendorProject"
                    ].includes(bookmark.__typename);
                } else if (filter === "products") {
                    return bookmark.__typename === "Product";
                } else if (filter === "posts") {
                    return [
                        "GroupPost",
                        "GovernmentPost",
                        "VendorPost"
                    ].includes(bookmark.__typename);
                } else {
                    return false;
                }
            });
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* RowWrap */.xv, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Col */.JX, {
                    width: [
                        1,
                        1,
                        1,
                        1
                    ],
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                        my: 20,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                            css: {
                                flex: 1,
                                backgroundColor: palette/* white */.ix,
                                border: "solid 1px ".concat(palette/* lightestSealBlue */.ks),
                                borderRadius: 4
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    css: {
                                        display: "flex",
                                        flexDirection: "row",
                                        alignItems: "center",
                                        padding: 15,
                                        overflow: "hidden",
                                        borderBottom: "solid 1px ".concat(palette/* lightestGray */.v2)
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                        css: {
                                            display: "inline-flex",
                                            "& > :not(:last-of-type)": {
                                                marginRight: 5
                                            }
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                role: "button",
                                                onClick: function() {
                                                    return setFilter("posts");
                                                },
                                                css: {
                                                    padding: "5px 10px",
                                                    fontSize: 12,
                                                    backgroundColor: filter === "posts" ? palette/* lightBlue */.f7 : palette/* lightestSealBlue */.ks,
                                                    borderRadius: 20,
                                                    cursor: "pointer",
                                                    userSelect: "none"
                                                },
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                    defaultMessage: "Posts",
                                                    id: "eR3YIn"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                role: "button",
                                                onClick: function() {
                                                    return setFilter("projects");
                                                },
                                                css: {
                                                    padding: "5px 10px",
                                                    fontSize: 12,
                                                    backgroundColor: filter === "projects" ? palette/* lightBlue */.f7 : palette/* lightestSealBlue */.ks,
                                                    borderRadius: 20,
                                                    cursor: "pointer",
                                                    userSelect: "none"
                                                },
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                    defaultMessage: "Projects",
                                                    id: "UxTJRa"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                role: "button",
                                                onClick: function() {
                                                    return setFilter("stories");
                                                },
                                                css: {
                                                    padding: "5px 10px",
                                                    fontSize: 12,
                                                    backgroundColor: filter === "stories" ? palette/* lightBlue */.f7 : palette/* lightestSealBlue */.ks,
                                                    borderRadius: 20,
                                                    cursor: "pointer",
                                                    userSelect: "none"
                                                },
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                    defaultMessage: "Stories",
                                                    id: "Ldxym4"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                role: "button",
                                                onClick: function() {
                                                    return setFilter("products");
                                                },
                                                css: {
                                                    padding: "5px 10px",
                                                    fontSize: 12,
                                                    backgroundColor: filter === "products" ? palette/* lightBlue */.f7 : palette/* lightestSealBlue */.ks,
                                                    borderRadius: 20,
                                                    cursor: "pointer",
                                                    userSelect: "none"
                                                },
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                    defaultMessage: "Products",
                                                    id: "7NFfmz"
                                                })
                                            })
                                        ]
                                    })
                                }),
                                filtered.length === 0 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyBlocks/* NoSaved */.s1, {
                                    css: {
                                        border: 0
                                    }
                                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                    children: [
                                        filter === "posts" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                            css: (0,mediaQueries/* default */.Z)({
                                                display: "grid",
                                                gridRowGap: 24,
                                                padding: 16
                                            }),
                                            children: filtered.map(function(bookmark) {
                                                if (bookmark && (bookmark.__typename === "GroupPost" || bookmark.__typename === "GovernmentPost" || bookmark.__typename === "VendorPost")) {
                                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PostFeedItem/* default */.Z, {
                                                        createdAt: bookmark.createdAt,
                                                        post: {
                                                            _id: bookmark._id,
                                                            body: bookmark.body,
                                                            upvotesCount: bookmark.upvotesCount,
                                                            commentsCount: bookmark.commentsCount,
                                                            viewerDidBookmark: bookmark.viewerDidBookmark,
                                                            viewerDidUpvote: bookmark.viewerDidUpvote,
                                                            viewerCanEdit: bookmark.viewerCanEdit,
                                                            viewerDidComment: bookmark.viewerDidComment,
                                                            group: bookmark.__typename === "GroupPost" ? bookmark.postGroup : null,
                                                            government: bookmark.__typename === "GovernmentPost" ? bookmark.postGovernment : null,
                                                            vendor: bookmark.__typename === "VendorPost" ? bookmark.postVendor : null,
                                                            createdAt: bookmark.createdAt,
                                                            author: bookmark.postAuthor,
                                                            attachments: bookmark.postAttachments,
                                                            links: bookmark.postLinks,
                                                            audience: bookmark.audience
                                                        }
                                                    }, bookmark._id);
                                                }
                                                return null;
                                            })
                                        }),
                                        filter === "projects" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProjectsListing/* default */.Z, {
                                            projects: filtered,
                                            onModalClose: function() {
                                                router.push("/[userSlug]/[[...tab]]", "/@".concat(user.slug, "/saved"));
                                            },
                                            gridProps: {
                                                columns: [
                                                    1,
                                                    1,
                                                    2
                                                ],
                                                spacingY: 6,
                                                margin: 4
                                            }
                                        }),
                                        filter === "stories" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoryListItemDividers/* default */.Z, {
                                            children: filtered.filter(notUndefinedOrNull/* default */.Z).map(function(bookmark) {
                                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoryListItemHoverContainer/* default */.Z, {
                                                    css: {
                                                        padding: 15
                                                    },
                                                    children: bookmark.__typename === "Story" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoryListItem/* default */.Z, {
                                                        story: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, bookmark), {
                                                            government: bookmark.storyGovernment
                                                        })
                                                    })
                                                }, bookmark._id);
                                            })
                                        }),
                                        filter === "products" && filtered.map(function(bookmark) {
                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ToggleBookmark/* default */.Z, {
                                                viewerDidBookmark: bookmark.viewerDidBookmark,
                                                targetId: bookmark._id,
                                                targetType: "PRODUCT",
                                                children: function(toggle) {
                                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                        css: {
                                                            borderTop: "solid 1px ".concat(palette/* lightestGray */.v2)
                                                        },
                                                        children: bookmark.__typename === "Product" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProductListItem, {
                                                            product: bookmark,
                                                            onBookmark: toggle
                                                        })
                                                    });
                                                }
                                            }, bookmark._id);
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            });
        }
    });
};
var WriteStory = function() {
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_powerplug_esm/* Value */.B4, {
        initial: "",
        children: function(param) {
            var value = param.value, set = param.set;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: {
                    padding: 15,
                    backgroundColor: "#f0f5ff",
                    border: "solid 1px ".concat(palette/* lightestGray */.v2),
                    borderRadius: 5
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                        css: {
                            display: "block",
                            marginBottom: 10,
                            color: palette/* mediumGray */.rF,
                            fontSize: 12,
                            textTransform: "uppercase"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Share your story",
                            id: "skGiBU"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                        css: {
                            fontSize: 16,
                            fontWeight: 600,
                            color: palette/* darkGray */.O5
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Pitch your story in one sentence",
                            id: "IBWque"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        css: {
                            display: "flex",
                            alignItems: "center",
                            marginTop: 10
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("input", {
                                onChange: function(event) {
                                    return set(event.target.value);
                                },
                                css: {
                                    flex: 1,
                                    height: 36,
                                    padding: 10,
                                    fontSize: 14,
                                    border: "solid 1px ".concat(palette/* lightSealBlue */.oz),
                                    borderRadius: 5,
                                    outline: 0,
                                    "&:focus": {
                                        border: "solid 1px ".concat(palette/* primary */.T$)
                                    },
                                    placeholder: intl.formatMessage({
                                        defaultMessage: "Begin typing the title of your story...",
                                        id: "q4Yt/6"
                                    })
                                }
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                css: {
                                    display: "inline-flex"
                                },
                                ml: 10,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                    href: value ? "/create-story?title=".concat(encodeURIComponent(value)) : "/create-story",
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* AnchorButton */.AN, {
                                        theme: "primary",
                                        css: {
                                            height: 36,
                                            paddingRight: 30,
                                            paddingLeft: 30,
                                            color: palette/* white */.ix,
                                            fontWeight: 400,
                                            fontSize: 12,
                                            letterSpacing: 0.1
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Start",
                                            id: "mOFG3K"
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                        css: {
                            display: "block",
                            marginTop: 10,
                            color: palette/* mediumGray */.rF,
                            fontSize: 12
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Please be descriptive and limit buzzwords. Don't worry, you'll be able to edit this \uD83D\uDE09",
                            id: "2TZ6Nj"
                        })
                    })
                ]
            });
        }
    });
};
var NoPublishedStories = function(param) {
    var user = param.user;
    if (user.isSelfie) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                padding: 60,
                backgroundColor: palette/* white */.ix,
                border: "solid 1px ".concat(palette/* lightestGray */.v2),
                borderRadius: 5
            },
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Empty, {}),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    css: {
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        marginTop: 20,
                        color: palette/* mediumGray */.rF,
                        textAlign: "center"
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        css: {
                            display: "grid",
                            gridRowGap: 15
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("p", {
                                css: {
                                    margin: 0,
                                    color: palette/* darkGray */.O5,
                                    fontWeight: "bold",
                                    fontSize: 18
                                },
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "There are no published stories for you",
                                        id: "aB3gpL"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Emoji, {
                                        children: "\uD83D\uDE1E"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                css: {
                                    maxWidth: 380,
                                    margin: 0,
                                    fontWeight: 400,
                                    fontSize: 14
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Stories allow you to quickly share how technology or creative practices are being used to improve your community.",
                                    id: "C49ST3"
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Auth/* default */.ZP, {
                                children: function(param) {
                                    var user = param.user;
                                    if (user && user.__typename === "GovernmentUser" && user.isInnovator) {
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                            href: "/create-story",
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* AnchorButton */.AN, {
                                                color: palette/* innovatorBlue */.LD,
                                                style: {
                                                    paddingRight: 50,
                                                    paddingLeft: 50,
                                                    fontWeight: 500
                                                },
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                    defaultMessage: "Write my first Story",
                                                    id: "8qcpnw"
                                                })
                                            })
                                        });
                                    } else {
                                        return null;
                                    }
                                }
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("p", {
                                css: {
                                    margin: 0,
                                    fontWeight: 400,
                                    fontSize: 14
                                },
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "Have something to share but don't have the time?",
                                        id: "nmV1TC"
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                        href: "mailto:hello@govlaunch.com",
                                        css: {
                                            color: palette/* primary */.T$
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Contact us",
                                            id: "WnQ/AZ"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        });
    } else {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Screen/* default */.ZP, {
            children: function(param) {
                var isMobile = param.isMobile;
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                    css: {
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: 60,
                        backgroundColor: palette/* white */.ix,
                        border: "solid 1px ".concat(palette/* lightestGray */.v2),
                        borderRadius: 5
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Empty, {
                            height: isMobile ? 250 : 400,
                            width: isMobile ? 300 : 600
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: {
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                color: palette/* mediumGray */.rF,
                                textAlign: "center"
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(spacings/* Margin */.Zt, {
                                mt: 15,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                        css: {
                                            margin: 0,
                                            color: palette/* darkGray */.O5,
                                            fontWeight: "bold",
                                            fontSize: 18
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "There are no published stories for {firstName}",
                                            id: "fV6OXh",
                                            values: {
                                                firstName: user.firstName
                                            }
                                        })
                                    }),
                                    user.isSelfie && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                                css: {
                                                    margin: 0,
                                                    fontWeight: 400,
                                                    fontSize: 14
                                                },
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                    defaultMessage: "Help {firstName} and collaborate on a story!",
                                                    id: "Bu6aVz",
                                                    values: {
                                                        firstName: user.firstName
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                                css: {
                                                    maxWidth: 370,
                                                    margin: 0,
                                                    fontWeight: 400,
                                                    fontSize: 14
                                                },
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                    defaultMessage: "You can always <mailto>contact us</mailto> if you need any help collaborating on stories or creating content.",
                                                    id: "/YaFZP",
                                                    values: {
                                                        // eslint-disable-next-line
                                                        mailto: function(children) {
                                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                                                href: "mailto:hello@govlaunch.com",
                                                                css: {
                                                                    color: palette/* primary */.T$
                                                                },
                                                                children: children
                                                            });
                                                        }
                                                    }
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                });
            }
        });
    }
};
function writeSavedStoriesCount(cache, id, fragment) {
    var cachedUser = cache.readFragment({
        fragment: fragment,
        id: id
    });
    if (!cachedUser) {
        return;
    }
    cache.writeFragment({
        fragment: fragment,
        id: id,
        data: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cachedUser), {
            storiesCount: cachedUser.storiesCount - 1
        })
    });
}
function Stories(param) {
    var user = param.user;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Query/* Query */.A, {
        notifyOnNetworkStatusChange: true,
        query: UserStoriesQuery,
        variables: {
            slug: user.slug,
            cursor: null
        },
        children: function(param) {
            var data = param.data, loading = param.loading, fetchMore = param.fetchMore, refetch = param.refetch;
            if (!data || !data.user) {
                return null;
            }
            var stories = data.user.stories;
            if (!stories) {
                return null;
            }
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* RowWrap */.xv, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Col */.JX, {
                    width: 1,
                    order: [
                        2,
                        2,
                        1,
                        1
                    ],
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        css: {
                            backgroundColor: palette/* white */.ix,
                            border: "solid 1px ".concat(palette/* lightestGray */.v2),
                            borderRadius: 5
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                css: {
                                    padding: 15,
                                    color: palette/* sealBlue */.N9,
                                    fontWeight: 500,
                                    fontSize: 12,
                                    letterSpacing: 0.5,
                                    textTransform: "uppercase",
                                    borderBottom: "solid 1px ".concat(palette/* lightestGray */.v2)
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Stories {count}",
                                    id: "HKcOm0",
                                    values: {
                                        count: user.storiesCount || 0
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ApolloConsumer/* ApolloConsumer */.a, {
                                children: function(param) {
                                    var cache = param.cache;
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoryListItemActionsContext.Provider, {
                                        value: {
                                            onUnpublish: function() {},
                                            onDelete: function() {
                                                if (user.__typename === "GovernmentUser") {
                                                    writeSavedStoriesCount(cache, "GovernmentUser:".concat(user._id), (0,lib/* gql */.Ps)(Tabs_templateObject()));
                                                } else if (user.__typename === "PendingUser") {
                                                    writeSavedStoriesCount(cache, "PendingUser:".concat(user._id), (0,lib/* gql */.Ps)(_templateObject1()));
                                                }
                                                refetch();
                                            }
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoryListItemDividers/* default */.Z, {
                                            children: (stories.items || []).map(function(story) {
                                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoryListItemHoverContainer/* default */.Z, {
                                                    css: {
                                                        padding: 15
                                                    },
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoryListItem/* default */.Z, {
                                                        story: story
                                                    })
                                                }, story._id);
                                            })
                                        })
                                    });
                                }
                            }),
                            stories.pageInfo.hasNextPage && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, {
                                onClick: function() {
                                    fetchMore({
                                        variables: {
                                            slug: user.slug,
                                            cursor: stories.pageInfo.endCursor
                                        },
                                        updateQuery: function(previousResult, param) {
                                            var fetchMoreResult = param.fetchMoreResult;
                                            if (!fetchMoreResult) {
                                                return previousResult;
                                            }
                                            return {
                                                __typename: "Query",
                                                user: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, fetchMoreResult.user), {
                                                    stories: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                        __typename: "Stories"
                                                    }, fetchMoreResult.user.stories), {
                                                        items: previousResult.user.stories.items.concat(fetchMoreResult.user.stories.items),
                                                        pageInfo: (0,_object_spread/* default */.Z)({}, fetchMoreResult.user.stories.pageInfo)
                                                    })
                                                })
                                            };
                                        }
                                    });
                                },
                                css: {
                                    zIndex: 9999,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    width: "100%",
                                    margin: 1,
                                    padding: 10,
                                    color: palette/* sealBlue */.N9,
                                    fontWeight: 500,
                                    fontSize: 12,
                                    textTransform: "uppercase",
                                    backgroundColor: palette/* white */.ix,
                                    border: "none",
                                    // TODO: needs to combo with <PopularStory> hover
                                    outline: "none",
                                    cursor: loading ? "default" : "pointer",
                                    "&:active": {
                                        opacity: 0.7
                                    },
                                    marginmt: 0
                                },
                                disabled: loading ? true : false,
                                children: loading ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Loading",
                                    id: "iFsDVR"
                                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Show more",
                                    id: "aWpBzj"
                                })
                            })
                        ]
                    })
                })
            });
        }
    });
}
function clampProjects(projects, showingProjects) {
    if (showingProjects <= 2) {
        return projects;
    }
    if (showingProjects <= 6) {
        return projects.slice(0, 2);
    }
    return [];
}
var NoProjectsBlock = function(param) {
    var user = param.user;
    var ref = (0,react.useState)(false), showCreateProjectModal = ref[0], setShowCreateProjectModal = ref[1];
    if (!user.isSelfie) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            css: {
                background: "#fff",
                border: "1px solid ".concat(palette/* lightestGray */.v2),
                padding: 24
            },
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: {
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    textAlign: "center",
                    maxWidth: 400,
                    margin: "0 auto"
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProjectIcon/* default */.Z, {
                        width: 80,
                        height: 80
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                        css: {
                            margin: "12px 0 0 0",
                            color: palette/* text */.fL,
                            fontWeight: 500,
                            fontSize: 16
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "{firstName} hasn't created any project yet",
                            id: "8hsuOz"
                        })
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(spacings/* Margin */.Zt, {
        mt: 16,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NoProjectsBox/* default */.Z, {
                onAddProject: function() {
                    return setShowCreateProjectModal(true);
                },
                dataIntercomTarget: "User Projects",
                addButtonIntercomTarget: "User Add Project"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CreateProjectModal/* default */.Z, {
                isOpen: showCreateProjectModal,
                onClose: function() {
                    return setShowCreateProjectModal(false);
                }
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(29452);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@12.2.5_cejl76k2qxbp2ab75jaaojpzhe/node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(45597);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/fp/pick.js
var pick = __webpack_require__(4074);
var pick_default = /*#__PURE__*/__webpack_require__.n(pick);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-final-form@6.5.9_s44h3cxpdxv6cks4bnqewerqda/node_modules/react-final-form/dist/react-final-form.es.js
var react_final_form_es = __webpack_require__(56225);
// EXTERNAL MODULE: ./node_modules/.pnpm/yup@0.32.11/node_modules/yup/es/index.js + 25 modules
var yup_es = __webpack_require__(55423);
// EXTERNAL MODULE: ./intl/locales.ts
var locales = __webpack_require__(30629);
// EXTERNAL MODULE: ./lib/hooks/useIntlValidationMessages.ts
var useIntlValidationMessages = __webpack_require__(67308);
// EXTERNAL MODULE: ./lib/hooks/useIsPhone.ts
var useIsPhone = __webpack_require__(57733);
// EXTERNAL MODULE: ./lib/queries/fragments/CompanyPlanFields.ts
var CompanyPlanFields = __webpack_require__(28896);
// EXTERNAL MODULE: ./lib/queries/fragments/CompanyPlanUsageFields.ts
var CompanyPlanUsageFields = __webpack_require__(71505);
// EXTERNAL MODULE: ./lib/queries/fragments/CompanySubscription.ts
var CompanySubscription = __webpack_require__(77438);
// EXTERNAL MODULE: ./lib/queries/fragments/StripeChargeFields.ts
var StripeChargeFields = __webpack_require__(11115);
;// CONCATENATED MODULE: ./lib/mutations/UpdateProfile.ts

function UpdateProfile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation UpdateProfile($user: UserProfileInput!) {\n    updateProfile(user: $user) {\n      ... on GovernmentUser {\n        _id\n        slug\n        role\n        firstName\n        lastName\n        fullName\n        avatar\n        isInnovator\n        jobTitle\n        lastSeen\n        email\n        notificationEmail\n        department {\n          _id\n          name\n        }\n        interests {\n          _id\n          name\n        }\n        searchable\n        preferences {\n          showAsAuthorOnProjects\n        }\n        socialMedia {\n          linkedin\n          facebook\n          instagram\n          youtube\n          twitter\n        }\n        linkedinUrl\n        projectsCount\n        isSiteAdmin\n        isLimitedSiteAdmin\n        verified\n        government {\n          _id\n          name\n          slug\n          logo\n          projectsCount\n          membersCount\n          feedCount\n          productsCount\n          actionsCount\n        }\n        algoliaKeys {\n          default\n          projects\n        }\n        groups {\n          _id\n          slug\n          name\n          logo\n          location\n        }\n        lastSignInAt\n        showActionCenterBanner\n        showOnboardingBanner\n        canSeeActiveGovernments\n        country\n        language\n        timeZone\n      }\n      ... on VendorUser {\n        _id\n        slug\n        role\n        firstName\n        lastName\n        fullName\n        avatar\n        isDisruptor\n        jobTitle\n        lastSeen\n        email\n        notificationEmail\n        department {\n          _id\n          name\n        }\n        interests {\n          _id\n          name\n        }\n        searchable\n        preferences {\n          showAsAuthorOnProjects\n        }\n        socialMedia {\n          linkedin\n          facebook\n          instagram\n          youtube\n          twitter\n        }\n        linkedinUrl\n        isSiteAdmin\n        isLimitedSiteAdmin\n        verified\n        company {\n          _id\n          name\n          slug\n          viewerCanInviteMembers\n          logo\n          isDisruptor\n          feedCount\n          productsCount\n          projectsCount\n          governmentConnectionsCount\n          storiesCount\n          actionsCount\n          groups {\n            _id\n          }\n          planUsage {\n            ...CompanyPlanUsageFields\n          }\n          ...CompanySubscription\n          plan {\n            ...CompanyPlanFields\n          }\n        }\n        algoliaKeys {\n          default\n          projects\n        }\n        groups {\n          _id\n          slug\n          name\n          logo\n          location\n        }\n        lastSignInAt\n        showActionCenterBanner\n        showOnboardingBanner\n        canSeeActiveGovernments\n        country\n        language\n        timeZone\n      }\n      ... on PendingUser {\n        _id\n        slug\n        role\n        firstName\n        lastName\n        fullName\n        avatar\n        jobTitle\n        lastSeen\n        email\n        notificationEmail\n        department {\n          _id\n          name\n        }\n        interests {\n          _id\n          name\n        }\n        searchable\n        preferences {\n          showAsAuthorOnProjects\n        }\n        socialMedia {\n          linkedin\n          facebook\n          instagram\n          youtube\n          twitter\n        }\n        linkedinUrl\n        verified\n        isSiteAdmin\n        isLimitedSiteAdmin\n        viewerCouldNotJoinReason\n        algoliaKeys {\n          default\n          projects\n        }\n        groups {\n          _id\n          slug\n          name\n          logo\n          location\n        }\n        lastSignInAt\n        showOnboardingBanner\n        canSeeActiveGovernments\n        country\n        language\n        timeZone\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    UpdateProfile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}





/* harmony default export */ var UpdateProfile = ((0,lib/* gql */.Ps)(UpdateProfile_templateObject(), CompanyPlanUsageFields/* default */.Z, CompanySubscription/* default */.Z, StripeChargeFields/* default */.Z, CompanyPlanFields/* default */.Z));

// EXTERNAL MODULE: ./lib/utils/validate.ts
var validate = __webpack_require__(32774);
// EXTERNAL MODULE: ./lib/withIntl.tsx + 9 modules
var withIntl = __webpack_require__(21505);
// EXTERNAL MODULE: ./src/utils/countries.ts
var countries = __webpack_require__(25655);
;// CONCATENATED MODULE: ./src/utils/timezones.ts
var TZ = [
    {
        country: "CI",
        name: "Africa/Abidjan",
        status: "Canonical",
        offset: "+00:00",
        link: ""
    },
    {
        country: "GH",
        name: "Africa/Accra",
        status: "Canonical",
        offset: "+00:00",
        link: ""
    },
    {
        country: "ET",
        name: "Africa/Addis_Ababa",
        status: "Alias",
        offset: "+03:00",
        link: "Africa/Nairobi"
    },
    {
        country: "DZ",
        name: "Africa/Algiers",
        status: "Canonical",
        offset: "+01:00",
        link: ""
    },
    {
        country: "ER",
        name: "Africa/Asmara",
        status: "Alias",
        offset: "+03:00",
        link: "Africa/Nairobi"
    },
    {
        country: "ER",
        name: "Africa/Asmera",
        status: "Deprecated",
        offset: "+03:00",
        link: "Africa/Nairobi"
    },
    {
        country: "ML",
        name: "Africa/Bamako",
        status: "Alias",
        offset: "+00:00",
        link: "Africa/Abidjan"
    },
    {
        country: "CF",
        name: "Africa/Bangui",
        status: "Alias",
        offset: "+01:00",
        link: "Africa/Lagos"
    },
    {
        country: "GM",
        name: "Africa/Banjul",
        status: "Alias",
        offset: "+00:00",
        link: "Africa/Abidjan"
    },
    {
        country: "GW",
        name: "Africa/Bissau",
        status: "Canonical",
        offset: "+00:00",
        link: ""
    },
    {
        country: "MW",
        name: "Africa/Blantyre",
        status: "Alias",
        offset: "+02:00",
        link: "Africa/Maputo"
    },
    {
        country: "CG",
        name: "Africa/Brazzaville",
        status: "Alias",
        offset: "+01:00",
        link: "Africa/Lagos"
    },
    {
        country: "BI",
        name: "Africa/Bujumbura",
        status: "Alias",
        offset: "+02:00",
        link: "Africa/Maputo"
    },
    {
        country: "EG",
        name: "Africa/Cairo",
        status: "Canonical",
        offset: "+02:00",
        link: ""
    },
    {
        country: "MA",
        name: "Africa/Casablanca",
        status: "Canonical",
        offset: "+01:00",
        link: ""
    },
    {
        country: "ES",
        name: "Africa/Ceuta",
        status: "Canonical",
        offset: "+01:00",
        link: ""
    },
    {
        country: "GN",
        name: "Africa/Conakry",
        status: "Alias",
        offset: "+00:00",
        link: "Africa/Abidjan"
    },
    {
        country: "SN",
        name: "Africa/Dakar",
        status: "Alias",
        offset: "+00:00",
        link: "Africa/Abidjan"
    },
    {
        country: "TZ",
        name: "Africa/Dar_es_Salaam",
        status: "Alias",
        offset: "+03:00",
        link: "Africa/Nairobi"
    },
    {
        country: "DJ",
        name: "Africa/Djibouti",
        status: "Alias",
        offset: "+03:00",
        link: "Africa/Nairobi"
    },
    {
        country: "CM",
        name: "Africa/Douala",
        status: "Alias",
        offset: "+01:00",
        link: "Africa/Lagos"
    },
    {
        country: "EH",
        name: "Africa/El_Aaiun",
        status: "Canonical",
        offset: "+01:00",
        link: ""
    },
    {
        country: "SL",
        name: "Africa/Freetown",
        status: "Alias",
        offset: "+00:00",
        link: "Africa/Abidjan"
    },
    {
        country: "BW",
        name: "Africa/Gaborone",
        status: "Alias",
        offset: "+02:00",
        link: "Africa/Maputo"
    },
    {
        country: "ZW",
        name: "Africa/Harare",
        status: "Alias",
        offset: "+02:00",
        link: "Africa/Maputo"
    },
    {
        country: "ZA",
        name: "Africa/Johannesburg",
        status: "Canonical",
        offset: "+02:00",
        link: ""
    },
    {
        country: "SS",
        name: "Africa/Juba",
        status: "Canonical",
        offset: "+02:00",
        link: ""
    },
    {
        country: "UG",
        name: "Africa/Kampala",
        status: "Alias",
        offset: "+03:00",
        link: "Africa/Nairobi"
    },
    {
        country: "SD",
        name: "Africa/Khartoum",
        status: "Canonical",
        offset: "+02:00",
        link: ""
    },
    {
        country: "RW",
        name: "Africa/Kigali",
        status: "Alias",
        offset: "+02:00",
        link: "Africa/Maputo"
    },
    {
        country: "CD",
        name: "Africa/Kinshasa",
        status: "Alias",
        offset: "+01:00",
        link: "Africa/Lagos"
    },
    {
        country: "NG",
        name: "Africa/Lagos",
        status: "Canonical",
        offset: "+01:00",
        link: ""
    },
    {
        country: "GA",
        name: "Africa/Libreville",
        status: "Alias",
        offset: "+01:00",
        link: "Africa/Lagos"
    },
    {
        country: "TG",
        name: "Africa/Lome",
        status: "Alias",
        offset: "+00:00",
        link: "Africa/Abidjan"
    },
    {
        country: "AO",
        name: "Africa/Luanda",
        status: "Alias",
        offset: "+01:00",
        link: "Africa/Lagos"
    },
    {
        country: "CD",
        name: "Africa/Lubumbashi",
        status: "Alias",
        offset: "+02:00",
        link: "Africa/Maputo"
    },
    {
        country: "ZM",
        name: "Africa/Lusaka",
        status: "Alias",
        offset: "+02:00",
        link: "Africa/Maputo"
    },
    {
        country: "GQ",
        name: "Africa/Malabo",
        status: "Alias",
        offset: "+01:00",
        link: "Africa/Lagos"
    },
    {
        country: "MZ",
        name: "Africa/Maputo",
        status: "Canonical",
        offset: "+02:00",
        link: ""
    },
    {
        country: "LS",
        name: "Africa/Maseru",
        status: "Alias",
        offset: "+02:00",
        link: "Africa/Johannesburg"
    },
    {
        country: "SZ",
        name: "Africa/Mbabane",
        status: "Alias",
        offset: "+02:00",
        link: "Africa/Johannesburg"
    },
    {
        country: "SO",
        name: "Africa/Mogadishu",
        status: "Alias",
        offset: "+03:00",
        link: "Africa/Nairobi"
    },
    {
        country: "LR",
        name: "Africa/Monrovia",
        status: "Canonical",
        offset: "+00:00",
        link: ""
    },
    {
        country: "KE",
        name: "Africa/Nairobi",
        status: "Canonical",
        offset: "+03:00",
        link: ""
    },
    {
        country: "TD",
        name: "Africa/Ndjamena",
        status: "Canonical",
        offset: "+01:00",
        link: ""
    },
    {
        country: "NE",
        name: "Africa/Niamey",
        status: "Alias",
        offset: "+01:00",
        link: "Africa/Lagos"
    },
    {
        country: "MR",
        name: "Africa/Nouakchott",
        status: "Alias",
        offset: "+00:00",
        link: "Africa/Abidjan"
    },
    {
        country: "BF",
        name: "Africa/Ouagadougou",
        status: "Alias",
        offset: "+00:00",
        link: "Africa/Abidjan"
    },
    {
        country: "BJ",
        name: "Africa/Porto-Novo",
        status: "Alias",
        offset: "+01:00",
        link: "Africa/Lagos"
    },
    {
        country: "ST",
        name: "Africa/Sao_Tome",
        status: "Canonical",
        offset: "+00:00",
        link: ""
    },
    {
        country: "ML",
        name: "Africa/Timbuktu",
        status: "Deprecated",
        offset: "+00:00",
        link: "Africa/Abidjan"
    },
    {
        country: "LY",
        name: "Africa/Tripoli",
        status: "Canonical",
        offset: "+02:00",
        link: ""
    },
    {
        country: "TN",
        name: "Africa/Tunis",
        status: "Canonical",
        offset: "+01:00",
        link: ""
    },
    {
        country: "NA",
        name: "Africa/Windhoek",
        status: "Canonical",
        offset: "+02:00",
        link: ""
    },
    {
        country: "US",
        name: "America/Adak",
        status: "Canonical",
        offset: "−10:00",
        link: ""
    },
    {
        country: "US",
        name: "America/Anchorage",
        status: "Canonical",
        offset: "−09:00",
        link: ""
    },
    {
        country: "AI",
        name: "America/Anguilla",
        status: "Alias",
        offset: "−04:00",
        link: "America/Port_of_Spain"
    },
    {
        country: "AG",
        name: "America/Antigua",
        status: "Alias",
        offset: "−04:00",
        link: "America/Port_of_Spain"
    },
    {
        country: "BR",
        name: "America/Araguaina",
        status: "Canonical",
        offset: "−03:00",
        link: ""
    },
    {
        country: "AR",
        name: "America/Argentina/Buenos_Aires",
        status: "Canonical",
        offset: "−03:00",
        link: ""
    },
    {
        country: "AR",
        name: "America/Argentina/Catamarca",
        status: "Canonical",
        offset: "−03:00",
        link: ""
    },
    {
        country: "AR",
        name: "America/Argentina/ComodRivadavia",
        status: "Deprecated",
        offset: "−03:00",
        link: "America/Argentina/Catamarca"
    },
    {
        country: "AR",
        name: "America/Argentina/Cordoba",
        status: "Canonical",
        offset: "−03:00",
        link: ""
    },
    {
        country: "AR",
        name: "America/Argentina/Jujuy",
        status: "Canonical",
        offset: "−03:00",
        link: ""
    },
    {
        country: "AR",
        name: "America/Argentina/La_Rioja",
        status: "Canonical",
        offset: "−03:00",
        link: ""
    },
    {
        country: "AR",
        name: "America/Argentina/Mendoza",
        status: "Canonical",
        offset: "−03:00",
        link: ""
    },
    {
        country: "AR",
        name: "America/Argentina/Rio_Gallegos",
        status: "Canonical",
        offset: "−03:00",
        link: ""
    },
    {
        country: "AR",
        name: "America/Argentina/Salta",
        status: "Canonical",
        offset: "−03:00",
        link: ""
    },
    {
        country: "AR",
        name: "America/Argentina/San_Juan",
        status: "Canonical",
        offset: "−03:00",
        link: ""
    },
    {
        country: "AR",
        name: "America/Argentina/San_Luis",
        status: "Canonical",
        offset: "−03:00",
        link: ""
    },
    {
        country: "AR",
        name: "America/Argentina/Tucuman",
        status: "Canonical",
        offset: "−03:00",
        link: ""
    },
    {
        country: "AR",
        name: "America/Argentina/Ushuaia",
        status: "Canonical",
        offset: "−03:00",
        link: ""
    },
    {
        country: "AW",
        name: "America/Aruba",
        status: "Alias",
        offset: "−04:00",
        link: "America/Curacao"
    },
    {
        country: "PY",
        name: "America/Asuncion",
        status: "Canonical",
        offset: "−04:00",
        link: ""
    },
    {
        country: "CA",
        name: "America/Atikokan",
        status: "Canonical",
        offset: "−05:00",
        link: ""
    },
    {
        country: "US",
        name: "America/Atka",
        status: "Deprecated",
        offset: "−10:00",
        link: "America/Adak"
    },
    {
        country: "BR",
        name: "America/Bahia",
        status: "Canonical",
        offset: "−03:00",
        link: ""
    },
    {
        country: "MX",
        name: "America/Bahia_Banderas",
        status: "Canonical",
        offset: "−06:00",
        link: ""
    },
    {
        country: "BB",
        name: "America/Barbados",
        status: "Canonical",
        offset: "−04:00",
        link: ""
    },
    {
        country: "BR",
        name: "America/Belem",
        status: "Canonical",
        offset: "−03:00",
        link: ""
    },
    {
        country: "BZ",
        name: "America/Belize",
        status: "Canonical",
        offset: "−06:00",
        link: ""
    },
    {
        country: "CA",
        name: "America/Blanc-Sablon",
        status: "Canonical",
        offset: "−04:00",
        link: ""
    },
    {
        country: "BR",
        name: "America/Boa_Vista",
        status: "Canonical",
        offset: "−04:00",
        link: ""
    },
    {
        country: "CO",
        name: "America/Bogota",
        status: "Canonical",
        offset: "−05:00",
        link: ""
    },
    {
        country: "US",
        name: "America/Boise",
        status: "Canonical",
        offset: "−07:00",
        link: ""
    },
    {
        country: "AR",
        name: "America/Buenos_Aires",
        status: "Deprecated",
        offset: "−03:00",
        link: "America/Argentina/Buenos_Aires"
    },
    {
        country: "CA",
        name: "America/Cambridge_Bay",
        status: "Canonical",
        offset: "−07:00",
        link: ""
    },
    {
        country: "BR",
        name: "America/Campo_Grande",
        status: "Canonical",
        offset: "−04:00",
        link: ""
    },
    {
        country: "MX",
        name: "America/Cancun",
        status: "Canonical",
        offset: "−05:00",
        link: ""
    },
    {
        country: "VE",
        name: "America/Caracas",
        status: "Canonical",
        offset: "−04:00",
        link: ""
    },
    {
        country: "AR",
        name: "America/Catamarca",
        status: "Deprecated",
        offset: "−03:00",
        link: "America/Argentina/Catamarca"
    },
    {
        country: "GF",
        name: "America/Cayenne",
        status: "Canonical",
        offset: "−03:00",
        link: ""
    },
    {
        country: "KY",
        name: "America/Cayman",
        status: "Alias",
        offset: "−05:00",
        link: "America/Panama"
    },
    {
        country: "US",
        name: "America/Chicago",
        status: "Canonical",
        offset: "−06:00",
        link: ""
    },
    {
        country: "MX",
        name: "America/Chihuahua",
        status: "Canonical",
        offset: "−07:00",
        link: ""
    },
    {
        country: "CA",
        name: "America/Coral_Harbour",
        status: "Deprecated",
        offset: "−05:00",
        link: "America/Atikokan"
    },
    {
        country: "AR",
        name: "America/Cordoba",
        status: "Deprecated",
        offset: "−03:00",
        link: "America/Argentina/Cordoba"
    },
    {
        country: "CR",
        name: "America/Costa_Rica",
        status: "Canonical",
        offset: "−06:00",
        link: ""
    },
    {
        country: "CA",
        name: "America/Creston",
        status: "Canonical",
        offset: "−07:00",
        link: ""
    },
    {
        country: "BR",
        name: "America/Cuiaba",
        status: "Canonical",
        offset: "−04:00",
        link: ""
    },
    {
        country: "CW",
        name: "America/Curacao",
        status: "Canonical",
        offset: "−04:00",
        link: ""
    },
    {
        country: "GL",
        name: "America/Danmarkshavn",
        status: "Canonical",
        offset: "+00:00",
        link: ""
    },
    {
        country: "CA",
        name: "America/Dawson",
        status: "Canonical",
        offset: "−07:00",
        link: ""
    },
    {
        country: "CA",
        name: "America/Dawson_Creek",
        status: "Canonical",
        offset: "−07:00",
        link: ""
    },
    {
        country: "US",
        name: "America/Denver",
        status: "Canonical",
        offset: "−07:00",
        link: ""
    },
    {
        country: "US",
        name: "America/Detroit",
        status: "Canonical",
        offset: "−05:00",
        link: ""
    },
    {
        country: "DM",
        name: "America/Dominica",
        status: "Alias",
        offset: "−04:00",
        link: "America/Port_of_Spain"
    },
    {
        country: "CA",
        name: "America/Edmonton",
        status: "Canonical",
        offset: "−07:00",
        link: ""
    },
    {
        country: "BR",
        name: "America/Eirunepe",
        status: "Canonical",
        offset: "−05:00",
        link: ""
    },
    {
        country: "SV",
        name: "America/El_Salvador",
        status: "Canonical",
        offset: "−06:00",
        link: ""
    },
    {
        country: "MX",
        name: "America/Ensenada",
        status: "Deprecated",
        offset: "−08:00",
        link: "America/Tijuana"
    },
    {
        country: "CA",
        name: "America/Fort_Nelson",
        status: "Canonical",
        offset: "−07:00",
        link: ""
    },
    {
        country: "US",
        name: "America/Fort_Wayne",
        status: "Deprecated",
        offset: "−05:00",
        link: "America/Indiana/Indianapolis"
    },
    {
        country: "BR",
        name: "America/Fortaleza",
        status: "Canonical",
        offset: "−03:00",
        link: ""
    },
    {
        country: "CA",
        name: "America/Glace_Bay",
        status: "Canonical",
        offset: "−04:00",
        link: ""
    },
    {
        country: "GL",
        name: "America/Godthab",
        status: "Deprecated",
        offset: "−03:00",
        link: "America/Nuuk"
    },
    {
        country: "CA",
        name: "America/Goose_Bay",
        status: "Canonical",
        offset: "−04:00",
        link: ""
    },
    {
        country: "TC",
        name: "America/Grand_Turk",
        status: "Canonical",
        offset: "−05:00",
        link: ""
    },
    {
        country: "GD",
        name: "America/Grenada",
        status: "Alias",
        offset: "−04:00",
        link: "America/Port_of_Spain"
    },
    {
        country: "GP",
        name: "America/Guadeloupe",
        status: "Alias",
        offset: "−04:00",
        link: "America/Port_of_Spain"
    },
    {
        country: "GT",
        name: "America/Guatemala",
        status: "Canonical",
        offset: "−06:00",
        link: ""
    },
    {
        country: "EC",
        name: "America/Guayaquil",
        status: "Canonical",
        offset: "−05:00",
        link: ""
    },
    {
        country: "GY",
        name: "America/Guyana",
        status: "Canonical",
        offset: "−04:00",
        link: ""
    },
    {
        country: "CA",
        name: "America/Halifax",
        status: "Canonical",
        offset: "−04:00",
        link: ""
    },
    {
        country: "CU",
        name: "America/Havana",
        status: "Canonical",
        offset: "−05:00",
        link: ""
    },
    {
        country: "MX",
        name: "America/Hermosillo",
        status: "Canonical",
        offset: "−07:00",
        link: ""
    },
    {
        country: "US",
        name: "America/Indiana/Indianapolis",
        status: "Canonical",
        offset: "−05:00",
        link: ""
    },
    {
        country: "US",
        name: "America/Indiana/Knox",
        status: "Canonical",
        offset: "−06:00",
        link: ""
    },
    {
        country: "US",
        name: "America/Indiana/Marengo",
        status: "Canonical",
        offset: "−05:00",
        link: ""
    },
    {
        country: "US",
        name: "America/Indiana/Petersburg",
        status: "Canonical",
        offset: "−05:00",
        link: ""
    },
    {
        country: "US",
        name: "America/Indiana/Tell_City",
        status: "Canonical",
        offset: "−06:00",
        link: ""
    },
    {
        country: "US",
        name: "America/Indiana/Vevay",
        status: "Canonical",
        offset: "−05:00",
        link: ""
    },
    {
        country: "US",
        name: "America/Indiana/Vincennes",
        status: "Canonical",
        offset: "−05:00",
        link: ""
    },
    {
        country: "US",
        name: "America/Indiana/Winamac",
        status: "Canonical",
        offset: "−05:00",
        link: ""
    },
    {
        country: "US",
        name: "America/Indianapolis",
        status: "Deprecated",
        offset: "−05:00",
        link: "America/Indiana/Indianapolis"
    },
    {
        country: "CA",
        name: "America/Inuvik",
        status: "Canonical",
        offset: "−07:00",
        link: ""
    },
    {
        country: "CA",
        name: "America/Iqaluit",
        status: "Canonical",
        offset: "−05:00",
        link: ""
    },
    {
        country: "JM",
        name: "America/Jamaica",
        status: "Canonical",
        offset: "−05:00",
        link: ""
    },
    {
        country: "AR",
        name: "America/Jujuy",
        status: "Deprecated",
        offset: "−03:00",
        link: "America/Argentina/Jujuy"
    },
    {
        country: "US",
        name: "America/Juneau",
        status: "Canonical",
        offset: "−09:00",
        link: ""
    },
    {
        country: "US",
        name: "America/Kentucky/Louisville",
        status: "Canonical",
        offset: "−05:00",
        link: ""
    },
    {
        country: "US",
        name: "America/Kentucky/Monticello",
        status: "Canonical",
        offset: "−05:00",
        link: ""
    },
    {
        country: "US",
        name: "America/Knox_IN",
        status: "Deprecated",
        offset: "−06:00",
        link: "America/Indiana/Knox"
    },
    {
        country: "BQ",
        name: "America/Kralendijk",
        status: "Alias",
        offset: "−04:00",
        link: "America/Curacao"
    },
    {
        country: "BO",
        name: "America/La_Paz",
        status: "Canonical",
        offset: "−04:00",
        link: ""
    },
    {
        country: "PE",
        name: "America/Lima",
        status: "Canonical",
        offset: "−05:00",
        link: ""
    },
    {
        country: "US",
        name: "America/Los_Angeles",
        status: "Canonical",
        offset: "−08:00",
        link: ""
    },
    {
        country: "US",
        name: "America/Louisville",
        status: "Deprecated",
        offset: "−05:00",
        link: "America/Kentucky/Louisville"
    },
    {
        country: "SX",
        name: "America/Lower_Princes",
        status: "Alias",
        offset: "−04:00",
        link: "America/Curacao"
    },
    {
        country: "BR",
        name: "America/Maceio",
        status: "Canonical",
        offset: "−03:00",
        link: ""
    },
    {
        country: "NI",
        name: "America/Managua",
        status: "Canonical",
        offset: "−06:00",
        link: ""
    },
    {
        country: "BR",
        name: "America/Manaus",
        status: "Canonical",
        offset: "−04:00",
        link: ""
    },
    {
        country: "MF",
        name: "America/Marigot",
        status: "Alias",
        offset: "−04:00",
        link: "America/Port_of_Spain"
    },
    {
        country: "MQ",
        name: "America/Martinique",
        status: "Canonical",
        offset: "−04:00",
        link: ""
    },
    {
        country: "MX",
        name: "America/Matamoros",
        status: "Canonical",
        offset: "−06:00",
        link: ""
    },
    {
        country: "MX",
        name: "America/Mazatlan",
        status: "Canonical",
        offset: "−07:00",
        link: ""
    },
    {
        country: "AR",
        name: "America/Mendoza",
        status: "Deprecated",
        offset: "−03:00",
        link: "America/Argentina/Mendoza"
    },
    {
        country: "US",
        name: "America/Menominee",
        status: "Canonical",
        offset: "−06:00",
        link: ""
    },
    {
        country: "MX",
        name: "America/Merida",
        status: "Canonical",
        offset: "−06:00",
        link: ""
    },
    {
        country: "US",
        name: "America/Metlakatla",
        status: "Canonical",
        offset: "−09:00",
        link: ""
    },
    {
        country: "MX",
        name: "America/Mexico_City",
        status: "Canonical",
        offset: "−06:00",
        link: ""
    },
    {
        country: "PM",
        name: "America/Miquelon",
        status: "Canonical",
        offset: "−03:00",
        link: ""
    },
    {
        country: "CA",
        name: "America/Moncton",
        status: "Canonical",
        offset: "−04:00",
        link: ""
    },
    {
        country: "MX",
        name: "America/Monterrey",
        status: "Canonical",
        offset: "−06:00",
        link: ""
    },
    {
        country: "UY",
        name: "America/Montevideo",
        status: "Canonical",
        offset: "−03:00",
        link: ""
    },
    {
        country: "CA",
        name: "America/Montreal",
        status: "Deprecated",
        offset: "−05:00",
        link: "America/Toronto"
    },
    {
        country: "MS",
        name: "America/Montserrat",
        status: "Alias",
        offset: "−04:00",
        link: "America/Port_of_Spain"
    },
    {
        country: "BS",
        name: "America/Nassau",
        status: "Canonical",
        offset: "−05:00",
        link: ""
    },
    {
        country: "US",
        name: "America/New_York",
        status: "Canonical",
        offset: "−05:00",
        link: ""
    },
    {
        country: "CA",
        name: "America/Nipigon",
        status: "Canonical",
        offset: "−05:00",
        link: ""
    },
    {
        country: "US",
        name: "America/Nome",
        status: "Canonical",
        offset: "−09:00",
        link: ""
    },
    {
        country: "BR",
        name: "America/Noronha",
        status: "Canonical",
        offset: "−02:00",
        link: ""
    },
    {
        country: "US",
        name: "America/North_Dakota/Beulah",
        status: "Canonical",
        offset: "−06:00",
        link: ""
    },
    {
        country: "US",
        name: "America/North_Dakota/Center",
        status: "Canonical",
        offset: "−06:00",
        link: ""
    },
    {
        country: "US",
        name: "America/North_Dakota/New_Salem",
        status: "Canonical",
        offset: "−06:00",
        link: ""
    },
    {
        country: "GL",
        name: "America/Nuuk",
        status: "Canonical",
        offset: "−03:00",
        link: ""
    },
    {
        country: "MX",
        name: "America/Ojinaga",
        status: "Canonical",
        offset: "−07:00",
        link: ""
    },
    {
        country: "PA",
        name: "America/Panama",
        status: "Canonical",
        offset: "−05:00",
        link: ""
    },
    {
        country: "CA",
        name: "America/Pangnirtung",
        status: "Canonical",
        offset: "−05:00",
        link: ""
    },
    {
        country: "SR",
        name: "America/Paramaribo",
        status: "Canonical",
        offset: "−03:00",
        link: ""
    },
    {
        country: "US",
        name: "America/Phoenix",
        status: "Canonical",
        offset: "−07:00",
        link: ""
    },
    {
        country: "HT",
        name: "America/Port-au-Prince",
        status: "Canonical",
        offset: "−05:00",
        link: ""
    },
    {
        country: "TT",
        name: "America/Port_of_Spain",
        status: "Canonical",
        offset: "−04:00",
        link: ""
    },
    {
        country: "BR",
        name: "America/Porto_Acre",
        status: "Deprecated",
        offset: "−05:00",
        link: "America/Rio_Branco"
    },
    {
        country: "BR",
        name: "America/Porto_Velho",
        status: "Canonical",
        offset: "−04:00",
        link: ""
    },
    {
        country: "PR",
        name: "America/Puerto_Rico",
        status: "Canonical",
        offset: "−04:00",
        link: ""
    },
    {
        country: "CL",
        name: "America/Punta_Arenas",
        status: "Canonical",
        offset: "−03:00",
        link: "Magallanes Region"
    },
    {
        country: "CA",
        name: "America/Rainy_River",
        status: "Canonical",
        offset: "−06:00",
        link: ""
    },
    {
        country: "CA",
        name: "America/Rankin_Inlet",
        status: "Canonical",
        offset: "−06:00",
        link: ""
    },
    {
        country: "BR",
        name: "America/Recife",
        status: "Canonical",
        offset: "−03:00",
        link: ""
    },
    {
        country: "CA",
        name: "America/Regina",
        status: "Canonical",
        offset: "−06:00",
        link: ""
    },
    {
        country: "CA",
        name: "America/Resolute",
        status: "Canonical",
        offset: "−06:00",
        link: ""
    },
    {
        country: "BR",
        name: "America/Rio_Branco",
        status: "Canonical",
        offset: "−05:00",
        link: ""
    },
    {
        country: "AR",
        name: "America/Rosario",
        status: "Deprecated",
        offset: "−03:00",
        link: "America/Argentina/Cordoba"
    },
    {
        country: "MX",
        name: "America/Santa_Isabel",
        status: "Deprecated",
        offset: "−08:00",
        link: "America/Tijuana"
    },
    {
        country: "BR",
        name: "America/Santarem",
        status: "Canonical",
        offset: "−03:00",
        link: ""
    },
    {
        country: "CL",
        name: "America/Santiago",
        status: "Canonical",
        offset: "−04:00",
        link: ""
    },
    {
        country: "DO",
        name: "America/Santo_Domingo",
        status: "Canonical",
        offset: "−04:00",
        link: ""
    },
    {
        country: "BR",
        name: "America/Sao_Paulo",
        status: "Canonical",
        offset: "−03:00",
        link: ""
    },
    {
        country: "GL",
        name: "America/Scoresbysund",
        status: "Canonical",
        offset: "−01:00",
        link: ""
    },
    {
        country: "US",
        name: "America/Shiprock",
        status: "Deprecated",
        offset: "−07:00",
        link: "America/Denver"
    },
    {
        country: "US",
        name: "America/Sitka",
        status: "Canonical",
        offset: "−09:00",
        link: ""
    },
    {
        country: "BL",
        name: "America/St_Barthelemy",
        status: "Alias",
        offset: "−04:00",
        link: "America/Port_of_Spain"
    },
    {
        country: "CA",
        name: "America/St_Johns",
        status: "Canonical",
        offset: "−03:30",
        link: ""
    },
    {
        country: "KN",
        name: "America/St_Kitts",
        status: "Alias",
        offset: "−04:00",
        link: "America/Port_of_Spain"
    },
    {
        country: "LC",
        name: "America/St_Lucia",
        status: "Alias",
        offset: "−04:00",
        link: "America/Port_of_Spain"
    },
    {
        country: "VI",
        name: "America/St_Thomas",
        status: "Alias",
        offset: "−04:00",
        link: "America/Port_of_Spain"
    },
    {
        country: "VC",
        name: "America/St_Vincent",
        status: "Alias",
        offset: "−04:00",
        link: "America/Port_of_Spain"
    },
    {
        country: "CA",
        name: "America/Swift_Current",
        status: "Canonical",
        offset: "−06:00",
        link: ""
    },
    {
        country: "HN",
        name: "America/Tegucigalpa",
        status: "Canonical",
        offset: "−06:00",
        link: ""
    },
    {
        country: "GL",
        name: "America/Thule",
        status: "Canonical",
        offset: "−04:00",
        link: ""
    },
    {
        country: "CA",
        name: "America/Thunder_Bay",
        status: "Canonical",
        offset: "−05:00",
        link: ""
    },
    {
        country: "MX",
        name: "America/Tijuana",
        status: "Canonical",
        offset: "−08:00",
        link: ""
    },
    {
        country: "CA",
        name: "America/Toronto",
        status: "Canonical",
        offset: "−05:00",
        link: ""
    },
    {
        country: "VG",
        name: "America/Tortola",
        status: "Alias",
        offset: "−04:00",
        link: "America/Port_of_Spain"
    },
    {
        country: "CA",
        name: "America/Vancouver",
        status: "Canonical",
        offset: "−08:00",
        link: ""
    },
    {
        country: "VI",
        name: "America/Virgin",
        status: "Deprecated",
        offset: "−04:00",
        link: "America/Port_of_Spain"
    },
    {
        country: "CA",
        name: "America/Whitehorse",
        status: "Canonical",
        offset: "−07:00",
        link: ""
    },
    {
        country: "CA",
        name: "America/Winnipeg",
        status: "Canonical",
        offset: "−06:00",
        link: ""
    },
    {
        country: "US",
        name: "America/Yakutat",
        status: "Canonical",
        offset: "−09:00",
        link: ""
    },
    {
        country: "CA",
        name: "America/Yellowknife",
        status: "Canonical",
        offset: "−07:00",
        link: ""
    },
    {
        country: "AQ",
        name: "Antarctica/Casey",
        status: "Canonical",
        offset: "+11:00",
        link: ""
    },
    {
        country: "AQ",
        name: "Antarctica/Davis",
        status: "Canonical",
        offset: "+07:00",
        link: ""
    },
    {
        country: "AQ",
        name: "Antarctica/DumontDUrville",
        status: "Canonical",
        offset: "+10:00",
        link: ""
    },
    {
        country: "AU",
        name: "Antarctica/Macquarie",
        status: "Canonical",
        offset: "+10:00",
        link: ""
    },
    {
        country: "AQ",
        name: "Antarctica/Mawson",
        status: "Canonical",
        offset: "+05:00",
        link: ""
    },
    {
        country: "AQ",
        name: "Antarctica/McMurdo",
        status: "Alias",
        offset: "+12:00",
        link: "Pacific/Auckland"
    },
    {
        country: "AQ",
        name: "Antarctica/Palmer",
        status: "Canonical",
        offset: "−03:00",
        link: "Chilean Antarctica Region"
    },
    {
        country: "AQ",
        name: "Antarctica/Rothera",
        status: "Canonical",
        offset: "−03:00",
        link: ""
    },
    {
        country: "AQ",
        name: "Antarctica/South_Pole",
        status: "Deprecated",
        offset: "+12:00",
        link: "Pacific/Auckland"
    },
    {
        country: "AQ",
        name: "Antarctica/Syowa",
        status: "Canonical",
        offset: "+03:00",
        link: ""
    },
    {
        country: "AQ",
        name: "Antarctica/Troll",
        status: "Canonical",
        offset: "+00:00",
        link: "+01:00"
    },
    {
        country: "AQ",
        name: "Antarctica/Vostok",
        status: "Canonical",
        offset: "+06:00",
        link: ""
    },
    {
        country: "SJ",
        name: "Arctic/Longyearbyen",
        status: "Alias",
        offset: "+01:00",
        link: "Europe/Oslo"
    },
    {
        country: "YE",
        name: "Asia/Aden",
        status: "Alias",
        offset: "+03:00",
        link: "Asia/Riyadh"
    },
    {
        country: "KZ",
        name: "Asia/Almaty",
        status: "Canonical",
        offset: "+06:00",
        link: ""
    },
    {
        country: "JO",
        name: "Asia/Amman",
        status: "Canonical",
        offset: "+02:00",
        link: ""
    },
    {
        country: "RU",
        name: "Asia/Anadyr",
        status: "Canonical",
        offset: "+12:00",
        link: ""
    },
    {
        country: "KZ",
        name: "Asia/Aqtau",
        status: "Canonical",
        offset: "+05:00",
        link: ""
    },
    {
        country: "KZ",
        name: "Asia/Aqtobe",
        status: "Canonical",
        offset: "+05:00",
        link: ""
    },
    {
        country: "TM",
        name: "Asia/Ashgabat",
        status: "Canonical",
        offset: "+05:00",
        link: ""
    },
    {
        country: "TM",
        name: "Asia/Ashkhabad",
        status: "Deprecated",
        offset: "+05:00",
        link: "Asia/Ashgabat"
    },
    {
        country: "KZ",
        name: "Asia/Atyrau",
        status: "Canonical",
        offset: "+05:00",
        link: ""
    },
    {
        country: "IQ",
        name: "Asia/Baghdad",
        status: "Canonical",
        offset: "+03:00",
        link: ""
    },
    {
        country: "BH",
        name: "Asia/Bahrain",
        status: "Alias",
        offset: "+03:00",
        link: "Asia/Qatar"
    },
    {
        country: "AZ",
        name: "Asia/Baku",
        status: "Canonical",
        offset: "+04:00",
        link: ""
    },
    {
        country: "TH",
        name: "Asia/Bangkok",
        status: "Canonical",
        offset: "+07:00",
        link: ""
    },
    {
        country: "RU",
        name: "Asia/Barnaul",
        status: "Canonical",
        offset: "+07:00",
        link: ""
    },
    {
        country: "LB",
        name: "Asia/Beirut",
        status: "Canonical",
        offset: "+02:00",
        link: ""
    },
    {
        country: "KG",
        name: "Asia/Bishkek",
        status: "Canonical",
        offset: "+06:00",
        link: ""
    },
    {
        country: "BN",
        name: "Asia/Brunei",
        status: "Canonical",
        offset: "+08:00",
        link: ""
    },
    {
        country: "IN",
        name: "Asia/Calcutta",
        status: "Deprecated",
        offset: "+05:30",
        link: "Asia/Kolkata"
    },
    {
        country: "RU",
        name: "Asia/Chita",
        status: "Canonical",
        offset: "+09:00",
        link: ""
    },
    {
        country: "MN",
        name: "Asia/Choibalsan",
        status: "Canonical",
        offset: "+08:00",
        link: ""
    },
    {
        country: "CN",
        name: "Asia/Chongqing",
        status: "Deprecated",
        offset: "+08:00",
        link: "Asia/Shanghai"
    },
    {
        country: "CN",
        name: "Asia/Chungking",
        status: "Deprecated",
        offset: "+08:00",
        link: "Asia/Shanghai"
    },
    {
        country: "LK",
        name: "Asia/Colombo",
        status: "Canonical",
        offset: "+05:30",
        link: ""
    },
    {
        country: "BD",
        name: "Asia/Dacca",
        status: "Deprecated",
        offset: "+06:00",
        link: "Asia/Dhaka"
    },
    {
        country: "SY",
        name: "Asia/Damascus",
        status: "Canonical",
        offset: "+02:00",
        link: ""
    },
    {
        country: "BD",
        name: "Asia/Dhaka",
        status: "Canonical",
        offset: "+06:00",
        link: ""
    },
    {
        country: "TL",
        name: "Asia/Dili",
        status: "Canonical",
        offset: "+09:00",
        link: ""
    },
    {
        country: "AE",
        name: "Asia/Dubai",
        status: "Canonical",
        offset: "+04:00",
        link: ""
    },
    {
        country: "TJ",
        name: "Asia/Dushanbe",
        status: "Canonical",
        offset: "+05:00",
        link: ""
    },
    {
        country: "CY",
        name: "Asia/Famagusta",
        status: "Canonical",
        offset: "+02:00",
        link: ""
    },
    {
        country: "PS",
        name: "Asia/Gaza",
        status: "Canonical",
        offset: "+02:00",
        link: ""
    },
    {
        country: "CN",
        name: "Asia/Harbin",
        status: "Deprecated",
        offset: "+08:00",
        link: "Asia/Shanghai"
    },
    {
        country: "PS",
        name: "Asia/Hebron",
        status: "Canonical",
        offset: "+02:00",
        link: ""
    },
    {
        country: "VN",
        name: "Asia/Ho_Chi_Minh",
        status: "Canonical",
        offset: "+07:00",
        link: ""
    },
    {
        country: "HK",
        name: "Asia/Hong_Kong",
        status: "Canonical",
        offset: "+08:00",
        link: ""
    },
    {
        country: "MN",
        name: "Asia/Hovd",
        status: "Canonical",
        offset: "+07:00",
        link: ""
    },
    {
        country: "RU",
        name: "Asia/Irkutsk",
        status: "Canonical",
        offset: "+08:00",
        link: ""
    },
    {
        country: "TR",
        name: "Asia/Istanbul",
        status: "Alias",
        offset: "+03:00",
        link: "Europe/Istanbul"
    },
    {
        country: "ID",
        name: "Asia/Jakarta",
        status: "Canonical",
        offset: "+07:00",
        link: ""
    },
    {
        country: "ID",
        name: "Asia/Jayapura",
        status: "Canonical",
        offset: "+09:00",
        link: ""
    },
    {
        country: "IL",
        name: "Asia/Jerusalem",
        status: "Canonical",
        offset: "+02:00",
        link: ""
    },
    {
        country: "AF",
        name: "Asia/Kabul",
        status: "Canonical",
        offset: "+04:30",
        link: ""
    },
    {
        country: "RU",
        name: "Asia/Kamchatka",
        status: "Canonical",
        offset: "+12:00",
        link: ""
    },
    {
        country: "PK",
        name: "Asia/Karachi",
        status: "Canonical",
        offset: "+05:00",
        link: ""
    },
    {
        country: "CN",
        name: "Asia/Kashgar",
        status: "Deprecated",
        offset: "+06:00",
        link: "Asia/Urumqi"
    },
    {
        country: "NP",
        name: "Asia/Kathmandu",
        status: "Canonical",
        offset: "+05:45",
        link: ""
    },
    {
        country: "NP",
        name: "Asia/Katmandu",
        status: "Deprecated",
        offset: "+05:45",
        link: "Asia/Kathmandu"
    },
    {
        country: "RU",
        name: "Asia/Khandyga",
        status: "Canonical",
        offset: "+09:00",
        link: ""
    },
    {
        country: "IN",
        name: "Asia/Kolkata",
        status: "Canonical",
        offset: "+05:30",
        link: "Time in India"
    },
    {
        country: "RU",
        name: "Asia/Krasnoyarsk",
        status: "Canonical",
        offset: "+07:00",
        link: ""
    },
    {
        country: "MY",
        name: "Asia/Kuala_Lumpur",
        status: "Canonical",
        offset: "+08:00",
        link: ""
    },
    {
        country: "MY",
        name: "Asia/Kuching",
        status: "Canonical",
        offset: "+08:00",
        link: ""
    },
    {
        country: "KW",
        name: "Asia/Kuwait",
        status: "Alias",
        offset: "+03:00",
        link: "Asia/Riyadh"
    },
    {
        country: "MO",
        name: "Asia/Macao",
        status: "Deprecated",
        offset: "+08:00",
        link: "Asia/Macau"
    },
    {
        country: "MO",
        name: "Asia/Macau",
        status: "Canonical",
        offset: "+08:00",
        link: ""
    },
    {
        country: "RU",
        name: "Asia/Magadan",
        status: "Canonical",
        offset: "+11:00",
        link: ""
    },
    {
        country: "ID",
        name: "Asia/Makassar",
        status: "Canonical",
        offset: "+08:00",
        link: ""
    },
    {
        country: "PH",
        name: "Asia/Manila",
        status: "Canonical",
        offset: "+08:00",
        link: ""
    },
    {
        country: "OM",
        name: "Asia/Muscat",
        status: "Alias",
        offset: "+04:00",
        link: "Asia/Dubai"
    },
    {
        country: "CY",
        name: "Asia/Nicosia",
        status: "Canonical",
        offset: "+02:00",
        link: ""
    },
    {
        country: "RU",
        name: "Asia/Novokuznetsk",
        status: "Canonical",
        offset: "+07:00",
        link: ""
    },
    {
        country: "RU",
        name: "Asia/Novosibirsk",
        status: "Canonical",
        offset: "+07:00",
        link: ""
    },
    {
        country: "RU",
        name: "Asia/Omsk",
        status: "Canonical",
        offset: "+06:00",
        link: ""
    },
    {
        country: "KZ",
        name: "Asia/Oral",
        status: "Canonical",
        offset: "+05:00",
        link: ""
    },
    {
        country: "KH",
        name: "Asia/Phnom_Penh",
        status: "Alias",
        offset: "+07:00",
        link: "Asia/Bangkok"
    },
    {
        country: "ID",
        name: "Asia/Pontianak",
        status: "Canonical",
        offset: "+07:00",
        link: ""
    },
    {
        country: "KP",
        name: "Asia/Pyongyang",
        status: "Canonical",
        offset: "+09:00",
        link: ""
    },
    {
        country: "QA",
        name: "Asia/Qatar",
        status: "Canonical",
        offset: "+03:00",
        link: ""
    },
    {
        country: "KZ",
        name: "Asia/Qostanay",
        status: "Canonical",
        offset: "+06:00",
        link: ""
    },
    {
        country: "KZ",
        name: "Asia/Qyzylorda",
        status: "Canonical",
        offset: "+05:00",
        link: ""
    },
    {
        country: "MM",
        name: "Asia/Rangoon",
        status: "Deprecated",
        offset: "+06:30",
        link: "Asia/Yangon"
    },
    {
        country: "SA",
        name: "Asia/Riyadh",
        status: "Canonical",
        offset: "+03:00",
        link: ""
    },
    {
        country: "VN",
        name: "Asia/Saigon",
        status: "Deprecated",
        offset: "+07:00",
        link: "Asia/Ho_Chi_Minh"
    },
    {
        country: "RU",
        name: "Asia/Sakhalin",
        status: "Canonical",
        offset: "+11:00",
        link: ""
    },
    {
        country: "UZ",
        name: "Asia/Samarkand",
        status: "Canonical",
        offset: "+05:00",
        link: ""
    },
    {
        country: "KR",
        name: "Asia/Seoul",
        status: "Canonical",
        offset: "+09:00",
        link: ""
    },
    {
        country: "CN",
        name: "Asia/Shanghai",
        status: "Canonical",
        offset: "+08:00",
        link: ""
    },
    {
        country: "SG",
        name: "Asia/Singapore",
        status: "Canonical",
        offset: "+08:00",
        link: ""
    },
    {
        country: "RU",
        name: "Asia/Srednekolymsk",
        status: "Canonical",
        offset: "+11:00",
        link: ""
    },
    {
        country: "TW",
        name: "Asia/Taipei",
        status: "Canonical",
        offset: "+08:00",
        link: ""
    },
    {
        country: "UZ",
        name: "Asia/Tashkent",
        status: "Canonical",
        offset: "+05:00",
        link: ""
    },
    {
        country: "GE",
        name: "Asia/Tbilisi",
        status: "Canonical",
        offset: "+04:00",
        link: ""
    },
    {
        country: "IR",
        name: "Asia/Tehran",
        status: "Canonical",
        offset: "+03:30",
        link: ""
    },
    {
        country: "IL",
        name: "Asia/Tel_Aviv",
        status: "Deprecated",
        offset: "+02:00",
        link: "Asia/Jerusalem"
    },
    {
        country: "BT",
        name: "Asia/Thimbu",
        status: "Deprecated",
        offset: "+06:00",
        link: "Asia/Thimphu"
    },
    {
        country: "BT",
        name: "Asia/Thimphu",
        status: "Canonical",
        offset: "+06:00",
        link: ""
    },
    {
        country: "JP",
        name: "Asia/Tokyo",
        status: "Canonical",
        offset: "+09:00",
        link: ""
    },
    {
        country: "RU",
        name: "Asia/Tomsk",
        status: "Canonical",
        offset: "+07:00",
        link: ""
    },
    {
        country: "ID",
        name: "Asia/Ujung_Pandang",
        status: "Deprecated",
        offset: "+08:00",
        link: "Asia/Makassar"
    },
    {
        country: "MN",
        name: "Asia/Ulaanbaatar",
        status: "Canonical",
        offset: "+08:00",
        link: ""
    },
    {
        country: "MN",
        name: "Asia/Ulan_Bator",
        status: "Deprecated",
        offset: "+08:00",
        link: "Asia/Ulaanbaatar"
    },
    {
        country: "CN",
        name: "Asia/Urumqi",
        status: "Canonical",
        offset: "+06:00",
        link: "Asia/Urumqi"
    },
    {
        country: "RU",
        name: "Asia/Ust-Nera",
        status: "Canonical",
        offset: "+10:00",
        link: ""
    },
    {
        country: "LA",
        name: "Asia/Vientiane",
        status: "Alias",
        offset: "+07:00",
        link: "Asia/Bangkok"
    },
    {
        country: "RU",
        name: "Asia/Vladivostok",
        status: "Canonical",
        offset: "+10:00",
        link: ""
    },
    {
        country: "RU",
        name: "Asia/Yakutsk",
        status: "Canonical",
        offset: "+09:00",
        link: ""
    },
    {
        country: "MM",
        name: "Asia/Yangon",
        status: "Canonical",
        offset: "+06:30",
        link: ""
    },
    {
        country: "RU",
        name: "Asia/Yekaterinburg",
        status: "Canonical",
        offset: "+05:00",
        link: ""
    },
    {
        country: "AM",
        name: "Asia/Yerevan",
        status: "Canonical",
        offset: "+04:00",
        link: ""
    },
    {
        country: "PT",
        name: "Atlantic/Azores",
        status: "Canonical",
        offset: "−01:00",
        link: ""
    },
    {
        country: "BM",
        name: "Atlantic/Bermuda",
        status: "Canonical",
        offset: "−04:00",
        link: ""
    },
    {
        country: "ES",
        name: "Atlantic/Canary",
        status: "Canonical",
        offset: "+00:00",
        link: ""
    },
    {
        country: "CV",
        name: "Atlantic/Cape_Verde",
        status: "Canonical",
        offset: "−01:00",
        link: ""
    },
    {
        country: "FO",
        name: "Atlantic/Faeroe",
        status: "Deprecated",
        offset: "+00:00",
        link: "Atlantic/Faroe"
    },
    {
        country: "FO",
        name: "Atlantic/Faroe",
        status: "Canonical",
        offset: "+00:00",
        link: ""
    },
    {
        country: "SJ",
        name: "Atlantic/Jan_Mayen",
        status: "Deprecated",
        offset: "+01:00",
        link: "Europe/Oslo"
    },
    {
        country: "PT",
        name: "Atlantic/Madeira",
        status: "Canonical",
        offset: "+00:00",
        link: ""
    },
    {
        country: "IS",
        name: "Atlantic/Reykjavik",
        status: "Canonical",
        offset: "+00:00",
        link: ""
    },
    {
        country: "GS",
        name: "Atlantic/South_Georgia",
        status: "Canonical",
        offset: "−02:00",
        link: ""
    },
    {
        country: "SH",
        name: "Atlantic/St_Helena",
        status: "Alias",
        offset: "+00:00",
        link: "Africa/Abidjan"
    },
    {
        country: "FK",
        name: "Atlantic/Stanley",
        status: "Canonical",
        offset: "−03:00",
        link: ""
    },
    {
        country: "AU",
        name: "Australia/ACT",
        status: "Deprecated",
        offset: "+10:00",
        link: "Australia/Sydney"
    },
    {
        country: "AU",
        name: "Australia/Adelaide",
        status: "Canonical",
        offset: "+09:30",
        link: ""
    },
    {
        country: "AU",
        name: "Australia/Brisbane",
        status: "Canonical",
        offset: "+10:00",
        link: ""
    },
    {
        country: "AU",
        name: "Australia/Broken_Hill",
        status: "Canonical",
        offset: "+09:30",
        link: ""
    },
    {
        country: "AU",
        name: "Australia/Canberra",
        status: "Deprecated",
        offset: "+10:00",
        link: "Australia/Sydney"
    },
    {
        country: "AU",
        name: "Australia/Currie",
        status: "Deprecated",
        offset: "+10:00",
        link: "Australia/Hobart"
    },
    {
        country: "AU",
        name: "Australia/Darwin",
        status: "Canonical",
        offset: "+09:30",
        link: ""
    },
    {
        country: "AU",
        name: "Australia/Eucla",
        status: "Canonical",
        offset: "+08:45",
        link: ""
    },
    {
        country: "AU",
        name: "Australia/Hobart",
        status: "Canonical",
        offset: "+10:00",
        link: ""
    },
    {
        country: "AU",
        name: "Australia/LHI",
        status: "Deprecated",
        offset: "+10:30",
        link: "Australia/Lord_Howe"
    },
    {
        country: "AU",
        name: "Australia/Lindeman",
        status: "Canonical",
        offset: "+10:00",
        link: ""
    },
    {
        country: "AU",
        name: "Australia/Lord_Howe",
        status: "Canonical",
        offset: "+10:30",
        link: "This is the only time zone in the world that uses 30-minute DST transitions."
    },
    {
        country: "AU",
        name: "Australia/Melbourne",
        status: "Canonical",
        offset: "+10:00",
        link: ""
    },
    {
        country: "AU",
        name: "Australia/North",
        status: "Deprecated",
        offset: "+09:30",
        link: "Australia/Darwin"
    },
    {
        country: "AU",
        name: "Australia/NSW",
        status: "Deprecated",
        offset: "+10:00",
        link: "Australia/Sydney"
    },
    {
        country: "AU",
        name: "Australia/Perth",
        status: "Canonical",
        offset: "+08:00",
        link: ""
    },
    {
        country: "AU",
        name: "Australia/Queensland",
        status: "Deprecated",
        offset: "+10:00",
        link: "Australia/Brisbane"
    },
    {
        country: "AU",
        name: "Australia/South",
        status: "Deprecated",
        offset: "+09:30",
        link: "Australia/Adelaide"
    },
    {
        country: "AU",
        name: "Australia/Sydney",
        status: "Canonical",
        offset: "+10:00",
        link: ""
    },
    {
        country: "AU",
        name: "Australia/Tasmania",
        status: "Deprecated",
        offset: "+10:00",
        link: "Australia/Hobart"
    },
    {
        country: "AU",
        name: "Australia/Victoria",
        status: "Deprecated",
        offset: "+10:00",
        link: "Australia/Melbourne"
    },
    {
        country: "AU",
        name: "Australia/West",
        status: "Deprecated",
        offset: "+08:00",
        link: "Australia/Perth"
    },
    {
        country: "AU",
        name: "Australia/Yancowinna",
        status: "Deprecated",
        offset: "+09:30",
        link: "Australia/Broken_Hill"
    },
    {
        country: "BR",
        name: "Brazil/Acre",
        status: "Deprecated",
        offset: "−05:00",
        link: "America/Rio_Branco"
    },
    {
        country: "BR",
        name: "Brazil/DeNoronha",
        status: "Deprecated",
        offset: "−02:00",
        link: "America/Noronha"
    },
    {
        country: "BR",
        name: "Brazil/East",
        status: "Deprecated",
        offset: "−03:00",
        link: "America/Sao_Paulo"
    },
    {
        country: "BR",
        name: "Brazil/West",
        status: "Deprecated",
        offset: "−04:00",
        link: "America/Manaus"
    },
    {
        country: "CA",
        name: "Canada/Atlantic",
        status: "Deprecated",
        offset: "−04:00",
        link: "America/Halifax"
    },
    {
        country: "CA",
        name: "Canada/Central",
        status: "Deprecated",
        offset: "−06:00",
        link: "America/Winnipeg"
    },
    {
        country: "CA",
        name: "Canada/Eastern",
        status: "Deprecated",
        offset: "−05:00",
        link: "America/Toronto"
    },
    {
        country: "CA",
        name: "Canada/Mountain",
        status: "Deprecated",
        offset: "−07:00",
        link: "America/Edmonton"
    },
    {
        country: "CA",
        name: "Canada/Newfoundland",
        status: "Deprecated",
        offset: "−03:30",
        link: "America/St_Johns"
    },
    {
        country: "CA",
        name: "Canada/Pacific",
        status: "Deprecated",
        offset: "−08:00",
        link: "America/Vancouver"
    },
    {
        country: "CA",
        name: "Canada/Saskatchewan",
        status: "Deprecated",
        offset: "−06:00",
        link: "America/Regina"
    },
    {
        country: "CA",
        name: "Canada/Yukon",
        status: "Deprecated",
        offset: "−07:00",
        link: "America/Whitehorse"
    },
    {
        country: "",
        name: "CET",
        status: "Deprecated",
        offset: "+01:00",
        link: "Europe/Paris"
    },
    {
        country: "CL",
        name: "Chile/Continental",
        status: "Deprecated",
        offset: "−04:00",
        link: "America/Santiago"
    },
    {
        country: "CL",
        name: "Chile/EasterIsland",
        status: "Deprecated",
        offset: "−06:00",
        link: "Pacific/Easter"
    },
    {
        country: "",
        name: "CST6CDT",
        status: "Deprecated",
        offset: "−06:00",
        link: "America/Chicago"
    },
    {
        country: "CU",
        name: "Cuba",
        status: "Deprecated",
        offset: "−05:00",
        link: "America/Havana"
    },
    {
        country: "",
        name: "EET",
        status: "Deprecated",
        offset: "+02:00",
        link: "Europe/Sofia"
    },
    {
        country: "EG",
        name: "Egypt",
        status: "Deprecated",
        offset: "+02:00",
        link: "Africa/Cairo"
    },
    {
        country: "IE",
        name: "Eire",
        status: "Deprecated",
        offset: "+01:00",
        link: "Europe/Dublin"
    },
    {
        country: "",
        name: "EST",
        status: "Deprecated",
        offset: "−05:00",
        link: "America/Cancun"
    },
    {
        country: "",
        name: "EST5EDT",
        status: "Deprecated",
        offset: "−05:00",
        link: "America/New_York"
    },
    {
        country: "",
        name: "Etc/GMT",
        status: "Canonical",
        offset: "+00:00",
        link: ""
    },
    {
        country: "",
        name: "Etc/GMT+0",
        status: "Alias",
        offset: "+00:00",
        link: "Etc/GMT"
    },
    {
        country: "",
        name: "Etc/GMT+1",
        status: "Canonical",
        offset: "−01:00",
        link: "Etc area description"
    },
    {
        country: "",
        name: "Etc/GMT+10",
        status: "Canonical",
        offset: "−10:00",
        link: "Etc area description"
    },
    {
        country: "",
        name: "Etc/GMT+11",
        status: "Canonical",
        offset: "−11:00",
        link: "Etc area description"
    },
    {
        country: "",
        name: "Etc/GMT+12",
        status: "Canonical",
        offset: "−12:00",
        link: "Etc area description"
    },
    {
        country: "",
        name: "Etc/GMT+2",
        status: "Canonical",
        offset: "−02:00",
        link: "Etc area description"
    },
    {
        country: "",
        name: "Etc/GMT+3",
        status: "Canonical",
        offset: "−03:00",
        link: "Etc area description"
    },
    {
        country: "",
        name: "Etc/GMT+4",
        status: "Canonical",
        offset: "−04:00",
        link: "Etc area description"
    },
    {
        country: "",
        name: "Etc/GMT+5",
        status: "Canonical",
        offset: "−05:00",
        link: "Etc area description"
    },
    {
        country: "",
        name: "Etc/GMT+6",
        status: "Canonical",
        offset: "−06:00",
        link: "Etc area description"
    },
    {
        country: "",
        name: "Etc/GMT+7",
        status: "Canonical",
        offset: "−07:00",
        link: "Etc area description"
    },
    {
        country: "",
        name: "Etc/GMT+8",
        status: "Canonical",
        offset: "−08:00",
        link: "Etc area description"
    },
    {
        country: "",
        name: "Etc/GMT+9",
        status: "Canonical",
        offset: "−09:00",
        link: "Etc area description"
    },
    {
        country: "",
        name: "Etc/GMT-0",
        status: "Alias",
        offset: "+00:00",
        link: "Etc/GMT"
    },
    {
        country: "",
        name: "Etc/GMT-1",
        status: "Canonical",
        offset: "+01:00",
        link: "Etc area description"
    },
    {
        country: "",
        name: "Etc/GMT-10",
        status: "Canonical",
        offset: "+10:00",
        link: "Etc area description"
    },
    {
        country: "",
        name: "Etc/GMT-11",
        status: "Canonical",
        offset: "+11:00",
        link: "Etc area description"
    },
    {
        country: "",
        name: "Etc/GMT-12",
        status: "Canonical",
        offset: "+12:00",
        link: "Etc area description"
    },
    {
        country: "",
        name: "Etc/GMT-13",
        status: "Canonical",
        offset: "+13:00",
        link: "Etc area description"
    },
    {
        country: "",
        name: "Etc/GMT-14",
        status: "Canonical",
        offset: "+14:00",
        link: "Etc area description"
    },
    {
        country: "",
        name: "Etc/GMT-2",
        status: "Canonical",
        offset: "+02:00",
        link: "Etc area description"
    },
    {
        country: "",
        name: "Etc/GMT-3",
        status: "Canonical",
        offset: "+03:00",
        link: "Etc area description"
    },
    {
        country: "",
        name: "Etc/GMT-4",
        status: "Canonical",
        offset: "+04:00",
        link: "Etc area description"
    },
    {
        country: "",
        name: "Etc/GMT-5",
        status: "Canonical",
        offset: "+05:00",
        link: "Etc area description"
    },
    {
        country: "",
        name: "Etc/GMT-6",
        status: "Canonical",
        offset: "+06:00",
        link: "Etc area description"
    },
    {
        country: "",
        name: "Etc/GMT-7",
        status: "Canonical",
        offset: "+07:00",
        link: "Etc area description"
    },
    {
        country: "",
        name: "Etc/GMT-8",
        status: "Canonical",
        offset: "+08:00",
        link: "Etc area description"
    },
    {
        country: "",
        name: "Etc/GMT-9",
        status: "Canonical",
        offset: "+09:00",
        link: "Etc area description"
    },
    {
        country: "",
        name: "Etc/GMT0",
        status: "Alias",
        offset: "+00:00",
        link: "Etc/GMT"
    },
    {
        country: "",
        name: "Etc/Greenwich",
        status: "Deprecated",
        offset: "+00:00",
        link: "Etc/GMT"
    },
    {
        country: "",
        name: "Etc/UCT",
        status: "Deprecated",
        offset: "+00:00",
        link: "Etc/UTC"
    },
    {
        country: "",
        name: "Etc/Universal",
        status: "Deprecated",
        offset: "+00:00",
        link: "Etc/UTC"
    },
    {
        country: "",
        name: "Etc/UTC",
        status: "Canonical",
        offset: "+00:00",
        link: ""
    },
    {
        country: "",
        name: "Etc/Zulu",
        status: "Deprecated",
        offset: "+00:00",
        link: "Etc/UTC"
    },
    {
        country: "NL",
        name: "Europe/Amsterdam",
        status: "Canonical",
        offset: "+01:00",
        link: ""
    },
    {
        country: "AD",
        name: "Europe/Andorra",
        status: "Canonical",
        offset: "+01:00",
        link: ""
    },
    {
        country: "RU",
        name: "Europe/Astrakhan",
        status: "Canonical",
        offset: "+04:00",
        link: ""
    },
    {
        country: "GR",
        name: "Europe/Athens",
        status: "Canonical",
        offset: "+02:00",
        link: ""
    },
    {
        country: "GB",
        name: "Europe/Belfast",
        status: "Deprecated",
        offset: "+00:00",
        link: "Europe/London"
    },
    {
        country: "RS",
        name: "Europe/Belgrade",
        status: "Canonical",
        offset: "+01:00",
        link: ""
    },
    {
        country: "DE",
        name: "Europe/Berlin",
        status: "Canonical",
        offset: "+01:00",
        link: "Time in Germany"
    },
    {
        country: "SK",
        name: "Europe/Bratislava",
        status: "Alias",
        offset: "+01:00",
        link: "Europe/Prague"
    },
    {
        country: "BE",
        name: "Europe/Brussels",
        status: "Canonical",
        offset: "+01:00",
        link: ""
    },
    {
        country: "RO",
        name: "Europe/Bucharest",
        status: "Canonical",
        offset: "+02:00",
        link: ""
    },
    {
        country: "HU",
        name: "Europe/Budapest",
        status: "Canonical",
        offset: "+01:00",
        link: ""
    },
    {
        country: "DE",
        name: "Europe/Busingen",
        status: "Alias",
        offset: "+01:00",
        link: "Europe/Zurich"
    },
    {
        country: "MD",
        name: "Europe/Chisinau",
        status: "Canonical",
        offset: "+02:00",
        link: ""
    },
    {
        country: "DK",
        name: "Europe/Copenhagen",
        status: "Canonical",
        offset: "+01:00",
        link: ""
    },
    {
        country: "IE",
        name: "Europe/Dublin",
        status: "Canonical",
        offset: "+01:00",
        link: ""
    },
    {
        country: "GI",
        name: "Europe/Gibraltar",
        status: "Canonical",
        offset: "+01:00",
        link: ""
    },
    {
        country: "GG",
        name: "Europe/Guernsey",
        status: "Alias",
        offset: "+00:00",
        link: "Europe/London"
    },
    {
        country: "FI",
        name: "Europe/Helsinki",
        status: "Canonical",
        offset: "+02:00",
        link: ""
    },
    {
        country: "IM",
        name: "Europe/Isle_of_Man",
        status: "Alias",
        offset: "+00:00",
        link: "Europe/London"
    },
    {
        country: "TR",
        name: "Europe/Istanbul",
        status: "Canonical",
        offset: "+03:00",
        link: ""
    },
    {
        country: "JE",
        name: "Europe/Jersey",
        status: "Alias",
        offset: "+00:00",
        link: "Europe/London"
    },
    {
        country: "RU",
        name: "Europe/Kaliningrad",
        status: "Canonical",
        offset: "+02:00",
        link: ""
    },
    {
        country: "UA",
        name: "Europe/Kiev",
        status: "Canonical",
        offset: "+02:00",
        link: ""
    },
    {
        country: "RU",
        name: "Europe/Kirov",
        status: "Canonical",
        offset: "+03:00",
        link: ""
    },
    {
        country: "PT",
        name: "Europe/Lisbon",
        status: "Canonical",
        offset: "+00:00",
        link: ""
    },
    {
        country: "SI",
        name: "Europe/Ljubljana",
        status: "Alias",
        offset: "+01:00",
        link: "Europe/Belgrade"
    },
    {
        country: "GB",
        name: "Europe/London",
        status: "Canonical",
        offset: "+00:00",
        link: ""
    },
    {
        country: "LU",
        name: "Europe/Luxembourg",
        status: "Canonical",
        offset: "+01:00",
        link: ""
    },
    {
        country: "ES",
        name: "Europe/Madrid",
        status: "Canonical",
        offset: "+01:00",
        link: ""
    },
    {
        country: "MT",
        name: "Europe/Malta",
        status: "Canonical",
        offset: "+01:00",
        link: ""
    },
    {
        country: "AX",
        name: "Europe/Mariehamn",
        status: "Alias",
        offset: "+02:00",
        link: "Europe/Helsinki"
    },
    {
        country: "BY",
        name: "Europe/Minsk",
        status: "Canonical",
        offset: "+03:00",
        link: ""
    },
    {
        country: "MC",
        name: "Europe/Monaco",
        status: "Canonical",
        offset: "+01:00",
        link: ""
    },
    {
        country: "RU",
        name: "Europe/Moscow",
        status: "Canonical",
        offset: "+03:00",
        link: ""
    },
    {
        country: "CY",
        name: "Europe/Nicosia",
        status: "Alias",
        offset: "+02:00",
        link: "Asia/Nicosia"
    },
    {
        country: "NO",
        name: "Europe/Oslo",
        status: "Canonical",
        offset: "+01:00",
        link: ""
    },
    {
        country: "FR",
        name: "Europe/Paris",
        status: "Canonical",
        offset: "+01:00",
        link: ""
    },
    {
        country: "ME",
        name: "Europe/Podgorica",
        status: "Alias",
        offset: "+01:00",
        link: "Europe/Belgrade"
    },
    {
        country: "CZ",
        name: "Europe/Prague",
        status: "Canonical",
        offset: "+01:00",
        link: ""
    },
    {
        country: "LV",
        name: "Europe/Riga",
        status: "Canonical",
        offset: "+02:00",
        link: ""
    },
    {
        country: "IT",
        name: "Europe/Rome",
        status: "Canonical",
        offset: "+01:00",
        link: ""
    },
    {
        country: "RU",
        name: "Europe/Samara",
        status: "Canonical",
        offset: "+04:00",
        link: ""
    },
    {
        country: "SM",
        name: "Europe/San_Marino",
        status: "Alias",
        offset: "+01:00",
        link: "Europe/Rome"
    },
    {
        country: "BA",
        name: "Europe/Sarajevo",
        status: "Alias",
        offset: "+01:00",
        link: "Europe/Belgrade"
    },
    {
        country: "RU",
        name: "Europe/Saratov",
        status: "Canonical",
        offset: "+04:00",
        link: ""
    },
    {
        country: "UA",
        name: "Europe/Simferopol",
        status: "Canonical",
        offset: "+03:00",
        link: "Disputed - Reflects data in the TZDB."
    },
    {
        country: "MK",
        name: "Europe/Skopje",
        status: "Alias",
        offset: "+01:00",
        link: "Europe/Belgrade"
    },
    {
        country: "BG",
        name: "Europe/Sofia",
        status: "Canonical",
        offset: "+02:00",
        link: ""
    },
    {
        country: "SE",
        name: "Europe/Stockholm",
        status: "Canonical",
        offset: "+01:00",
        link: ""
    },
    {
        country: "EE",
        name: "Europe/Tallinn",
        status: "Canonical",
        offset: "+02:00",
        link: ""
    },
    {
        country: "AL",
        name: "Europe/Tirane",
        status: "Canonical",
        offset: "+01:00",
        link: ""
    },
    {
        country: "MD",
        name: "Europe/Tiraspol",
        status: "Deprecated",
        offset: "+02:00",
        link: "Europe/Chisinau"
    },
    {
        country: "RU",
        name: "Europe/Ulyanovsk",
        status: "Canonical",
        offset: "+04:00",
        link: ""
    },
    {
        country: "UA",
        name: "Europe/Uzhgorod",
        status: "Canonical",
        offset: "+02:00",
        link: ""
    },
    {
        country: "LI",
        name: "Europe/Vaduz",
        status: "Alias",
        offset: "+01:00",
        link: "Europe/Zurich"
    },
    {
        country: "VA",
        name: "Europe/Vatican",
        status: "Alias",
        offset: "+01:00",
        link: "Europe/Rome"
    },
    {
        country: "AT",
        name: "Europe/Vienna",
        status: "Canonical",
        offset: "+01:00",
        link: ""
    },
    {
        country: "LT",
        name: "Europe/Vilnius",
        status: "Canonical",
        offset: "+02:00",
        link: ""
    },
    {
        country: "RU",
        name: "Europe/Volgograd",
        status: "Canonical",
        offset: "+03:00",
        link: ""
    },
    {
        country: "PL",
        name: "Europe/Warsaw",
        status: "Canonical",
        offset: "+01:00",
        link: ""
    },
    {
        country: "HR",
        name: "Europe/Zagreb",
        status: "Alias",
        offset: "+01:00",
        link: "Europe/Belgrade"
    },
    {
        country: "UA",
        name: "Europe/Zaporozhye",
        status: "Canonical",
        offset: "+02:00",
        link: ""
    },
    {
        country: "CH",
        name: "Europe/Zurich",
        status: "Canonical",
        offset: "+01:00",
        link: ""
    },
    {
        country: "",
        name: "Factory",
        status: "Canonical",
        offset: "+00:00",
        link: ""
    },
    {
        country: "GB",
        name: "GB",
        status: "Deprecated",
        offset: "+00:00",
        link: "Europe/London"
    },
    {
        country: "GB",
        name: "GB-Eire",
        status: "Deprecated",
        offset: "+00:00",
        link: "Europe/London"
    },
    {
        country: "",
        name: "GMT",
        status: "Alias",
        offset: "+00:00",
        link: "Etc/GMT"
    },
    {
        country: "",
        name: "GMT+0",
        status: "Deprecated",
        offset: "+00:00",
        link: "Etc/GMT"
    },
    {
        country: "",
        name: "GMT-0",
        status: "Deprecated",
        offset: "+00:00",
        link: "Etc/GMT"
    },
    {
        country: "",
        name: "GMT0",
        status: "Deprecated",
        offset: "+00:00",
        link: "Etc/GMT"
    },
    {
        country: "",
        name: "Greenwich",
        status: "Deprecated",
        offset: "+00:00",
        link: "Etc/GMT"
    },
    {
        country: "HK",
        name: "Hongkong",
        status: "Deprecated",
        offset: "+08:00",
        link: "Asia/Hong_Kong"
    },
    {
        country: "",
        name: "HST",
        status: "Deprecated",
        offset: "−10:00",
        link: "Pacific/Honolulu"
    },
    {
        country: "IS",
        name: "Iceland",
        status: "Deprecated",
        offset: "+00:00",
        link: "Atlantic/Reykjavik"
    },
    {
        country: "MG",
        name: "Indian/Antananarivo",
        status: "Alias",
        offset: "+03:00",
        link: "Africa/Nairobi"
    },
    {
        country: "IO",
        name: "Indian/Chagos",
        status: "Canonical",
        offset: "+06:00",
        link: ""
    },
    {
        country: "CX",
        name: "Indian/Christmas",
        status: "Canonical",
        offset: "+07:00",
        link: ""
    },
    {
        country: "CC",
        name: "Indian/Cocos",
        status: "Canonical",
        offset: "+06:30",
        link: ""
    },
    {
        country: "KM",
        name: "Indian/Comoro",
        status: "Alias",
        offset: "+03:00",
        link: "Africa/Nairobi"
    },
    {
        country: "TF",
        name: "Indian/Kerguelen",
        status: "Canonical",
        offset: "+05:00",
        link: ""
    },
    {
        country: "SC",
        name: "Indian/Mahe",
        status: "Canonical",
        offset: "+04:00",
        link: ""
    },
    {
        country: "MV",
        name: "Indian/Maldives",
        status: "Canonical",
        offset: "+05:00",
        link: ""
    },
    {
        country: "MU",
        name: "Indian/Mauritius",
        status: "Canonical",
        offset: "+04:00",
        link: ""
    },
    {
        country: "YT",
        name: "Indian/Mayotte",
        status: "Alias",
        offset: "+03:00",
        link: "Africa/Nairobi"
    },
    {
        country: "RE",
        name: "Indian/Reunion",
        status: "Canonical",
        offset: "+04:00",
        link: ""
    },
    {
        country: "IR",
        name: "Iran",
        status: "Deprecated",
        offset: "+03:30",
        link: "Asia/Tehran"
    },
    {
        country: "IL",
        name: "Israel",
        status: "Deprecated",
        offset: "+02:00",
        link: "Asia/Jerusalem"
    },
    {
        country: "JM",
        name: "Jamaica",
        status: "Deprecated",
        offset: "−05:00",
        link: "America/Jamaica"
    },
    {
        country: "JP",
        name: "Japan",
        status: "Deprecated",
        offset: "+09:00",
        link: "Asia/Tokyo"
    },
    {
        country: "MH",
        name: "Kwajalein",
        status: "Deprecated",
        offset: "+12:00",
        link: "Pacific/Kwajalein"
    },
    {
        country: "LY",
        name: "Libya",
        status: "Deprecated",
        offset: "+02:00",
        link: "Africa/Tripoli"
    },
    {
        country: "",
        name: "MET",
        status: "Deprecated",
        offset: "+01:00",
        link: "Europe/Paris"
    },
    {
        country: "MX",
        name: "Mexico/BajaNorte",
        status: "Deprecated",
        offset: "−08:00",
        link: "America/Tijuana"
    },
    {
        country: "MX",
        name: "Mexico/BajaSur",
        status: "Deprecated",
        offset: "−07:00",
        link: "America/Mazatlan"
    },
    {
        country: "MX",
        name: "Mexico/General",
        status: "Deprecated",
        offset: "−06:00",
        link: "America/Mexico_City"
    },
    {
        country: "",
        name: "MST",
        status: "Deprecated",
        offset: "−07:00",
        link: "America/Phoenix"
    },
    {
        country: "",
        name: "MST7MDT",
        status: "Deprecated",
        offset: "−07:00",
        link: "America/Denver"
    },
    {
        country: "US",
        name: "Navajo",
        status: "Deprecated",
        offset: "−07:00",
        link: "America/Denver"
    },
    {
        country: "NZ",
        name: "NZ",
        status: "Deprecated",
        offset: "+12:00",
        link: "Pacific/Auckland"
    },
    {
        country: "NZ",
        name: "NZ-CHAT",
        status: "Deprecated",
        offset: "+12:45",
        link: "Pacific/Chatham"
    },
    {
        country: "WS",
        name: "Pacific/Apia",
        status: "Canonical",
        offset: "+13:00",
        link: ""
    },
    {
        country: "NZ",
        name: "Pacific/Auckland",
        status: "Canonical",
        offset: "+12:00",
        link: ""
    },
    {
        country: "PG",
        name: "Pacific/Bougainville",
        status: "Canonical",
        offset: "+11:00",
        link: ""
    },
    {
        country: "NZ",
        name: "Pacific/Chatham",
        status: "Canonical",
        offset: "+12:45",
        link: ""
    },
    {
        country: "FM",
        name: "Pacific/Chuuk",
        status: "Canonical",
        offset: "+10:00",
        link: ""
    },
    {
        country: "CL",
        name: "Pacific/Easter",
        status: "Canonical",
        offset: "−06:00",
        link: ""
    },
    {
        country: "VU",
        name: "Pacific/Efate",
        status: "Canonical",
        offset: "+11:00",
        link: ""
    },
    {
        country: "KI",
        name: "Pacific/Enderbury",
        status: "Canonical",
        offset: "+13:00",
        link: ""
    },
    {
        country: "TK",
        name: "Pacific/Fakaofo",
        status: "Canonical",
        offset: "+13:00",
        link: ""
    },
    {
        country: "FJ",
        name: "Pacific/Fiji",
        status: "Canonical",
        offset: "+12:00",
        link: ""
    },
    {
        country: "TV",
        name: "Pacific/Funafuti",
        status: "Canonical",
        offset: "+12:00",
        link: ""
    },
    {
        country: "EC",
        name: "Pacific/Galapagos",
        status: "Canonical",
        offset: "−06:00",
        link: ""
    },
    {
        country: "PF",
        name: "Pacific/Gambier",
        status: "Canonical",
        offset: "−09:00",
        link: ""
    },
    {
        country: "SB",
        name: "Pacific/Guadalcanal",
        status: "Canonical",
        offset: "+11:00",
        link: ""
    },
    {
        country: "GU",
        name: "Pacific/Guam",
        status: "Canonical",
        offset: "+10:00",
        link: ""
    },
    {
        country: "US",
        name: "Pacific/Honolulu",
        status: "Canonical",
        offset: "−10:00",
        link: ""
    },
    {
        country: "UM",
        name: "Pacific/Johnston",
        status: "Deprecated",
        offset: "−10:00",
        link: "Pacific/Honolulu"
    },
    {
        country: "KI",
        name: "Pacific/Kiritimati",
        status: "Canonical",
        offset: "+14:00",
        link: ""
    },
    {
        country: "FM",
        name: "Pacific/Kosrae",
        status: "Canonical",
        offset: "+11:00",
        link: ""
    },
    {
        country: "MH",
        name: "Pacific/Kwajalein",
        status: "Canonical",
        offset: "+12:00",
        link: ""
    },
    {
        country: "MH",
        name: "Pacific/Majuro",
        status: "Canonical",
        offset: "+12:00",
        link: ""
    },
    {
        country: "PF",
        name: "Pacific/Marquesas",
        status: "Canonical",
        offset: "−09:30",
        link: ""
    },
    {
        country: "UM",
        name: "Pacific/Midway",
        status: "Alias",
        offset: "−11:00",
        link: "Pacific/Pago_Pago"
    },
    {
        country: "NR",
        name: "Pacific/Nauru",
        status: "Canonical",
        offset: "+12:00",
        link: ""
    },
    {
        country: "NU",
        name: "Pacific/Niue",
        status: "Canonical",
        offset: "−11:00",
        link: ""
    },
    {
        country: "NF",
        name: "Pacific/Norfolk",
        status: "Canonical",
        offset: "+11:00",
        link: ""
    },
    {
        country: "NC",
        name: "Pacific/Noumea",
        status: "Canonical",
        offset: "+11:00",
        link: ""
    },
    {
        country: "AS",
        name: "Pacific/Pago_Pago",
        status: "Canonical",
        offset: "−11:00",
        link: ""
    },
    {
        country: "PW",
        name: "Pacific/Palau",
        status: "Canonical",
        offset: "+09:00",
        link: ""
    },
    {
        country: "PN",
        name: "Pacific/Pitcairn",
        status: "Canonical",
        offset: "−08:00",
        link: ""
    },
    {
        country: "FM",
        name: "Pacific/Pohnpei",
        status: "Canonical",
        offset: "+11:00",
        link: ""
    },
    {
        country: "FM",
        name: "Pacific/Ponape",
        status: "Deprecated",
        offset: "+11:00",
        link: "Pacific/Pohnpei"
    },
    {
        country: "PG",
        name: "Pacific/Port_Moresby",
        status: "Canonical",
        offset: "+10:00",
        link: ""
    },
    {
        country: "CK",
        name: "Pacific/Rarotonga",
        status: "Canonical",
        offset: "−10:00",
        link: ""
    },
    {
        country: "MP",
        name: "Pacific/Saipan",
        status: "Alias",
        offset: "+10:00",
        link: "Pacific/Guam"
    },
    {
        country: "WS",
        name: "Pacific/Samoa",
        status: "Deprecated",
        offset: "−11:00",
        link: "Pacific/Pago_Pago"
    },
    {
        country: "PF",
        name: "Pacific/Tahiti",
        status: "Canonical",
        offset: "−10:00",
        link: ""
    },
    {
        country: "KI",
        name: "Pacific/Tarawa",
        status: "Canonical",
        offset: "+12:00",
        link: ""
    },
    {
        country: "TO",
        name: "Pacific/Tongatapu",
        status: "Canonical",
        offset: "+13:00",
        link: ""
    },
    {
        country: "FM",
        name: "Pacific/Truk",
        status: "Deprecated",
        offset: "+10:00",
        link: "Pacific/Chuuk"
    },
    {
        country: "UM",
        name: "Pacific/Wake",
        status: "Canonical",
        offset: "+12:00",
        link: ""
    },
    {
        country: "WF",
        name: "Pacific/Wallis",
        status: "Canonical",
        offset: "+12:00",
        link: ""
    },
    {
        country: "FM",
        name: "Pacific/Yap",
        status: "Deprecated",
        offset: "+10:00",
        link: "Pacific/Chuuk"
    },
    {
        country: "PL",
        name: "Poland",
        status: "Deprecated",
        offset: "+01:00",
        link: "Europe/Warsaw"
    },
    {
        country: "PT",
        name: "Portugal",
        status: "Deprecated",
        offset: "+00:00",
        link: "Europe/Lisbon"
    },
    {
        country: "CN",
        name: "PRC",
        status: "Deprecated",
        offset: "+08:00",
        link: "Asia/Shanghai"
    },
    {
        country: "",
        name: "PST8PDT",
        status: "Deprecated",
        offset: "−08:00",
        link: "America/Los_Angeles"
    },
    {
        country: "TW",
        name: "ROC",
        status: "Deprecated",
        offset: "+08:00",
        link: "Asia/Taipei"
    },
    {
        country: "KR",
        name: "ROK",
        status: "Deprecated",
        offset: "+09:00",
        link: "Asia/Seoul"
    },
    {
        country: "SG",
        name: "Singapore",
        status: "Deprecated",
        offset: "+08:00",
        link: "Asia/Singapore"
    },
    {
        country: "TR",
        name: "Turkey",
        status: "Deprecated",
        offset: "+03:00",
        link: "Europe/Istanbul"
    },
    {
        country: "",
        name: "UCT",
        status: "Deprecated",
        offset: "+00:00",
        link: "Etc/UTC"
    },
    {
        country: "",
        name: "Universal",
        status: "Deprecated",
        offset: "+00:00",
        link: "Etc/UTC"
    },
    {
        country: "US",
        name: "US/Alaska",
        status: "Deprecated",
        offset: "−09:00",
        link: "America/Anchorage"
    },
    {
        country: "US",
        name: "US/Aleutian",
        status: "Deprecated",
        offset: "−10:00",
        link: "America/Adak"
    },
    {
        country: "US",
        name: "US/Arizona",
        status: "Deprecated",
        offset: "−07:00",
        link: "America/Phoenix"
    },
    {
        country: "US",
        name: "US/Central",
        status: "Deprecated",
        offset: "−06:00",
        link: "America/Chicago"
    },
    {
        country: "US",
        name: "US/East-Indiana",
        status: "Deprecated",
        offset: "−05:00",
        link: "America/Indiana/Indianapolis"
    },
    {
        country: "US",
        name: "US/Eastern",
        status: "Deprecated",
        offset: "−05:00",
        link: "America/New_York"
    },
    {
        country: "US",
        name: "US/Hawaii",
        status: "Deprecated",
        offset: "−10:00",
        link: "Pacific/Honolulu"
    },
    {
        country: "US",
        name: "US/Indiana-Starke",
        status: "Deprecated",
        offset: "−06:00",
        link: "America/Indiana/Knox"
    },
    {
        country: "US",
        name: "US/Michigan",
        status: "Deprecated",
        offset: "−05:00",
        link: "America/Detroit"
    },
    {
        country: "US",
        name: "US/Mountain",
        status: "Deprecated",
        offset: "−07:00",
        link: "America/Denver"
    },
    {
        country: "US",
        name: "US/Pacific",
        status: "Deprecated",
        offset: "−08:00",
        link: "America/Los_Angeles"
    },
    {
        country: "WS",
        name: "US/Samoa",
        status: "Deprecated",
        offset: "−11:00",
        link: "Pacific/Pago_Pago"
    },
    {
        country: "",
        name: "UTC",
        status: "Alias",
        offset: "+00:00",
        link: "Etc/UTC"
    },
    {
        country: "RU",
        name: "W-SU",
        status: "Deprecated",
        offset: "+03:00",
        link: "Europe/Moscow"
    },
    {
        country: "",
        name: "WET",
        status: "Deprecated",
        offset: "+00:00",
        link: "Europe/Lisbon"
    },
    {
        country: "",
        name: "Zulu",
        status: "Deprecated",
        offset: "+00:00",
        link: "Etc/UTC"
    }, 
];
var TIMEZONES = [
    {
        code: "UTC",
        description: "(UTC) Universal Coordinated Time"
    },
    {
        code: "ECT",
        description: "(UTC+01:00) European Central Time"
    },
    {
        code: "EET",
        description: "(UTC+02:00) Eastern European Time"
    },
    {
        code: "ART",
        description: "(UTC+02:00) (Arabic) Egypt Standard Time"
    },
    {
        code: "EAT",
        description: "(UTC+03:00) Eastern African Time"
    },
    {
        code: "MET",
        description: "(UTC+03:30) Middle East Time"
    },
    {
        code: "NET",
        description: "(UTC+04:00) Near East Time"
    },
    {
        code: "PLT",
        description: "(UTC+05:00) Pakistan Lahore Time"
    },
    {
        code: "IST",
        description: "(UTC+05:30) India Standard Time"
    },
    {
        code: "BST",
        description: "(UTC+06:00) Bangladesh Standard Time"
    },
    {
        code: "VST",
        description: "(UTC+07:00) Vietnam Standard Time"
    },
    {
        code: "CTT",
        description: "(UTC+08:00) China Taiwan Time"
    },
    {
        code: "JST",
        description: "(UTC+09:00) Japan Standard Time"
    },
    {
        code: "ACT",
        description: "(UTC+09:30) Australia Central Time"
    },
    {
        code: "AET",
        description: "(UTC+10:00) Australia Eastern Time"
    },
    {
        code: "SST",
        description: "(UTC+11:00) Solomon Standard Time"
    },
    {
        code: "NST",
        description: "(UTC+12:00) New Zealand Standard Time"
    },
    {
        code: "MIT",
        description: "(UTC-11:00) Midway Islands Time"
    },
    {
        code: "HST",
        description: "(UTC-10:00) Hawaii Standard Time"
    },
    {
        code: "AST",
        description: "(UTC-09:00) Alaska Standard Time"
    },
    {
        code: "PST",
        description: "(UTC-08:00) Pacific Standard Time"
    },
    {
        code: "PNT",
        description: "(UTC-07:00) Phoenix Standard Time"
    },
    {
        code: "MST",
        description: "(UTC-07:00) Mountain Standard Time"
    },
    {
        code: "CST",
        description: "(UTC-06:00) Central Standard Time"
    },
    {
        code: "EST",
        description: "(UTC-05:00) Eastern Standard Time"
    },
    {
        code: "IET",
        description: "(UTC-05:00) Indiana Eastern Standard Time"
    },
    {
        code: "PRT",
        description: "(UTC-04:00) Puerto Rico and US Virgin Islands Time"
    },
    {
        code: "CNT",
        description: "(UTC-03:30) Canada Newfoundland Time"
    },
    {
        code: "AGT",
        description: "(UTC-03:00) Argentina Standard Time"
    },
    {
        code: "BET",
        description: "(UTC-03:00) Brazil Eastern Time"
    },
    {
        code: "CAT",
        description: "(UTC-1:00) Central African Time"
    }, 
];

// EXTERNAL MODULE: ./node_modules/.pnpm/@emotion+styled@11.8.1_psntm5zmlvip7zjgnrjqfe3wg4/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js
var emotion_styled_browser_esm = __webpack_require__(43893);
;// CONCATENATED MODULE: ./components/user/settings/index.tsx








var Section = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "eg9r92y0"
})({
    padding: 24,
    position: "relative",
    background: "#fff",
    borderRadius: 4,
    border: "1px solid ".concat(palette/* lightestGray */.v2)
});
var Title = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("h2", {
    target: "eg9r92y1"
})({
    paddingBottom: 20,
    fontSize: 20,
    margin: 0,
    color: palette/* darkGray */.O5,
    borderBottom: "1px solid ".concat(palette/* lightestGray */.v2)
});
var Form = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("form", {
    target: "eg9r92y2"
})({
    display: "flex",
    flexDirection: "column",
    width: "100%"
});
function FormGroup(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Phone */.LP, {
        children: function(isPhone) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,_object_spread/* default */.Z)({
                css: {
                    display: "flex",
                    width: "100%",
                    marginTop: 25,
                    position: "relative",
                    alignItems: "center",
                    flexWrap: isPhone ? "wrap" : null
                }
            }, props));
        }
    });
}
var Label = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("label", {
    target: "eg9r92y3"
})({
    width: 170,
    textAlign: "left",
    fontWeight: 500,
    fontSize: 16,
    color: palette/* sealBlue */.N9
});
var Error = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("span", {
    target: "eg9r92y4"
})({
    position: "absolute",
    bottom: 8,
    marginBottom: 3,
    left: 150,
    fontSize: 12,
    color: palette/* red */.Q6
});
var Input = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("input", {
    target: "eg9r92y5"
})({
    width: "100%",
    border: 0,
    background: "none",
    paddingBottom: 16,
    paddingLeft: 0,
    borderBottom: "1px solid ".concat(palette/* lightestGray */.v2),
    "&:focus, &:active": {
        borderBottom: "1px solid ".concat(palette/* lightGray */.l2),
        outline: 0
    },
    color: palette/* text */.fL,
    fontSize: 14,
    "&::placeholder": {
        color: palette/* sealBlue */.N9,
        fontWeight: 500
    }
}, function(param) {
    var hasError = param.hasError;
    if (hasError) {
        return {
            borderBottomColor: palette/* red */.Q6,
            ":focus, :active": {
                borderBottomColor: palette/* red */.Q6
            }
        };
    }
});
var Checkbox = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("input", {
    target: "eg9r92y6"
})({
    margin: "0 !important"
});
function TextField(_param) {
    var input = _param.input, meta = _param.meta, props = (0,_object_without_properties/* default */.Z)(_param, [
        "input",
        "meta"
    ]);
    var hasError = meta.touched && (!!meta.error || !!meta.submitError);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Input, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props, input), {
                hasError: hasError
            })),
            hasError && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Error, {
                children: meta.error || meta.submitError
            })
        ]
    });
}
var CheckboxField = function(_param) {
    var input = _param.input, meta = _param.meta, label = _param.label, id = _param.id, props = (0,_object_without_properties/* default */.Z)(_param, [
        "input",
        "meta",
        "label",
        "id"
    ]);
    var hasError = meta.touched && (!!meta.error || !!meta.submitError);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("label", {
        htmlFor: id,
        css: {
            width: "100%",
            display: "flex",
            alignItems: "center"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Checkbox, (0,_object_spread/* default */.Z)({
                id: id,
                type: "checkbox"
            }, props, input)),
            label && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    margin: 0,
                    marginLeft: 10,
                    fontWeight: "normal",
                    fontSize: 14,
                    marginTop: 1
                },
                children: label
            }),
            hasError && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Error, {
                children: meta.error || meta.submitError
            })
        ]
    });
};
function RadioboxField(param) {
    var input = param.input, meta = param.meta, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, children = param.children;
    var hasError = meta.touched && (!!meta.error || !!meta.submitError);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("label", {
        css: {
            width: "100%",
            display: "flex",
            alignItems: "center"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Checkbox, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                type: "checkbox"
            }, input), {
                disabled: disabled
            })),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    margin: 0,
                    marginLeft: 10,
                    fontWeight: "normal",
                    fontSize: 14,
                    marginTop: 1
                },
                children: children
            }),
            hasError && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Error, {
                children: meta.error || meta.submitError
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/tag/TagsSelect.tsx
var TagsSelect = __webpack_require__(90731);
// EXTERNAL MODULE: ./components/form/FieldValidationError.tsx
var FieldValidationError = __webpack_require__(80360);
;// CONCATENATED MODULE: ./components/user/settings/DepartmentField.tsx










function DepartmentField() {
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Field */.gN, {
        name: "department",
        children: function(param) {
            var input = param.input, meta = param.meta;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FormGroup, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Phone */.LP, {
                        children: function(isPhone) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Label, {
                                id: "tags-input-memo-label",
                                css: {
                                    marginTop: 12,
                                    marginBottom: "auto",
                                    width: 140,
                                    flexShrink: 0,
                                    flexGrow: 0,
                                    color: !input.value ? "#BE561E" : palette/* darkGray */.O5,
                                    paddingBottom: isPhone ? 16 : 0
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Department",
                                    id: "eXcD4S"
                                })
                            });
                        }
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        css: {
                            width: "100%",
                            minWidth: 250
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TagsSelect/* default */.Z, {
                                onChange: function(tags) {
                                    if (tags.length > 0) {
                                        input.onChange(tags[tags.length - 1]);
                                    } else {
                                        input.onChange(null);
                                    }
                                },
                                onFocus: input.onFocus,
                                onBlur: input.onBlur,
                                placeholder: input.value ? " " : intl.formatMessage({
                                    defaultMessage: "What department do you work in?",
                                    id: "zAQz7C"
                                }),
                                value: input.value ? [
                                    input.value
                                ] : [],
                                type: types/* ITagType.Department */.mG.Department
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FieldValidationError/* default */.Z, {
                                    meta: meta
                                })
                            })
                        ]
                    })
                ]
            });
        }
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.9_mnlteiidv5se4zpyvopwg4rohq/node_modules/@apollo/client/react/hooks/useApolloClient.js
var useApolloClient = __webpack_require__(16258);
;// CONCATENATED MODULE: ./lib/queries/GetDepartmentRelatedTags.ts

function GetDepartmentRelatedTags_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query GetDepartmentRelatedTags($departmentId: ObjectId!) {\n    getDepartmentRelatedTags(departmentId: $departmentId) {\n      _id\n      name\n    }\n  }\n"
    ]);
    GetDepartmentRelatedTags_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var GetDepartmentRelatedTags = ((0,lib/* gql */.Ps)(GetDepartmentRelatedTags_templateObject()));

// EXTERNAL MODULE: ./node_modules/.pnpm/react-final-form-listeners@1.0.3_lg2mtjwdp6uekin4ikdpzytntq/node_modules/react-final-form-listeners/dist/react-final-form-listeners.es.js
var react_final_form_listeners_es = __webpack_require__(60526);
;// CONCATENATED MODULE: ./components/user/settings/InterestsField.tsx

















function InterestsField() {
    var apolloClient = (0,useApolloClient/* useApolloClient */.x)();
    var intl = (0,useIntl/* default */.Z)();
    var queryRelatedTags = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(departmentId) {
            var queryData;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return apolloClient.query({
                            query: GetDepartmentRelatedTags,
                            variables: {
                                departmentId: departmentId
                            }
                        });
                    case 2:
                        queryData = _ctx.sent;
                        return _ctx.abrupt("return", queryData.data.getDepartmentRelatedTags || []);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function queryRelatedTags(departmentId) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Field */.gN, {
        name: "interests",
        children: function(param) {
            var input = param.input, meta = param.meta;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_listeners_es/* OnChange */.GU, {
                        name: "department",
                        children: function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(value) {
                                var relatedTags, interests;
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            if (!value) {
                                                _ctx.next = 6;
                                                break;
                                            }
                                            _ctx.next = 3;
                                            return queryRelatedTags(value.objectID);
                                        case 3:
                                            relatedTags = _ctx.sent;
                                            interests = relatedTags.map(function(interest) {
                                                return {
                                                    _id: interest._id,
                                                    objectID: interest._id,
                                                    name: interest.name
                                                };
                                            }).filter(function(interest) {
                                                return !(input.value || []).find(function(value) {
                                                    return value._id === interest._id || value.objectID === interest._id;
                                                });
                                            });
                                            input.onChange((input.value || []).concat(interests));
                                        case 6:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }));
                            return function(value) {
                                return _ref.apply(this, arguments);
                            };
                        }()
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FormGroup, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Phone */.LP, {
                                children: function(isPhone) {
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Label, {
                                        id: "interests",
                                        css: {
                                            marginTop: 12,
                                            marginBottom: "auto",
                                            width: 140,
                                            flexShrink: 0,
                                            flexGrow: 0,
                                            color: !input.value ? "#BE561E" : palette/* darkGray */.O5,
                                            paddingBottom: isPhone ? 16 : 0
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Interests",
                                            id: "dDDm0f"
                                        })
                                    });
                                }
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                css: {
                                    width: "100%"
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TagsSelect/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, input), {
                                            type: [
                                                types/* ITagType.Product */.mG.Product,
                                                types/* ITagType.Story */.mG.Story,
                                                types/* ITagType.Project */.mG.Project
                                            ],
                                            placeholder: intl.formatMessage({
                                                defaultMessage: "Select up to twenty areas that interest you",
                                                id: "IFObl4"
                                            })
                                        })),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FieldValidationError/* default */.Z, {
                                                meta: meta
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            });
        }
    });
};

;// CONCATENATED MODULE: ./components/user/settings/MyDetailsSection.tsx




























var MyDetailsSection = function(param) {
    var user = param.user;
    var isPhone = (0,useIsPhone/* default */.Z)();
    var intl = (0,useIntl/* default */.Z)();
    var intlValidationMessages = (0,useIntlValidationMessages/* default */.Z)();
    var ref = (0,withIntl/* useIntlLocale */.U)(), locale = ref.locale, changeLocale = ref.changeLocale;
    var detailsValidationSchema = function(user) {
        if (user.__typename === "VendorUser") {
            return yup_es/* object */.Ry().shape({
                firstName: yup_es/* string */.Z_().required(intlValidationMessages.cantBeBlank),
                lastName: yup_es/* string */.Z_().required(intlValidationMessages.cantBeBlank),
                jobTitle: yup_es/* string */.Z_().nullable().trim(),
                email: yup_es/* string */.Z_().email(intlValidationMessages.invalidEmailAddress).nullable(),
                notificationEmail: yup_es/* string */.Z_().email(intlValidationMessages.invalidEmailAddress).nullable(),
                department: yup_es/* string */.Z_().nullable(),
                linkedin: yup_es/* string */.Z_().url(intlValidationMessages.invalidUrl).nullable(),
                twitter: yup_es/* string */.Z_().url(intlValidationMessages.invalidUrl).nullable(),
                hideSearch: yup_es/* bool */.Xg().required(),
                hideAuthor: yup_es/* bool */.Xg().required()
            });
        }
        return yup_es/* object */.Ry().shape({
            firstName: yup_es/* string */.Z_().required(intlValidationMessages.cantBeBlank),
            lastName: yup_es/* string */.Z_().required(intlValidationMessages.cantBeBlank),
            jobTitle: yup_es/* string */.Z_().nullable().trim(),
            email: yup_es/* string */.Z_().email(intlValidationMessages.invalidEmailAddress).nullable(),
            notificationEmail: yup_es/* string */.Z_().email(intlValidationMessages.invalidEmailAddress).nullable(),
            department: yup_es/* mixed */.nK().nullable(),
            interests: yup_es/* array */.IX().when("department", {
                is: function(value) {
                    return value !== null;
                },
                then: yup_es/* array */.IX().required().min(1, intlValidationMessages.selectAMinOfXitems(1)).max(20, intlValidationMessages.selectUpToItems(20)),
                otherwise: yup_es/* array */.IX().nullable().max(20, intlValidationMessages.selectUpToItems(20))
            }),
            linkedin: yup_es/* string */.Z_().url(intlValidationMessages.invalidUrl).nullable(),
            twitter: yup_es/* string */.Z_().url(intlValidationMessages.invalidUrl).nullable(),
            hideSearch: yup_es/* bool */.Xg().required(),
            hideAuthor: yup_es/* bool */.Xg().required()
        });
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section, {
        "data-intercom-target": "User Details",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                    defaultMessage: "My Details",
                    id: "mhrg7/"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
                mutation: UpdateProfile,
                onCompleted: function(data) {
                    if (data.updateProfile.language && data.updateProfile.language !== locale) {
                        changeLocale(data.updateProfile.language);
                    }
                },
                children: function(updateProfile) {
                    /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Form */.l0, {
                        keepDirtyOnReinitialize: true,
                        onSubmit: function() {
                            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
                                return runtime_default().wrap(function _callee$(_ctx) {
                                    while(1)switch(_ctx.prev = _ctx.next){
                                        case 0:
                                            _ctx.next = 2;
                                            return updateProfile({
                                                variables: {
                                                    user: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pick_default()([
                                                        "firstName",
                                                        "jobTitle",
                                                        "lastName",
                                                        "notificationEmail"
                                                    ], data)), {
                                                        department: data.department ? data.department.objectID : null,
                                                        interests: data.interests.map(function(param) {
                                                            var _id = param._id, objectID = param.objectID;
                                                            return _id || objectID;
                                                        }),
                                                        socialMedia: {
                                                            facebook: user.socialMedia ? user.socialMedia.facebook : null,
                                                            instagram: user.socialMedia ? user.socialMedia.instagram : null,
                                                            youtube: user.socialMedia ? user.socialMedia.youtube : null,
                                                            linkedin: data.linkedin,
                                                            twitter: data.twitter
                                                        },
                                                        searchable: !data.hideSearch,
                                                        preferences: {
                                                            showAsAuthorOnProjects: !data.hideAuthor
                                                        },
                                                        country: data.country,
                                                        language: data.language,
                                                        timeZone: data.timeZone
                                                    })
                                                }
                                            });
                                        case 2:
                                        case "end":
                                            return _ctx.stop();
                                    }
                                }, _callee);
                            }));
                            return function(data) {
                                return _ref.apply(this, arguments);
                            };
                        }(),
                        validate: (0,validate/* default */.Z)(detailsValidationSchema(user)),
                        initialValues: {
                            firstName: user.firstName,
                            lastName: user.lastName,
                            jobTitle: (user.jobTitle || "") === "-" ? null : user.jobTitle,
                            email: user.email,
                            notificationEmail: user.notificationEmail,
                            hideSearch: !user.searchable,
                            linkedin: user.socialMedia ? user.socialMedia.linkedin : null,
                            twitter: user.socialMedia ? user.socialMedia.twitter : null,
                            department: user.department ? {
                                _id: user.department._id,
                                objectID: user.department._id,
                                name: user.department.name
                            } : null,
                            interests: (user.interests || []).map(function(interest) {
                                return {
                                    _id: interest._id,
                                    objectID: interest._id,
                                    name: interest.name
                                };
                            }),
                            hideAuthor: user.isSiteAdmin ? true : !user.preferences.showAsAuthorOnProjects,
                            country: user.country,
                            language: user.language,
                            timeZone: user.timeZone
                        },
                        children: function(param) {
                            var handleSubmit = param.handleSubmit, submitting = param.submitting;
                            /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Form, {
                                onSubmit: handleSubmit,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormRow, {
                                        labelId: "firstName",
                                        label: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "First name",
                                            id: "pONqz8"
                                        }),
                                        field: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Field */.gN, {
                                            component: TextField,
                                            name: "firstName",
                                            type: "text",
                                            maxLength: 20
                                        }),
                                        isTextField: true
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormRow, {
                                        labelId: "lastName",
                                        label: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Last name",
                                            id: "txUL0F"
                                        }),
                                        field: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Field */.gN, {
                                            component: TextField,
                                            name: "lastName",
                                            type: "text",
                                            maxLength: 40
                                        }),
                                        isTextField: true
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormRow, {
                                        labelId: "jobTitle",
                                        label: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Job Title",
                                            id: "w7sjvQ"
                                        }),
                                        field: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Field */.gN, {
                                            component: TextField,
                                            name: "jobTitle",
                                            type: "text",
                                            maxLength: 120
                                        }),
                                        colorCondition: !user.jobTitle || user.jobTitle === "-",
                                        isTextField: true
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormRow, {
                                        labelId: "email",
                                        label: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "E-mail",
                                            id: "tkwCac"
                                        }),
                                        field: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Field */.gN, {
                                            component: TextField,
                                            name: "email",
                                            type: "text",
                                            disabled: true
                                        }),
                                        isTextField: true
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormRow, {
                                        labelId: "notificationEmail",
                                        label: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Notification E-mail",
                                            id: "Op5r53"
                                        }),
                                        field: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Field */.gN, {
                                            component: TextField,
                                            name: "notificationEmail",
                                            type: "text"
                                        }),
                                        colorCondition: !user.notificationEmail,
                                        isTextField: true
                                    }),
                                    user.__typename !== "VendorUser" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DepartmentField, {}),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InterestsField, {})
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormRow, {
                                        labelId: "linkedin",
                                        label: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Linkedin Profile URL",
                                            id: "MBUflk"
                                        }),
                                        field: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Field */.gN, {
                                            component: TextField,
                                            name: "linkedin",
                                            type: "text"
                                        }),
                                        colorCondition: !(user.socialMedia && user.socialMedia.linkedin),
                                        isTextField: true
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormRow, {
                                        labelId: "twitter",
                                        label: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Twitter Profile URL",
                                            id: "i2aOtT"
                                        }),
                                        field: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Field */.gN, {
                                            component: TextField,
                                            name: "twitter",
                                            type: "text"
                                        }),
                                        isTextField: true
                                    }),
                                    user.__typename === "GovernmentUser" && user.government && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormRow, {
                                        labelId: "government",
                                        label: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Government",
                                            id: "bh4rlK"
                                        }),
                                        field: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GovernmentRowValue, {
                                            user: user
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormRow, {
                                        labelId: "country",
                                        label: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Country",
                                            id: "vONi+O"
                                        }),
                                        field: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Field */.gN, {
                                            name: "country",
                                            children: function(param) {
                                                var input = param.input;
                                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SimpleSelect, {
                                                    allowEmpty: true,
                                                    input: input,
                                                    items: countries/* COUNTRIES.map */.od.map(function(country) {
                                                        return {
                                                            label: country.name,
                                                            value: country.code
                                                        };
                                                    })
                                                });
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormRow, {
                                        labelId: "language",
                                        label: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Language",
                                            id: "y1Z3or"
                                        }),
                                        field: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Field */.gN, {
                                            name: "language",
                                            children: function(param) {
                                                var input = param.input;
                                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SimpleSelect, {
                                                    allowEmpty: true,
                                                    input: input,
                                                    items: locales/* default.map */.Z.map(function(language) {
                                                        return {
                                                            label: language.name,
                                                            value: language.id
                                                        };
                                                    })
                                                });
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormRow, {
                                        labelId: "timeZone",
                                        label: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Time Zone",
                                            id: "jGWq1h"
                                        }),
                                        field: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                            css: {
                                                width: "100%"
                                            },
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Field */.gN, {
                                                name: "timeZone",
                                                children: function(param) {
                                                    var input = param.input;
                                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Typeahead */.pY, {
                                                        renderItem: TimeZoneTypeaheadItem,
                                                        items: TZ.filter(function(param) {
                                                            var status = param.status;
                                                            return status === "Canonical";
                                                        }).map(function(node) {
                                                            return {
                                                                label: node.name,
                                                                value: node.name,
                                                                offset: node.offset
                                                            };
                                                        }),
                                                        onChange: function(node) {
                                                            return input.onChange((node === null || node === void 0 ? void 0 : node.value) || null);
                                                        },
                                                        selectedItem: function() {
                                                            var matches = TZ.filter(function(param) {
                                                                var name = param.name;
                                                                return name === input.value;
                                                            });
                                                            if (matches && matches.length > 0) {
                                                                var _matches = (0,_sliced_to_array/* default */.Z)(matches, 1), node = _matches[0];
                                                                return {
                                                                    label: node.name,
                                                                    value: node.name,
                                                                    offset: node.offset
                                                                };
                                                            }
                                                            return null;
                                                        }(),
                                                        placeholder: "Type a timezone name"
                                                    });
                                                }
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormRow, {
                                        labelId: "search",
                                        label: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Search",
                                            id: "xmcVZ0"
                                        }),
                                        field: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Field */.gN, {
                                            component: CheckboxField,
                                            name: "hideSearch",
                                            id: "hideSearch",
                                            label: intl.formatMessage({
                                                defaultMessage: "Hide Profile from Google and other search engines",
                                                id: "ma/nUb"
                                            }),
                                            type: "checkbox"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormRow, {
                                        labelId: "hideAuthorLabel",
                                        label: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Project Creation",
                                            id: "MYIKOT"
                                        }),
                                        field: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Field */.gN, {
                                            component: CheckboxField,
                                            name: "hideAuthor",
                                            id: "hideAuthor",
                                            label: intl.formatMessage({
                                                defaultMessage: "Do not show my information on projects I create",
                                                id: "omJ8c+"
                                            }),
                                            type: "checkbox",
                                            disabled: user.isSiteAdmin
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                            mt: 20,
                                            css: {
                                                display: "flex",
                                                justifyContent: isPhone ? "center" : undefined
                                            },
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, {
                                                disabled: submitting,
                                                type: "submit",
                                                css: {
                                                    minWidth: 120
                                                },
                                                children: submitting ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                                    ml: 2,
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* LoadingIndicator */.TF, {})
                                                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                    defaultMessage: "Update",
                                                    id: "BWpuKl"
                                                })
                                            })
                                        })
                                    })
                                ]
                            });
                        }
                    });
                }
            })
        ]
    });
};
/* harmony default export */ var settings_MyDetailsSection = (MyDetailsSection);
function SimpleSelect(param) {
    var input = param.input, items = param.items, allowEmpty = param.allowEmpty;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("select", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, input), {
        css: {
            height: 42,
            padding: "0 10px",
            fontSize: 14,
            backgroundColor: palette/* white */.ix,
            border: "1px solid ".concat(palette/* lightestGray */.v2),
            borderRadius: 5,
            margin: 0,
            marginRight: 5,
            width: "100%",
            outline: 0,
            ":focus": {
                borderColor: palette/* lightGray */.l2
            },
            "::placeholder": {
                color: palette/* sealBlue */.N9
            }
        },
        children: [
            allowEmpty && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SelectOption, {
                label: "",
                value: ""
            }, "Empty"),
            items.map(function(item) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SelectOption, {
                    label: item.label,
                    value: item.value
                }, item.value);
            })
        ]
    }));
}
function SelectOption(param) {
    var label = param.label, value = param.value;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("option", {
        value: value,
        children: label
    });
}
function FormRow(param) {
    var labelId = param.labelId, label = param.label, field = param.field, colorCondition = param.colorCondition, isTextField = param.isTextField;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Label, {
        id: labelId,
        css: colorCondition ? {
            color: "#BE561E",
            width: "100%"
        } : {
            color: palette/* darkGray */.O5,
            width: "100%"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Phone */.LP, {
            children: function(isPhone) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FormGroup, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: {
                                width: 170,
                                marginRight: 10,
                                paddingBottom: isPhone || isTextField ? 16 : 0
                            },
                            children: label
                        }),
                        field
                    ]
                });
            }
        })
    });
}
function GovernmentRowValue(param) {
    var user = param.user;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
        css: {
            width: "100%",
            paddingBottom: 10,
            paddingLeft: 0,
            borderBottom: "1px solid ".concat(palette/* lightestGray */.v2)
        },
        children: user.government && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
            css: {
                display: "flex",
                alignItems: "center"
            },
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(profile_picture/* default */.Z, {
                    image: user.government.logo,
                    name: user.government.name,
                    xsmall: true
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                    css: {
                        color: palette/* text */.fL,
                        fontSize: 14,
                        marginLeft: 10
                    },
                    children: user.government.name
                })
            ]
        })
    });
}
function TimeZoneTypeaheadItem(param) {
    var item = param.item, active = param.active;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Flex */.kC, {
        as: "li",
        py: 3,
        px: 4,
        bg: active ? "blue.600" : "white",
        color: active ? "white" : "black",
        cursor: "pointer",
        align: "center",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
            overflow: "hidden",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(web/* Text */.xv, {
                fontSize: "md",
                mb: 0,
                isTruncated: true,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("i", {
                        children: item.offset
                    }),
                    " ",
                    item.label
                ]
            })
        })
    });
}

// EXTERNAL MODULE: ./lib/queries/fragments/GroupFields.ts
var GroupFields = __webpack_require__(89471);
;// CONCATENATED MODULE: ./lib/mutations/LeaveGroup.ts

function LeaveGroup_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation LeaveGroup($groupId: ObjectId!) {\n    leaveGroup(id: $groupId) {\n      ... on PendingUser {\n        _id\n        primaryGroup {\n          _id\n        }\n        groups {\n          _id\n          ...GroupFields\n        }\n      }\n      ... on GovernmentUser {\n        _id\n        primaryGroup {\n          _id\n        }\n        groups {\n          _id\n          ...GroupFields\n        }\n      }\n      ... on VendorUser {\n        _id\n        primaryGroup {\n          _id\n        }\n        groups {\n          _id\n          ...GroupFields\n        }\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    LeaveGroup_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ var LeaveGroup = ((0,lib/* gql */.Ps)(LeaveGroup_templateObject(), GroupFields/* default */.Z));

;// CONCATENATED MODULE: ./lib/mutations/SetPrimaryGroup.ts

function SetPrimaryGroup_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation SetPrimaryGroup($groupId: ObjectId!) {\n    setPrimaryGroup(id: $groupId) {\n      ... on PendingUser {\n        _id\n        primaryGroup {\n          _id\n        }\n        groups {\n          _id\n          ...GroupFields\n        }\n      }\n      ... on GovernmentUser {\n        _id\n        primaryGroup {\n          _id\n        }\n        groups {\n          _id\n          ...GroupFields\n        }\n      }\n      ... on VendorUser {\n        _id\n        primaryGroup {\n          _id\n        }\n        groups {\n          _id\n          ...GroupFields\n        }\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    SetPrimaryGroup_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/* harmony default export */ var SetPrimaryGroup = ((0,lib/* gql */.Ps)(SetPrimaryGroup_templateObject(), GroupFields/* default */.Z));

;// CONCATENATED MODULE: ./components/user/settings/MyGroupsSection.tsx











var MyGroupsSection = function(param) {
    var primaryGroup = param.primaryGroup, groups = param.groups;
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section, {
        "data-intercom-target": "User Groups",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                    defaultMessage: "My Groups",
                    id: "kkghcT"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
                mutation: LeaveGroup,
                children: function(leaveGroup) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
                        mutation: SetPrimaryGroup,
                        children: function(setPrimaryGroup) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                mt: 25,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    css: {
                                        display: "grid",
                                        gridRowGap: 12
                                    },
                                    children: groups.map(function(group) {
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                            css: {
                                                display: "flex"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                                    passHref: true,
                                                    href: "/groups/[groupSlug]",
                                                    as: "/groups/".concat(group.slug),
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(profile_picture/* default */.Z, {
                                                            size: 46,
                                                            name: group.name,
                                                            image: group.logo
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                    css: {
                                                        marginLeft: 12,
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        justifyContent: "space-around"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                                            passHref: true,
                                                            href: "/groups/[groupSlug]",
                                                            as: "/groups/".concat(group.slug),
                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                                                css: {
                                                                    color: palette/* darkGray */.O5,
                                                                    fontSize: 14,
                                                                    fontWeight: 600
                                                                },
                                                                children: group.name
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                            css: {
                                                                display: "flex",
                                                                alignItems: "center"
                                                            },
                                                            children: [
                                                                primaryGroup && primaryGroup._id === group._id && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                                    css: {
                                                                        display: "inline-flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                        color: palette/* primary */.T$,
                                                                        fontSize: 9,
                                                                        borderRadius: 20,
                                                                        backgroundColor: palette/* lightestBlue */.I,
                                                                        height: 18,
                                                                        padding: "0 14px",
                                                                        fontWeight: 600
                                                                    },
                                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                                        defaultMessage: "Primary Group",
                                                                        id: "avcQVt"
                                                                    })
                                                                }),
                                                                (!primaryGroup || primaryGroup._id !== group._id) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                                    onClick: function() {
                                                                        setPrimaryGroup({
                                                                            variables: {
                                                                                groupId: group._id
                                                                            }
                                                                        });
                                                                    },
                                                                    css: {
                                                                        fontSize: 12,
                                                                        color: palette/* primary */.T$,
                                                                        cursor: "pointer"
                                                                    },
                                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                                        defaultMessage: "Set as Primary",
                                                                        id: "CYgweL"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                                    css: {
                                                                        fontSize: 12,
                                                                        color: palette/* darkGray */.O5,
                                                                        marginLeft: 4,
                                                                        marginRight: 4
                                                                    },
                                                                    children: "\xb7"
                                                                }),
                                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                                    onClick: function() {
                                                                        if (window.confirm(intl.formatMessage({
                                                                            defaultMessage: "Are you sure you want to leave {name}?",
                                                                            id: "fkoj3E"
                                                                        }, {
                                                                            name: group.name
                                                                        }))) {
                                                                            leaveGroup({
                                                                                variables: {
                                                                                    groupId: group._id
                                                                                }
                                                                            });
                                                                        }
                                                                    },
                                                                    css: {
                                                                        fontSize: 12,
                                                                        color: palette/* red */.Q6,
                                                                        cursor: "pointer"
                                                                    },
                                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                                        defaultMessage: "Leave Group",
                                                                        id: "aN2Gli"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, group._id);
                                    })
                                })
                            });
                        }
                    });
                }
            })
        ]
    });
};
/* harmony default export */ var settings_MyGroupsSection = (MyGroupsSection);

;// CONCATENATED MODULE: ./lib/mutations/DeleteProfile.ts

function DeleteProfile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation DeleteProfile($userId: ObjectId!) {\n    deleteProfile(userId: $userId)\n  }\n"
    ]);
    DeleteProfile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var DeleteProfile = ((0,lib/* gql */.Ps)(DeleteProfile_templateObject()));

// EXTERNAL MODULE: ./components/makers/Alert.tsx
var Alert = __webpack_require__(6404);
;// CONCATENATED MODULE: ./components/user/settings/DeleteMyAccountSection.tsx














var ConfirmDelete = function(param) {
    var submitting = param.submitting;
    var ref = (0,react.useState)(""), deleteInputValue = ref[0], setDeleteInputValue = ref[1];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FormGroup, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Input */.II, {
                type: "text",
                css: {
                    maxWidth: "250px"
                },
                value: deleteInputValue,
                onChange: function(event) {
                    setDeleteInputValue(event.target.value);
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Button */.zx, {
                variantColor: "blue",
                ml: 2,
                disabled: submitting || deleteInputValue !== "DELETE",
                type: "submit",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                    defaultMessage: "Confirm",
                    id: "N2IrpM"
                })
            })
        ]
    });
};
var DeleteProfileMutation = function(param) {
    var user = param.user;
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
        onCompleted: function() {
            window.location.href = "/";
        },
        variables: {
            userId: user._id
        },
        mutation: DeleteProfile,
        onError: function() {
            alert(intl.formatMessage({
                defaultMessage: "Something went wrong. Please try again later!",
                id: "kyJap5"
            }));
        },
        children: function(deleteUser) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Form */.l0, {
                onSubmit: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _ctx.next = 2;
                                return deleteUser({
                                    variables: {
                                        userId: user._id
                                    }
                                });
                            case 2:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                })),
                children: function(param) {
                    var handleSubmit = param.handleSubmit, submitting = param.submitting;
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Form, {
                        onSubmit: handleSubmit,
                        children: [
                            user.__typename === "VendorUser" && user.showDeleteUserWarning && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                mt: 4,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Alert/* default */.Z, {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                        defaultMessage: "Deleting your account will also cancel your company's paid subscription.",
                                        id: "QTdZpL"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                                fontSize: "md",
                                fontWeight: 400,
                                mt: 4,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "To confirm that you want to permanently delete your account, type DELETE in the box",
                                    id: "O2BOO5"
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ConfirmDelete, {
                                submitting: submitting
                            })
                        ]
                    });
                }
            });
        }
    });
};
function DeleteMyAccountSection(param) {
    var user = param.user;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useToggle/* default */.Z)(false), 2), submitSectionVisible = ref[0], toggleSubmitSectionVisible = ref[1];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section, {
        "data-intercom-target": "Delete User",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                    defaultMessage: "Delete account",
                    id: "wyxJrL"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Text */.xv, {
                fontSize: [
                    "md",
                    "md",
                    "md"
                ],
                fontWeight: 400,
                mt: 4,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                    defaultMessage: "Deleting your account will permanently remove all data and information related to your current account. If you decide to later on create another account, it will be a brand new account.",
                    id: "QIQWXc"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Button */.zx, {
                variantColor: "red",
                mt: 4,
                css: {
                    backgroundColor: "#EB1501",
                    color: "#fff"
                },
                onClick: toggleSubmitSectionVisible,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                    defaultMessage: "Permanently Delete Account",
                    id: "0ukaON"
                })
            }),
            submitSectionVisible && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DeleteProfileMutation, {
                user: user
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@apollo+client@3.6.9_mnlteiidv5se4zpyvopwg4rohq/node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(81871);
;// CONCATENATED MODULE: ./lib/mutations/UpdateProfileEmailSubscription.ts

function UpdateProfileEmailSubscription_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  mutation UpdateProfileEmailSubscription($user: UserProfileSubscriptionInput!) {\n    updateProfileEmailSubscription(user: $user) {\n      ... on GovernmentUser {\n        newsletterFrequency\n        subscribedToNewsletter\n        subscribedToCampaign\n      }\n      ... on VendorUser {\n        newsletterFrequency\n        subscribedToNewsletter\n        subscribedToCampaign\n      }\n      ... on PendingUser {\n        newsletterFrequency\n        subscribedToNewsletter\n        subscribedToCampaign\n      }\n    }\n  }\n"
    ]);
    UpdateProfileEmailSubscription_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

/* harmony default export */ var UpdateProfileEmailSubscription = ((0,lib/* gql */.Ps)(UpdateProfileEmailSubscription_templateObject()));

;// CONCATENATED MODULE: ./components/user/settings/NewsletterFrequencyField.tsx







function NewsletterFrequencyField(param) {
    var subscribed = param.subscribed;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: {
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            width: "100%"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    fontSize: 20
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                    defaultMessage: "Personal Roundup",
                    id: "esGDoD"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    color: palette/* darkGray */.O5,
                    fontSize: 16,
                    marginBottom: 20
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                    defaultMessage: "A personalized email that includes recommended content based on your interests and the Collections you follow.",
                    id: "5rbvj2"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: {
                    display: "flex",
                    flexDirection: "row"
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: {
                            color: palette/* darkGray */.O5
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Frequency",
                            id: "vAW30j"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: {
                            marginLeft: 8
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Field */.gN, {
                            name: "newsletterFrequency",
                            type: "radio",
                            value: types/* INewsletterFrequency.Weekly */.O$.Weekly,
                            component: RadioboxField,
                            disabled: !subscribed,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "Weekly",
                                id: "/clOBU"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: {
                            marginLeft: 8
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Field */.gN, {
                            name: "newsletterFrequency",
                            type: "radio",
                            value: types/* INewsletterFrequency.Biweekly */.O$.Biweekly,
                            component: RadioboxField,
                            disabled: !subscribed,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "Biweekly",
                                id: "GZ66QA"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: {
                            marginLeft: 8
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Field */.gN, {
                            name: "newsletterFrequency",
                            type: "radio",
                            value: types/* INewsletterFrequency.Monthly */.O$.Monthly,
                            component: RadioboxField,
                            disabled: !subscribed,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "Monthly",
                                id: "wYsv4Z"
                            })
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/.pnpm/@swc+helpers@0.4.3/node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(87169);
;// CONCATENATED MODULE: ./components/user/settings/SubscribedToNewsletter.tsx






function SubscribedToNewsletter(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Field */.gN, {
        name: "subscribedToNewsletter",
        type: "checkbox",
        children: function(param) {
            var input = param.input;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    display: "flex",
                    alignItems: "flex-start",
                    margin: 4
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    css: {
                        width: "100%",
                        display: "flex",
                        alignItems: "center"
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SubscribedToNewsletter_Checkbox, (0,_object_spread/* default */.Z)({
                        id: "subscribeToNewsletter",
                        type: "checkbox"
                    }, props, input))
                })
            });
        }
    });
};
var SubscribedToNewsletter_Checkbox = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("input", {
    target: "e1b6nj030"
})({
    margin: "0 !important"
});

;// CONCATENATED MODULE: ./components/user/settings/SubscribedToCampaign.tsx







function SubscribedToCampaign() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        css: {
            display: "flex",
            flexDirection: "row",
            width: "100%"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                css: {
                    display: "flex",
                    flexDirection: "column",
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: {
                            fontSize: 20
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("label", {
                            htmlFor: "subscribedToCampaign",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                defaultMessage: "Govlaunch Updates",
                                id: "f7In8V"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: {
                            color: palette/* darkGray */.O5,
                            fontSize: 16
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                            defaultMessage: "Periodic product releases, company announcements and other fun stuff! \uD83C\uDF89",
                            id: "tMcH18"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Field */.gN, {
                name: "subscribedToCampaign",
                type: "checkbox",
                children: function(param) {
                    var input = param.input;
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        css: {
                            display: "flex",
                            alignItems: "flex-start",
                            margin: 4
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            css: {
                                width: "100%",
                                display: "flex",
                                alignItems: "center"
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SubscribedToNewsletter_Checkbox, (0,_object_spread/* default */.Z)({
                                id: "subscribedToCampaign",
                                type: "checkbox"
                            }, input))
                        })
                    });
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/user/settings/UserEmailSubscriptionSettings.tsx


















function UserEmailSubscriptionSettings(param) {
    var user = param.user;
    var divRef = (0,react.useRef)(null);
    var router = (0,next_router.useRouter)();
    var ref = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(UpdateProfileEmailSubscription), 1), updateProfileEmailSubscription = ref[0];
    (0,react.useEffect)(function() {
        if (router.query.from === "newsletter-unsubscribe" && divRef.current && typeof divRef.current.scrollIntoView === "function") {
            divRef.current.scrollIntoView({
                behavior: "auto"
            });
        }
    }, [
        router.query.from
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_final_form_es/* Form */.l0, {
            keepDirtyOnReinitialize: true,
            onSubmit: function() {
                var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _ctx.next = 2;
                                return updateProfileEmailSubscription({
                                    variables: {
                                        user: {
                                            userId: user._id,
                                            newsletterFrequency: data.newsletterFrequency,
                                            subscribedToNewsletter: data.subscribedToNewsletter,
                                            subscribedToCampaign: data.subscribedToCampaign
                                        }
                                    }
                                });
                            case 2:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }));
                return function(data) {
                    return _ref.apply(this, arguments);
                };
            }(),
            initialValues: {
                newsletterFrequency: user.newsletterFrequency || types/* INewsletterFrequency.Biweekly */.O$.Biweekly,
                subscribedToNewsletter: user.subscribedToNewsletter || false,
                subscribedToCampaign: user.subscribedToCampaign
            },
            children: function(param) {
                var handleSubmit = param.handleSubmit, submitting = param.submitting, values = param.values;
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Form, {
                    onSubmit: handleSubmit,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                        ref: divRef,
                        css: {
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                css: {
                                    borderBottom: "1px solid ".concat(palette/* lightestGray */.v2),
                                    display: "flex",
                                    flexDirection: "column",
                                    width: "100%"
                                },
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h2", {
                                        css: {
                                            fontSize: 20,
                                            margin: 0,
                                            color: palette/* darkGray */.O5,
                                            alignSelf: "flex-start"
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                            defaultMessage: "Newsletter Preferences",
                                            id: "SLtxEX"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                        css: {
                                            alignSelf: "flex-end",
                                            color: palette/* darkGray */.O5,
                                            fontSize: 16,
                                            margin: "0px 4px 4px 0px"
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("label", {
                                            htmlFor: "subscribeToNewsletter",
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                defaultMessage: "Get Updates",
                                                id: "fmob0k"
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                css: {
                                    borderBottom: "1px solid ".concat(palette/* lightestGray */.v2),
                                    display: "flex",
                                    flexDirection: "row",
                                    width: "100%",
                                    paddingTop: 16,
                                    paddingBottom: 16
                                },
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewsletterFrequencyField, {
                                        subscribed: values.subscribedToNewsletter
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SubscribedToNewsletter, {
                                        css: {
                                            alignSelf: "flex-end"
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                css: {
                                    borderBottom: "1px solid ".concat(palette/* lightestGray */.v2),
                                    display: "flex",
                                    flexDirection: "row",
                                    width: "100%",
                                    paddingTop: 16,
                                    paddingBottom: 16
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SubscribedToCampaign, {})
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Button */.zx, {
                                disabled: submitting,
                                type: "submit",
                                css: {
                                    minWidth: 120,
                                    marginTop: 16,
                                    alignSelf: "flex-start"
                                },
                                children: submitting ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                    ml: 2,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* LoadingIndicator */.TF, {})
                                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                    defaultMessage: "Update",
                                    id: "BWpuKl"
                                })
                            })
                        ]
                    })
                });
            }
        })
    });
};

;// CONCATENATED MODULE: ./components/user/UserProfileSettings.tsx







function UserProfileSettings(param) {
    var user = param.user;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                mt: 20,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(settings_MyDetailsSection, {
                    user: user
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                mt: 20,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UserEmailSubscriptionSettings, {
                    user: user
                })
            }),
            user.groups && user.groups.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                mt: 20,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(settings_MyGroupsSection, {
                    groups: user.groups,
                    primaryGroup: user.primaryGroup
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                mt: 20,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DeleteMyAccountSection, {
                    user: user
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/icons/AnonymousUser.tsx
var AnonymousUser = __webpack_require__(71985);
;// CONCATENATED MODULE: ./components/user/UsersBox.tsx














var UsersBox = function(param) {
    var title = param.title, users = param.users, dataIntercomTarget = param.dataIntercomTarget;
    var isTablet = (0,useIsTablet/* default */.Z)();
    var ref = (0,useShowMoreCounter/* default */.Z)(users.length, isTablet ? 3 : 8), offset = ref.offset, hasMore = ref.hasMore, showMore = ref.showMore;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
        "data-intercom-target": dataIntercomTarget,
        css: {
            backgroundColor: palette/* white */.ix,
            borderRadius: 5,
            border: "solid 1px ".concat(palette/* lightestGray */.v2)
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: {
                    padding: 15,
                    borderBottom: "solid 1px ".concat(palette/* lightestGray */.v2)
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h2", {
                    css: {
                        textTransform: "uppercase",
                        fontSize: 12,
                        color: palette/* darkGray */.O5,
                        letterSpacing: 0.5,
                        fontWeight: 500,
                        margin: 0
                    },
                    children: title
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Grid */.rj, {
                gutter: 15,
                children: chunk_default()(4, users.slice(0, offset)).map(function(row, index) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* RowWrap */.xv, {
                        mt: 15,
                        mb: 15,
                        css: {
                            justifyContent: row.length % 4 === 0 ? "center" : "flex-start"
                        },
                        children: row.map(function(user) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Col */.JX, {
                                width: 3 / 12,
                                style: {
                                    display: "flex",
                                    justifyContent: "center"
                                },
                                children: user.slug ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                    passHref: true,
                                    href: "/[userSlug]/[[...tab]]",
                                    as: "/@".concat(user.slug),
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                        css: {
                                            display: "inline-flex"
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tooltip/* default */.Z, {
                                            backgroundColor: palette/* innovatorBlue */.LD,
                                            borderColor: palette/* innovatorBlue */.LD,
                                            render: function() {
                                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                    css: {
                                                        padding: 10,
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        alignItems: "center",
                                                        color: palette/* white */.ix,
                                                        maxWidth: 200
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                            css: {
                                                                fontSize: 14,
                                                                fontWeight: 600
                                                            },
                                                            children: user.fullName || user.firstName
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                            css: {
                                                                fontSize: 12,
                                                                fontWeight: 400,
                                                                marginTop: 5
                                                            },
                                                            children: user.jobTitle
                                                        })
                                                    ]
                                                });
                                            },
                                            children: function(param) {
                                                var innerRef = param.innerRef, bind = param.bind;
                                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(profile_picture/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, bind), {
                                                    innerRef: innerRef,
                                                    size: 60,
                                                    image: user.avatar,
                                                    name: user.fullName
                                                }));
                                            }
                                        })
                                    })
                                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                    css: {
                                        display: "inline-flex"
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AnonymousUser/* default */.Z, {
                                        width: 60,
                                        height: 60
                                    })
                                })
                            }, user._id);
                        })
                    }, index);
                })
            }),
            hasMore && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UsersBox_ShowMore, {
                onClick: showMore
            })
        ]
    });
};
var UsersBox_ShowMore = function(props) {
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        role: "button",
        "aria-label": intl.formatMessage({
            defaultMessage: "Show more",
            id: "aWpBzj"
        }),
        css: {
            padding: 15,
            textTransform: "uppercase",
            color: palette/* sealBlue */.N9,
            fontSize: 12,
            textAlign: "center",
            cursor: "pointer",
            borderTop: "solid 1px ".concat(palette/* lightestGray */.v2),
            "&:hover": {
                color: palette/* darkGray */.O5
            }
        }
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
            defaultMessage: "Show more",
            id: "aWpBzj"
        })
    }));
};
/* harmony default export */ var user_UsersBox = (UsersBox);

;// CONCATENATED MODULE: ./components/user/utils/countUserBookmarks.ts
function countUserBookmarks(user) {
    return (user.savedProductsCount || 0) + (user.savedProjectsCount || 0) + (user.savedPostsCount || 0) + (user.savedStoriesCount || 0);
};

;// CONCATENATED MODULE: ./components/user/UserProfile.tsx

































function getDefaultTab(tab, user) {
    if (tab) {
        return Array.isArray(tab) ? tab[0] : tab;
    }
    if (user && user.__typename === "GovernmentUser") {
        return "posts";
    }
    if (user && (user.__typename === "PendingUser" || user.__typename === "VendorUser") && (user.storiesCount || 0) > 0) {
        return "stories";
    }
    if (user && user.__typename === "PendingUser" || user && user.__typename === "VendorUser" && (user.projectsCount || 0) === 0) {
        return "saved";
    }
    return "projects";
}
function UserProfile(param) {
    var user = param.user, router = param.router;
    var tab = router ? getDefaultTab(router.query.tab, user) : null;
    var subtab = router ? router.query.subtab : null;
    var isMobile = (0,useIsMobile/* default */.Z)();
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(spacings/* Margin */.Zt, {
        mb: 30,
        css: {
            width: "100%"
        },
        children: [
            !user.searchable && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((head_default()), {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                    name: "robots",
                    content: "noindex"
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core/* Grid */.rj, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(core/* RowWrap */.xv, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(core/* Col */.JX, {
                            width: [
                                1,
                                1,
                                1,
                                4 / 12
                            ],
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                    mt: 30,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                        "data-intercom-target": user.isSelfie ? "User Details" : null,
                                        css: {
                                            borderRadius: 5,
                                            backgroundColor: palette/* white */.ix,
                                            border: "solid 1px ".concat(palette/* lightestGray */.v2),
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            alignItems: "center"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                                mt: 16,
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                    css: {
                                                        position: "relative"
                                                    },
                                                    children: [
                                                        user.isSelfie ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
                                                            mutation: SetProfilePicture,
                                                            children: function(setPicture) {
                                                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ChangeableProfilePicture, {
                                                                    image: user.avatar,
                                                                    name: user.fullName,
                                                                    disruptor: user.__typename === "VendorUser" && user.isDisruptor || false,
                                                                    innovator: user.__typename === "GovernmentUser" && user.isInnovator || false,
                                                                    onChange: function(picture) {
                                                                        setPicture({
                                                                            variables: {
                                                                                userId: user._id,
                                                                                picture: picture
                                                                            },
                                                                            optimisticResponse: {
                                                                                __typename: "Mutation",
                                                                                setProfilePicture: {
                                                                                    __typename: user.__typename,
                                                                                    _id: user._id,
                                                                                    avatar: picture
                                                                                }
                                                                            }
                                                                        });
                                                                    }
                                                                });
                                                            }
                                                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(profile_picture/* default */.Z, {
                                                            image: user.avatar,
                                                            name: user.fullName,
                                                            size: 100,
                                                            css: {
                                                                zIndex: 2
                                                            },
                                                            innovator: user.__typename === "GovernmentUser" && user.isInnovator,
                                                            disruptor: user.__typename === "VendorUser" && user.isDisruptor || false
                                                        }),
                                                        user.__typename === "GovernmentUser" && user.isInnovator && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                            css: {
                                                                position: "absolute",
                                                                right: 5,
                                                                bottom: 5,
                                                                zIndex: 3
                                                            },
                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(InnovatorsIcon, {
                                                                height: 20,
                                                                width: 20
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                                mt: 18,
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("h1", {
                                                    css: {
                                                        fontSize: 24,
                                                        color: palette/* text */.fL,
                                                        margin: 0,
                                                        textAlign: "center",
                                                        padding: "0 15px",
                                                        wordBreak: "break-word"
                                                    },
                                                    children: user.fullName
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                                mt: 8,
                                                css: {
                                                    display: "flex"
                                                },
                                                children: user.__typename === "PendingUser" ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                    css: {
                                                        fontSize: 16,
                                                        color: palette/* darkGray */.O5,
                                                        margin: "0 auto",
                                                        fontWeight: "normal",
                                                        textAlign: "center",
                                                        padding: "0 16px",
                                                        display: "flex",
                                                        wordBreak: "break-word"
                                                    },
                                                    children: user.jobTitle
                                                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                                    css: {
                                                        fontSize: 16,
                                                        color: palette/* mediumGray */.rF,
                                                        margin: "0 auto",
                                                        wordBreak: "break-word",
                                                        fontWeight: "normal",
                                                        textAlign: "center",
                                                        padding: "0 16px"
                                                    },
                                                    children: [
                                                        user.__typename === "VendorUser" && user.company && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                            defaultMessage: "{jobTitle} at <company>{companyName}</company>",
                                                            id: "PYjq3P",
                                                            values: {
                                                                jobTitle: user.jobTitle,
                                                                companyName: user.company.name,
                                                                company: function(name) {
                                                                    if (user.__typename === "VendorUser" && user.company) {
                                                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                                                            href: "/vendors/[vendorSlug]",
                                                                            as: "/vendors/".concat(user.company.slug),
                                                                            passHref: true,
                                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("a", {
                                                                                css: {
                                                                                    color: palette/* mediumGray */.rF,
                                                                                    ":hover": {
                                                                                        textDecoration: "underline !important"
                                                                                    }
                                                                                },
                                                                                children: name
                                                                            })
                                                                        });
                                                                    }
                                                                    return null;
                                                                }
                                                            }
                                                        }),
                                                        " ",
                                                        user.__typename === "GovernmentUser" && user.government && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                                            href: "/governments/[governmentSlug]/[[...content]]",
                                                            as: "/governments/".concat(user.government.slug),
                                                            passHref: true,
                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                                css: {
                                                                    color: palette/* mediumGray */.rF,
                                                                    alignItems: "center",
                                                                    ":hover": {
                                                                        textDecoration: "underline !important"
                                                                    },
                                                                    cursor: "pointer"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                                        children: user.government.name
                                                                    }),
                                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Tooltip */.u, {
                                                                        maxWidth: "230px",
                                                                        textAlign: "center",
                                                                        "aria-label": user.government.name,
                                                                        label: user.government.city.countryName,
                                                                        bg: "blue.600",
                                                                        py: 2,
                                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* Box */.xu, {
                                                                            as: "span",
                                                                            display: "inline-block",
                                                                            ml: 2,
                                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(web/* CountryFlag */.AW, {
                                                                                countryCode: user.government.city.country,
                                                                                width: 25,
                                                                                height: 14
                                                                            })
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                                mt: user.isSelfie ? 0 : 16,
                                                mb: 16,
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                    css: {
                                                        display: "flex",
                                                        justifyContent: "center"
                                                    },
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FollowButton, {
                                                        user: user
                                                    })
                                                })
                                            }),
                                            user.__typename === "GovernmentUser" && user.government && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HorizontalLine/* default */.Z, {
                                                        color: palette/* lightestGray */.v2
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                        css: {
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            width: "100%",
                                                            padding: 16
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                                css: {
                                                                    textTransform: "uppercase",
                                                                    fontSize: 12,
                                                                    fontWeight: 500,
                                                                    color: palette/* darkGray */.O5
                                                                },
                                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                                    defaultMessage: "Government",
                                                                    id: "bh4rlK"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                                                mt: 8,
                                                                css: {
                                                                    display: "inline-flex"
                                                                },
                                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                                                    href: "/governments/[governmentSlug]/[[...content]]",
                                                                    as: "/governments/".concat(user.government.slug),
                                                                    passHref: true,
                                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
                                                                        css: {
                                                                            display: "inline-flex",
                                                                            alignItems: "center"
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(profile_picture/* default */.Z, {
                                                                                image: user.government.logo,
                                                                                name: user.government.name,
                                                                                size: 39
                                                                            }),
                                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                                                                ml: 8,
                                                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                                                    css: {
                                                                                        color: palette/* darkGray */.O5
                                                                                    },
                                                                                    children: user.government.name
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            user.__typename === "VendorUser" && user.company && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HorizontalLine/* default */.Z, {
                                                        color: palette/* lightestGray */.v2
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                        css: {
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            width: "100%",
                                                            padding: 16
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                                css: {
                                                                    textTransform: "uppercase",
                                                                    fontSize: 12,
                                                                    fontWeight: 500,
                                                                    color: palette/* darkGray */.O5
                                                                },
                                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                                    defaultMessage: "Company",
                                                                    id: "9YazHG"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                                                mt: 8,
                                                                css: {
                                                                    display: "inline-flex"
                                                                },
                                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                                                    href: "/vendors/[vendorSlug]",
                                                                    as: "/vendors/".concat(user.company.slug),
                                                                    passHref: true,
                                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
                                                                        css: {
                                                                            display: "inline-flex",
                                                                            alignItems: "center"
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(profile_picture/* default */.Z, {
                                                                                image: user.company.logo,
                                                                                name: user.company.name,
                                                                                size: 39
                                                                            }),
                                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                                                                ml: 8,
                                                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                                                    css: {
                                                                                        color: palette/* darkGray */.O5
                                                                                    },
                                                                                    children: user.company.name
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            user.groups.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HorizontalLine/* default */.Z, {
                                                        color: palette/* lightestGray */.v2
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                        css: {
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            width: "100%",
                                                            padding: 16
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                                                mb: 8,
                                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                                    css: {
                                                                        textTransform: "uppercase",
                                                                        fontSize: 12,
                                                                        fontWeight: 500,
                                                                        color: palette/* darkGray */.O5
                                                                    },
                                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(message/* default */.Z, {
                                                                        defaultMessage: "Groups",
                                                                        id: "hzmswI"
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                                css: {
                                                                    display: "grid",
                                                                    gridRowGap: 12
                                                                },
                                                                children: user.groups.map(function(group) {
                                                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                                        css: {
                                                                            display: "inline-flex"
                                                                        },
                                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                                                            passHref: true,
                                                                            href: "/groups/[groupSlug]",
                                                                            as: "/groups/".concat(group.slug),
                                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("a", {
                                                                                css: {
                                                                                    display: "inline-flex",
                                                                                    alignItems: "center"
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(profile_picture/* default */.Z, {
                                                                                        image: group.logo,
                                                                                        name: group.name,
                                                                                        size: 39
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                                                                        ml: 8,
                                                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                                                            css: {
                                                                                                color: palette/* darkGray */.O5
                                                                                            },
                                                                                            children: group.name
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    }, group._id);
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                isMobile && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                    mt: 16,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navbar, {
                                        user: user,
                                        tab: tab
                                    })
                                }),
                                user.__typename === "GovernmentUser" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                    mt: 20,
                                    children: user.isSelfie ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ResourcesForm/* ResourcesFormContextProvider */.Kf, {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Mutation/* Mutation */.m, {
                                            mutation: SetUserResources,
                                            children: function(setResources) {
                                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ResourcesForm/* default */.ZP, {
                                                    resources: user.resources,
                                                    dataIntercomTarget: user.isSelfie ? "User Resources" : null,
                                                    onAdd: function(resource) {
                                                        return setResources({
                                                            variables: {
                                                                resources: [
                                                                    resource
                                                                ].concat((0,_to_consumable_array/* default */.Z)(user.resources)).map(function(resource) {
                                                                    return {
                                                                        type: resource.type || "",
                                                                        title: resource.title || "",
                                                                        url: resource.url || null,
                                                                        addedAt: resource.addedAt,
                                                                        filename: resource.filename || null,
                                                                        body: resource.body || null
                                                                    };
                                                                })
                                                            }
                                                        });
                                                    },
                                                    onRemove: function(removedResource) {
                                                        return setResources({
                                                            variables: {
                                                                resources: user.resources.filter(function(resource) {
                                                                    return removedResource !== resource;
                                                                }).map(function(resource) {
                                                                    return {
                                                                        type: resource.type || "",
                                                                        title: resource.title || "",
                                                                        url: resource.url || null,
                                                                        addedAt: resource.addedAt,
                                                                        filename: resource.filename || null,
                                                                        body: resource.body || null
                                                                    };
                                                                })
                                                            }
                                                        });
                                                    }
                                                });
                                            }
                                        })
                                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Resources/* default */.Z, {
                                        titleColor: palette/* darkGray */.O5,
                                        resources: user.resources
                                    })
                                }),
                                user.following.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                    mt: 20,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Following, {
                                        user: user
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Query/* Query */.A, {
                                    query: RecentlyJoinedGovernments,
                                    children: function(param) {
                                        var data = param.data;
                                        if (!data || !data.recentlyJoinedGovernments) {
                                            return null;
                                        }
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                            mt: 20,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GovernmentsBox, {
                                                title: intl.formatMessage({
                                                    defaultMessage: "Recently Joined",
                                                    id: "17qYnl"
                                                }),
                                                governments: data.recentlyJoinedGovernments,
                                                "data-intercom-target": user.isSelfie ? "Recently Joined Governments" : null
                                            })
                                        });
                                    }
                                }),
                                user.__typename === "GovernmentUser" && user.government && user.government.members && user.government.members.length > 1 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                    mt: 20,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(user_UsersBox, {
                                        dataIntercomTarget: user.isSelfie ? "User From" : null,
                                        title: intl.formatMessage({
                                            defaultMessage: "From {governmentName}",
                                            id: "r9xwVF"
                                        }, {
                                            governmentName: user.government.name
                                        }),
                                        users: user.government.members.filter(function(member) {
                                            return member._id !== user._id;
                                        })
                                    })
                                }),
                                user.__typename === "VendorUser" && user.company && user.company.members && user.company.members.length > 1 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                    mt: 20,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(user_UsersBox, {
                                        dataIntercomTarget: user.isSelfie ? "User From" : null,
                                        title: intl.formatMessage({
                                            defaultMessage: "From {companyName}",
                                            id: "w5263M"
                                        }, {
                                            companyName: user.company.name
                                        }),
                                        users: user.company.members.filter(function(member) {
                                            return member._id !== user._id;
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(core/* Col */.JX, {
                            width: [
                                1,
                                1,
                                1,
                                8 / 12
                            ],
                            children: [
                                !isMobile && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                    mt: 30,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Navbar, {
                                        user: user,
                                        tab: tab
                                    })
                                }),
                                tab === "posts" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                    children: [
                                        user.__typename === "GovernmentUser" && user.government && user.isSelfie && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                            mt: 20,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WriteContentBox/* default */.Z, {
                                                user: user,
                                                context: "user",
                                                dataIntercomTarget: "User Write Content Box"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PostsTab, {
                                            user: user
                                        })
                                    ]
                                }),
                                tab === "stories" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StoriesTab, {
                                    user: user
                                }),
                                tab === "saved" && user.isSelfie && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SavedTab, {
                                    user: user,
                                    subtab: subtab
                                }),
                                tab === "projects" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProjectsTab, {
                                    user: user
                                }),
                                user.__typename === "GovernmentUser" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(sharing_SharingSettingsModal, {
                                    user: user,
                                    isOpen: Boolean(router && router.query.sharing && user.isSelfie),
                                    onRequestClose: function() {
                                        return router.push("/[userSlug]/[[...tab]]", "/@".concat(user.slug, "/settings"));
                                    }
                                }),
                                user.isSelfie && tab === "settings" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                    children: [
                                        user.__typename === "GovernmentUser" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spacings/* Margin */.Zt, {
                                            mt: 20,
                                            mb: 20,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(sharing_SharingBox, {
                                                user: user,
                                                tab: tab
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UserProfileSettings, {
                                            user: user
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
function Navbar(param) {
    var user = param.user, tab = param.tab;
    var isMobile = (0,useIsMobile/* default */.Z)();
    var intl = (0,useIntl/* default */.Z)();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ProfileNavbar/* default */.Z, {
        children: [
            user.__typename === "GovernmentUser" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewLinkTab/* default */.Z, {
                href: "/[userSlug]/[[...tab]]",
                as: "/@".concat(user.slug),
                title: intl.formatMessage({
                    defaultMessage: "Activity",
                    id: "ZmlNQ3"
                }),
                count: user.postsCount,
                active: tab === "posts",
                dataIntercomTarget: user.isSelfie ? "User Activity Tab" : null
            }),
            (user.storiesCount || 0) > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewLinkTab/* default */.Z, {
                href: "/[userSlug]/[[...tab]]?tab=stories",
                as: "/@".concat(user.slug, "/stories"),
                title: intl.formatMessage({
                    defaultMessage: "Stories",
                    id: "Ldxym4"
                }),
                count: user.storiesCount,
                active: tab === "stories",
                dataIntercomTarget: user.isSelfie ? "User Stories Tab" : null
            }),
            user.__typename !== "PendingUser" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewLinkTab/* default */.Z, {
                href: "/[userSlug]/[[...tab]]?tab=projects",
                as: "/@".concat(user.slug, "/projects"),
                title: intl.formatMessage({
                    defaultMessage: "Projects",
                    id: "UxTJRa"
                }),
                count: user.projectsCount,
                active: tab === "projects",
                dataIntercomTarget: user.isSelfie ? "User Projects Tab" : null
            }),
            user.isSelfie && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewLinkTab/* default */.Z, {
                href: "/[userSlug]/[[...tab]]?tab=saved",
                as: "/@".concat(user.slug, "/saved"),
                title: intl.formatMessage({
                    defaultMessage: "Saved",
                    id: "fsB/4p"
                }),
                count: countUserBookmarks(user),
                active: tab === "saved",
                dataIntercomTarget: user.isSelfie ? "User Saved Tab" : null
            }),
            user.isSelfie && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                css: isMobile ? {
                    marginTop: 8
                } : {
                    marginLeft: "auto",
                    height: "100%",
                    padding: "0 20px",
                    borderLeft: "1px solid ".concat(palette/* lightestGray */.v2),
                    display: "flex",
                    alignItems: "center"
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewLinkTab/* default */.Z, {
                    href: "/[userSlug]/[[...tab]]?tab=settings",
                    as: "/@".concat(user.slug, "/settings"),
                    title: intl.formatMessage({
                        defaultMessage: "Settings",
                        id: "D3idYv"
                    }),
                    active: tab === "settings",
                    dataIntercomTarget: user.isSelfie ? "User Settings Tab" : null
                })
            })
        ]
    });
}
/* harmony default export */ var user_UserProfile = ((0,next_router.withRouter)(UserProfile));

// EXTERNAL MODULE: ./lib/queries/ProfileQuery.ts + 1 modules
var ProfileQuery = __webpack_require__(44982);
// EXTERNAL MODULE: ./lib/route/Redirect.tsx
var Redirect = __webpack_require__(47116);
// EXTERNAL MODULE: ./lib/utils/safeGetQueryParameter.ts
var safeGetQueryParameter = __webpack_require__(35909);
// EXTERNAL MODULE: ./src/components/navbar/NavbarLayout.tsx + 62 modules
var NavbarLayout = __webpack_require__(71858);
;// CONCATENATED MODULE: ./pages/[userSlug]/[[...tab]].tsx













var User = function(param) {
    var slug = param.slug;
    var user = (0,Auth/* useSelfie */.yD)();
    var router = (0,next_router.useRouter)();
    var queryTab = constructQueryTab(router.query.tab, router.query.sharing);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavbarLayout/* default */.Z, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Query/* Query */.A, {
            query: ProfileQuery/* default */.Z,
            variables: {
                slug: slug
            },
            children: function(param) {
                var data = param.data, loading = param.loading;
                if (!data || loading || !data.user) {
                    return null;
                }
                if (!user) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UserPageSeo, {
                                user: data.user,
                                tab: queryTab
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GatedContent/* default */.Z, {
                                hardRefreshAfterSignin: true,
                                image: "/static/gating/government-user-desktop.png"
                            })
                        ]
                    });
                }
                // When no slug is returned it means that the logged user can't see the profile
                if (!data.user.slug) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Redirect/* default */.Z, {
                        to: "/"
                    });
                }
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UserPageSeo, {
                            user: data.user,
                            tab: queryTab
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(user_UserProfile, {
                            user: data.user
                        })
                    ]
                });
            }
        })
    });
};
User.getInitialProps = function(param) {
    var query = param.query;
    var slug = (0,safeGetQueryParameter/* default */.Z)(query, "userSlug");
    return {
        slug: slug.startsWith("@") ? slug.replace("@", "") : slug
    };
};
function constructQueryTab(tab, sharing) {
    if ((typeof sharing === "undefined" ? "undefined" : (0,_type_of/* default */.Z)(sharing)) !== undefined && sharing) {
        return "sharing";
    }
    var queryTab = Array.isArray(tab) ? tab[0] : tab;
    return queryTab || "";
}
/* harmony default export */ var _tab_ = (User);


/***/ }),

/***/ 70455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ProjectCards; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(93712);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(18316);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(82789);
/* harmony import */ var _govlaunch_project__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78062);
/* harmony import */ var _govlaunch_web__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19026);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54892);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22051);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59496);
/* harmony import */ var _components_project_EmptyProjectSlot__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33563);
/* harmony import */ var _src_utils_nextLinkHref__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(88196);
/* harmony import */ var _src_utils_stringOrFirst__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(39327);
/* harmony import */ var _src_components_project_CreateProjectModal__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(23115);
/* harmony import */ var _src_components_project_modal_ProjectModal__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96077);
/* harmony import */ var _src_components_project_listing_computeNavigationProps__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(36668);
/* harmony import */ var lodash_fp_noop__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(98483);
/* harmony import */ var lodash_fp_noop__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(lodash_fp_noop__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _lib_hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(67459);
/* harmony import */ var _lib_withIntl__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(21505);
/* harmony import */ var _src_components_translation_TranslationButton__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(98769);


















function ProjectCards(param) {
    var projects = param.projects, gridProps = param.gridProps, _onClick = param.onClick, onClick = _onClick === void 0 ? (lodash_fp_noop__WEBPACK_IMPORTED_MODULE_9___default()) : _onClick, _withAddProjectSlot = param.withAddProjectSlot, withAddProjectSlot = _withAddProjectSlot === void 0 ? false : _withAddProjectSlot, addProjectSlotText = param.addProjectSlotText, firstLocationId = param.firstLocationId, firstLocationCountry = param.firstLocationCountry, groupId = param.groupId, projectNavigationLimit = param.projectNavigationLimit, onModalClose = param.onModalClose, _routeParams = param.routeParams, routeParams = _routeParams === void 0 ? {} : _routeParams;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var isMobile = (0,_lib_hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), showCreateProjectModal = ref[0], setShowCreateProjectModal = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(null), relatedProject = ref1[0], setRelatedProject = ref1[1];
    var locale = (0,_lib_withIntl__WEBPACK_IMPORTED_MODULE_11__/* .useIntlLocale */ .U)().locale;
    var projectSlugFromRouter = router.query.projectSlug;
    var langFromRouter = router.query.lang;
    var slugExistsOnProjects = projects.some(function(project) {
        return project.slug === projectSlugFromRouter;
    }) || relatedProject;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_src_components_project_CreateProjectModal__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                isOpen: showCreateProjectModal,
                onClose: function() {
                    return setShowCreateProjectModal(false);
                },
                groupId: groupId
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsxs */ .BX)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_1__/* .PageGridContainer */ .pf, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({
                px: 0
            }, gridProps), {
                children: [
                    withAddProjectSlot && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_components_project_EmptyProjectSlot__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        onClick: function() {
                            return setShowCreateProjectModal(true);
                        },
                        groupId: groupId,
                        text: addProjectSlotText
                    }),
                    projects.map(function(project, index) {
                        var linkHref = isMobile ? "/projects/".concat(project.slug) : (0,_src_utils_nextLinkHref__WEBPACK_IMPORTED_MODULE_6__/* .appendNextLinkHrefParams */ .o)(router, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({
                            projectSlug: project.slug
                        }, routeParams));
                        var translationLinkHref = isMobile ? "/projects/[projectSlug]" : (0,_src_utils_nextLinkHref__WEBPACK_IMPORTED_MODULE_6__/* .appendNextLinkHrefParams */ .o)(router, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({
                            projectSlug: project.slug,
                            lang: locale
                        }, routeParams));
                        var translationLinkWrap = function() {
                            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_src_components_translation_TranslationButton__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                paddingY: "4px",
                                onClick: function(event) {
                                    event.preventDefault();
                                    event.stopPropagation();
                                    router.push(translationLinkHref, "/projects/".concat(project.slug, "?lang=").concat(locale));
                                }
                            });
                        };
                        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            href: linkHref,
                            as: "/projects/".concat(project.slug),
                            passHref: true,
                            scroll: false,
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_govlaunch_project__WEBPACK_IMPORTED_MODULE_0__/* .ProjectCard */ .t, {
                                "data-intercom-target": index === 0 ? "First project" : undefined,
                                project: project,
                                onClick: function(event) {
                                    return onClick(event, project, index);
                                },
                                firstLocationId: firstLocationId,
                                firstLocationCountry: firstLocationCountry,
                                translationLinkWrap: locale !== "en-US" ? translationLinkWrap : undefined
                            })
                        }, project._id);
                    })
                ]
            })),
            projectSlugFromRouter && slugExistsOnProjects && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_src_components_project_modal_ProjectModal__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                onClickProject: function(project) {
                    setRelatedProject(project);
                },
                projectSlug: (0,_src_utils_stringOrFirst__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(projectSlugFromRouter),
                navigation: (0,_src_components_project_listing_computeNavigationProps__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(projects.slice(0, projectNavigationLimit), (0,_src_utils_stringOrFirst__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(projectSlugFromRouter)),
                onClose: onModalClose,
                lang: (0,_src_utils_stringOrFirst__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(langFromRouter)
            })
        ]
    });
};


/***/ }),

/***/ 93921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ProjectsListing; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82789);
/* harmony import */ var _govlaunch_web__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19026);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59496);
/* harmony import */ var _components_form_resources_ShowMoreButtonWithIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38248);
/* harmony import */ var _src_shared_components_NoResultsFound__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(57600);
/* harmony import */ var _src_components_project_listing_ProjectCards__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70455);






function ProjectsListing(param) {
    var projects = param.projects, loading = param.loading, onLoadMore = param.onLoadMore, hasNextPage = param.hasNextPage, onModalClose = param.onModalClose, _gridProps = param.gridProps, gridProps = _gridProps === void 0 ? {
        columns: [
            1,
            1,
            2,
            3
        ],
        spacingY: 6
    } : _gridProps, _withAddProjectSlot = param.withAddProjectSlot, withAddProjectSlot = _withAddProjectSlot === void 0 ? false : _withAddProjectSlot, addProjectSlotText = param.addProjectSlotText, groupId = param.groupId, onClickProject = param.onClickProject, _projectNavigationLimit = param.projectNavigationLimit, projectNavigationLimit = _projectNavigationLimit === void 0 ? Infinity : _projectNavigationLimit, firstLocationId = param.firstLocationId, firstLocationCountry = param.firstLocationCountry;
    if (!loading && projects.length === 0) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_0__/* .PageContainer */ ._z, {
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_src_shared_components_NoResultsFound__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                mt: 32
            })
        });
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_src_components_project_listing_ProjectCards__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                projects: projects,
                gridProps: gridProps,
                withAddProjectSlot: withAddProjectSlot,
                addProjectSlotText: addProjectSlotText,
                groupId: groupId,
                onClick: onClickProject,
                firstLocationId: firstLocationId,
                firstLocationCountry: firstLocationCountry,
                projectNavigationLimit: projectNavigationLimit,
                onModalClose: onModalClose
            }),
            hasNextPage && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_govlaunch_web__WEBPACK_IMPORTED_MODULE_0__/* .Flex */ .kC, {
                justifyContent: "center",
                mt: 6,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_components_form_resources_ShowMoreButtonWithIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    loading: loading || false,
                    onClick: function() {
                        if (typeof onLoadMore !== "undefined") {
                            onLoadMore();
                        }
                    }
                })
            })
        ]
    });
};


/***/ }),

/***/ 25655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "od": function() { return /* binding */ COUNTRIES; },
/* harmony export */   "u5": function() { return /* binding */ findCountryNameByCode; }
/* harmony export */ });
var COUNTRIES = [
    {
        code: "AF",
        name: "Afghanistan"
    },
    {
        code: "AX",
        name: "\xc5land Islands"
    },
    {
        code: "AL",
        name: "Albania"
    },
    {
        code: "DZ",
        name: "Algeria"
    },
    {
        code: "AS",
        name: "American Samoa"
    },
    {
        code: "AD",
        name: "Andorra"
    },
    {
        code: "AO",
        name: "Angola"
    },
    {
        code: "AI",
        name: "Anguilla"
    },
    {
        code: "AQ",
        name: "Antarctica"
    },
    {
        code: "AG",
        name: "Antigua and Barbuda"
    },
    {
        code: "AR",
        name: "Argentina"
    },
    {
        code: "AM",
        name: "Armenia"
    },
    {
        code: "AW",
        name: "Aruba"
    },
    {
        code: "AU",
        name: "Australia"
    },
    {
        code: "AT",
        name: "Austria"
    },
    {
        code: "AZ",
        name: "Azerbaijan"
    },
    {
        code: "BS",
        name: "Bahamas"
    },
    {
        code: "BH",
        name: "Bahrain"
    },
    {
        code: "BD",
        name: "Bangladesh"
    },
    {
        code: "BB",
        name: "Barbados"
    },
    {
        code: "BY",
        name: "Belarus"
    },
    {
        code: "BE",
        name: "Belgium"
    },
    {
        code: "BZ",
        name: "Belize"
    },
    {
        code: "BJ",
        name: "Benin"
    },
    {
        code: "BM",
        name: "Bermuda"
    },
    {
        code: "BT",
        name: "Bhutan"
    },
    {
        code: "BO",
        name: "Bolivia, Plurinational State of"
    },
    {
        code: "BQ",
        name: "Bonaire, Sint Eustatius and Saba"
    },
    {
        code: "BA",
        name: "Bosnia and Herzegovina"
    },
    {
        code: "BW",
        name: "Botswana"
    },
    {
        code: "BV",
        name: "Bouvet Island"
    },
    {
        code: "BR",
        name: "Brazil"
    },
    {
        code: "IO",
        name: "British Indian Ocean Territory"
    },
    {
        code: "BN",
        name: "Brunei Darussalam"
    },
    {
        code: "BG",
        name: "Bulgaria"
    },
    {
        code: "BF",
        name: "Burkina Faso"
    },
    {
        code: "BI",
        name: "Burundi"
    },
    {
        code: "KH",
        name: "Cambodia"
    },
    {
        code: "CM",
        name: "Cameroon"
    },
    {
        code: "CA",
        name: "Canada"
    },
    {
        code: "CV",
        name: "Cape Verde"
    },
    {
        code: "KY",
        name: "Cayman Islands"
    },
    {
        code: "CF",
        name: "Central African Republic"
    },
    {
        code: "TD",
        name: "Chad"
    },
    {
        code: "CL",
        name: "Chile"
    },
    {
        code: "CN",
        name: "China"
    },
    {
        code: "CX",
        name: "Christmas Island"
    },
    {
        code: "CC",
        name: "Cocos (Keeling) Islands"
    },
    {
        code: "CO",
        name: "Colombia"
    },
    {
        code: "KM",
        name: "Comoros"
    },
    {
        code: "CG",
        name: "Congo"
    },
    {
        code: "CD",
        name: "Congo, the Democratic Republic of the"
    },
    {
        code: "CK",
        name: "Cook Islands"
    },
    {
        code: "CR",
        name: "Costa Rica"
    },
    {
        code: "CI",
        name: "C\xf4te d'Ivoire"
    },
    {
        code: "HR",
        name: "Croatia"
    },
    {
        code: "CU",
        name: "Cuba"
    },
    {
        code: "CW",
        name: "Cura\xe7ao"
    },
    {
        code: "CY",
        name: "Cyprus"
    },
    {
        code: "CZ",
        name: "Czech Republic"
    },
    {
        code: "DK",
        name: "Denmark"
    },
    {
        code: "DJ",
        name: "Djibouti"
    },
    {
        code: "DM",
        name: "Dominica"
    },
    {
        code: "DO",
        name: "Dominican Republic"
    },
    {
        code: "EC",
        name: "Ecuador"
    },
    {
        code: "EG",
        name: "Egypt"
    },
    {
        code: "SV",
        name: "El Salvador"
    },
    {
        code: "GQ",
        name: "Equatorial Guinea"
    },
    {
        code: "ER",
        name: "Eritrea"
    },
    {
        code: "EE",
        name: "Estonia"
    },
    {
        code: "ET",
        name: "Ethiopia"
    },
    {
        code: "FK",
        name: "Falkland Islands (Malvinas)"
    },
    {
        code: "FO",
        name: "Faroe Islands"
    },
    {
        code: "FJ",
        name: "Fiji"
    },
    {
        code: "FI",
        name: "Finland"
    },
    {
        code: "FR",
        name: "France"
    },
    {
        code: "GF",
        name: "French Guiana"
    },
    {
        code: "PF",
        name: "French Polynesia"
    },
    {
        code: "TF",
        name: "French Southern Territories"
    },
    {
        code: "GA",
        name: "Gabon"
    },
    {
        code: "GM",
        name: "Gambia"
    },
    {
        code: "GE",
        name: "Georgia"
    },
    {
        code: "DE",
        name: "Germany"
    },
    {
        code: "GH",
        name: "Ghana"
    },
    {
        code: "GI",
        name: "Gibraltar"
    },
    {
        code: "GR",
        name: "Greece"
    },
    {
        code: "GL",
        name: "Greenland"
    },
    {
        code: "GD",
        name: "Grenada"
    },
    {
        code: "GP",
        name: "Guadeloupe"
    },
    {
        code: "GU",
        name: "Guam"
    },
    {
        code: "GT",
        name: "Guatemala"
    },
    {
        code: "GG",
        name: "Guernsey"
    },
    {
        code: "GN",
        name: "Guinea"
    },
    {
        code: "GW",
        name: "Guinea-Bissau"
    },
    {
        code: "GY",
        name: "Guyana"
    },
    {
        code: "HT",
        name: "Haiti"
    },
    {
        code: "HM",
        name: "Heard Island and McDonald Islands"
    },
    {
        code: "VA",
        name: "Holy See (Vatican City State)"
    },
    {
        code: "HN",
        name: "Honduras"
    },
    {
        code: "HK",
        name: "Hong Kong"
    },
    {
        code: "HU",
        name: "Hungary"
    },
    {
        code: "IS",
        name: "Iceland"
    },
    {
        code: "IN",
        name: "India"
    },
    {
        code: "ID",
        name: "Indonesia"
    },
    {
        code: "IR",
        name: "Iran, Islamic Republic of"
    },
    {
        code: "IQ",
        name: "Iraq"
    },
    {
        code: "IE",
        name: "Ireland"
    },
    {
        code: "IM",
        name: "Isle of Man"
    },
    {
        code: "IL",
        name: "Israel"
    },
    {
        code: "IT",
        name: "Italy"
    },
    {
        code: "JM",
        name: "Jamaica"
    },
    {
        code: "JP",
        name: "Japan"
    },
    {
        code: "JE",
        name: "Jersey"
    },
    {
        code: "JO",
        name: "Jordan"
    },
    {
        code: "KZ",
        name: "Kazakhstan"
    },
    {
        code: "KE",
        name: "Kenya"
    },
    {
        code: "KI",
        name: "Kiribati"
    },
    {
        code: "KP",
        name: "Korea, Democratic People's Republic of"
    },
    {
        code: "KR",
        name: "Korea, Republic of"
    },
    {
        code: "KW",
        name: "Kuwait"
    },
    {
        code: "KG",
        name: "Kyrgyzstan"
    },
    {
        code: "LA",
        name: "Lao People's Democratic Republic"
    },
    {
        code: "LV",
        name: "Latvia"
    },
    {
        code: "LB",
        name: "Lebanon"
    },
    {
        code: "LS",
        name: "Lesotho"
    },
    {
        code: "LR",
        name: "Liberia"
    },
    {
        code: "LY",
        name: "Libya"
    },
    {
        code: "LI",
        name: "Liechtenstein"
    },
    {
        code: "LT",
        name: "Lithuania"
    },
    {
        code: "LU",
        name: "Luxembourg"
    },
    {
        code: "MO",
        name: "Macao"
    },
    {
        code: "MK",
        name: "Macedonia, the Former Yugoslav Republic of"
    },
    {
        code: "MG",
        name: "Madagascar"
    },
    {
        code: "MW",
        name: "Malawi"
    },
    {
        code: "MY",
        name: "Malaysia"
    },
    {
        code: "MV",
        name: "Maldives"
    },
    {
        code: "ML",
        name: "Mali"
    },
    {
        code: "MT",
        name: "Malta"
    },
    {
        code: "MH",
        name: "Marshall Islands"
    },
    {
        code: "MQ",
        name: "Martinique"
    },
    {
        code: "MR",
        name: "Mauritania"
    },
    {
        code: "MU",
        name: "Mauritius"
    },
    {
        code: "YT",
        name: "Mayotte"
    },
    {
        code: "MX",
        name: "Mexico"
    },
    {
        code: "FM",
        name: "Micronesia, Federated States of"
    },
    {
        code: "MD",
        name: "Moldova, Republic of"
    },
    {
        code: "MC",
        name: "Monaco"
    },
    {
        code: "MN",
        name: "Mongolia"
    },
    {
        code: "ME",
        name: "Montenegro"
    },
    {
        code: "MS",
        name: "Montserrat"
    },
    {
        code: "MA",
        name: "Morocco"
    },
    {
        code: "MZ",
        name: "Mozambique"
    },
    {
        code: "MM",
        name: "Myanmar"
    },
    {
        code: "NA",
        name: "Namibia"
    },
    {
        code: "NR",
        name: "Nauru"
    },
    {
        code: "NP",
        name: "Nepal"
    },
    {
        code: "NL",
        name: "Netherlands"
    },
    {
        code: "NC",
        name: "New Caledonia"
    },
    {
        code: "NZ",
        name: "New Zealand"
    },
    {
        code: "NI",
        name: "Nicaragua"
    },
    {
        code: "NE",
        name: "Niger"
    },
    {
        code: "NG",
        name: "Nigeria"
    },
    {
        code: "NU",
        name: "Niue"
    },
    {
        code: "NF",
        name: "Norfolk Island"
    },
    {
        code: "MP",
        name: "Northern Mariana Islands"
    },
    {
        code: "NO",
        name: "Norway"
    },
    {
        code: "OM",
        name: "Oman"
    },
    {
        code: "PK",
        name: "Pakistan"
    },
    {
        code: "PW",
        name: "Palau"
    },
    {
        code: "PS",
        name: "Palestine, State of"
    },
    {
        code: "PA",
        name: "Panama"
    },
    {
        code: "PG",
        name: "Papua New Guinea"
    },
    {
        code: "PY",
        name: "Paraguay"
    },
    {
        code: "PE",
        name: "Peru"
    },
    {
        code: "PH",
        name: "Philippines"
    },
    {
        code: "PN",
        name: "Pitcairn"
    },
    {
        code: "PL",
        name: "Poland"
    },
    {
        code: "PT",
        name: "Portugal"
    },
    {
        code: "PR",
        name: "Puerto Rico"
    },
    {
        code: "QA",
        name: "Qatar"
    },
    {
        code: "RE",
        name: "R\xe9union"
    },
    {
        code: "RO",
        name: "Romania"
    },
    {
        code: "RU",
        name: "Russian Federation"
    },
    {
        code: "RW",
        name: "Rwanda"
    },
    {
        code: "BL",
        name: "Saint Barth\xe9lemy"
    },
    {
        code: "SH",
        name: "Saint Helena, Ascension and Tristan da Cunha"
    },
    {
        code: "KN",
        name: "Saint Kitts and Nevis"
    },
    {
        code: "LC",
        name: "Saint Lucia"
    },
    {
        code: "MF",
        name: "Saint Martin (French part)"
    },
    {
        code: "PM",
        name: "Saint Pierre and Miquelon"
    },
    {
        code: "VC",
        name: "Saint Vincent and the Grenadines"
    },
    {
        code: "WS",
        name: "Samoa"
    },
    {
        code: "SM",
        name: "San Marino"
    },
    {
        code: "ST",
        name: "Sao Tome and Principe"
    },
    {
        code: "SA",
        name: "Saudi Arabia"
    },
    {
        code: "SN",
        name: "Senegal"
    },
    {
        code: "RS",
        name: "Serbia"
    },
    {
        code: "SC",
        name: "Seychelles"
    },
    {
        code: "SL",
        name: "Sierra Leone"
    },
    {
        code: "SG",
        name: "Singapore"
    },
    {
        code: "SX",
        name: "Sint Maarten (Dutch part)"
    },
    {
        code: "SK",
        name: "Slovakia"
    },
    {
        code: "SI",
        name: "Slovenia"
    },
    {
        code: "SB",
        name: "Solomon Islands"
    },
    {
        code: "SO",
        name: "Somalia"
    },
    {
        code: "ZA",
        name: "South Africa"
    },
    {
        code: "GS",
        name: "South Georgia and the South Sandwich Islands"
    },
    {
        code: "SS",
        name: "South Sudan"
    },
    {
        code: "ES",
        name: "Spain"
    },
    {
        code: "LK",
        name: "Sri Lanka"
    },
    {
        code: "SD",
        name: "Sudan"
    },
    {
        code: "SR",
        name: "Suriname"
    },
    {
        code: "SJ",
        name: "Svalbard and Jan Mayen"
    },
    {
        code: "SZ",
        name: "Swaziland"
    },
    {
        code: "SE",
        name: "Sweden"
    },
    {
        code: "CH",
        name: "Switzerland"
    },
    {
        code: "SY",
        name: "Syrian Arab Republic"
    },
    {
        code: "TW",
        name: "Taiwan, Province of China"
    },
    {
        code: "TJ",
        name: "Tajikistan"
    },
    {
        code: "TZ",
        name: "Tanzania, United Republic of"
    },
    {
        code: "TH",
        name: "Thailand"
    },
    {
        code: "TL",
        name: "Timor-Leste"
    },
    {
        code: "TG",
        name: "Togo"
    },
    {
        code: "TK",
        name: "Tokelau"
    },
    {
        code: "TO",
        name: "Tonga"
    },
    {
        code: "TT",
        name: "Trinidad and Tobago"
    },
    {
        code: "TN",
        name: "Tunisia"
    },
    {
        code: "TR",
        name: "Turkey"
    },
    {
        code: "TM",
        name: "Turkmenistan"
    },
    {
        code: "TC",
        name: "Turks and Caicos Islands"
    },
    {
        code: "TV",
        name: "Tuvalu"
    },
    {
        code: "UG",
        name: "Uganda"
    },
    {
        code: "UA",
        name: "Ukraine"
    },
    {
        code: "AE",
        name: "United Arab Emirates"
    },
    {
        code: "GB",
        name: "United Kingdom"
    },
    {
        code: "US",
        name: "United States"
    },
    {
        code: "UM",
        name: "United States Minor Outlying Islands"
    },
    {
        code: "UY",
        name: "Uruguay"
    },
    {
        code: "UZ",
        name: "Uzbekistan"
    },
    {
        code: "VU",
        name: "Vanuatu"
    },
    {
        code: "VE",
        name: "Venezuela, Bolivarian Republic of"
    },
    {
        code: "VN",
        name: "Viet Nam"
    },
    {
        code: "VG",
        name: "Virgin Islands, British"
    },
    {
        code: "VI",
        name: "Virgin Islands, U.S."
    },
    {
        code: "WF",
        name: "Wallis and Futuna"
    },
    {
        code: "EH",
        name: "Western Sahara"
    },
    {
        code: "YE",
        name: "Yemen"
    },
    {
        code: "ZM",
        name: "Zambia"
    },
    {
        code: "ZW",
        name: "Zimbabwe"
    }, 
];
function findCountryNameByCode(isoCode) {
    var ref;
    return ((ref = COUNTRIES.find(function(country) {
        return country.code === isoCode;
    })) === null || ref === void 0 ? void 0 : ref.name) || null;
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (COUNTRIES)));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3481,5522,2727,1386,3685,916,4293,9932,504,5017,4185,2670,9158,890,1249,5676,9774,2888,179], function() { return __webpack_exec__(81245); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);